/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Long: { input: any; output: any; }
  TimeSpan: { input: any; output: any; }
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AdUserDto = {
  __typename?: 'ADUserDto';
  displayName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Represents an activity template with activity template activities. */
export type ActivityTemplate = {
  __typename?: 'ActivityTemplate';
  /** Gets the costs per project activity. */
  activityTemplateActivities: Array<ActivityTemplateActivity>;
  activityTemplates: Array<ActivityTemplateActivity>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the name of the activity template. */
  name: Scalars['String']['output'];
};


/** Represents an activity template with activity template activities. */
export type ActivityTemplateActivityTemplateActivitiesArgs = {
  order?: InputMaybe<Array<ActivityTemplateActivitySortInput>>;
  where?: InputMaybe<ActivityTemplateActivityFilterInput>;
};


/** Represents an activity template with activity template activities. */
export type ActivityTemplateActivityTemplatesArgs = {
  order?: InputMaybe<Array<ActivityTemplateActivitySortInput>>;
  where?: InputMaybe<ActivityTemplateActivityFilterInput>;
};

/** Represents an activity assigned to a activity template with installations costs. */
export type ActivityTemplateActivity = {
  __typename?: 'ActivityTemplateActivity';
  /** Gets the activity. */
  activity: ProjectActivity;
  /** Gets the collections of costs. */
  activityCosts: Array<ActivityTemplateActivityCost>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
};

/** Represents a cost of an activity in a activity template. */
export type ActivityTemplateActivityCost = {
  __typename?: 'ActivityTemplateActivityCost';
  /** Gets the type of cost. */
  costType: CostType;
  /** Gets the cost value. */
  costValue?: Maybe<Money>;
};

/** Represents a cost of an activity in a activity template. */
export type ActivityTemplateActivityCostFilterInput = {
  /** Gets the activity template activity. */
  activityTemplateActivity?: InputMaybe<ActivityTemplateActivityFilterInput>;
  /** Gets the activity template activity identifier. */
  activityTemplateActivityId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<ActivityTemplateActivityCostFilterInput>>;
  /** Gets the type of cost. */
  costType?: InputMaybe<CostTypeOperationFilterInput>;
  /** Gets the cost value. */
  costValue?: InputMaybe<MoneyFilterInput>;
  or?: InputMaybe<Array<ActivityTemplateActivityCostFilterInput>>;
};

/** Represents an activity assigned to a activity template with installations costs. */
export type ActivityTemplateActivityFilterInput = {
  /** Gets the activity. */
  activity?: InputMaybe<ProjectActivityFilterInput>;
  /** Gets the collections of costs. */
  activityCosts?: InputMaybe<ListFilterInputTypeOfActivityTemplateActivityCostFilterInput>;
  /** Gets the ActivityTemplate. */
  activityTemplate?: InputMaybe<ActivityTemplateFilterInput>;
  /** Gets the ActivityTemplate identifier. */
  activityTemplateId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<ActivityTemplateActivityFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ActivityTemplateActivityFilterInput>>;
};

/** Represents an activity assigned to a activity template with installations costs. */
export type ActivityTemplateActivitySortInput = {
  /** Gets the activity. */
  activity?: InputMaybe<ProjectActivitySortInput>;
  /** Gets the ActivityTemplate. */
  activityTemplate?: InputMaybe<ActivityTemplateSortInput>;
  /** Gets the ActivityTemplate identifier. */
  activityTemplateId?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
};

/** Represents an activity template with activity template activities. */
export type ActivityTemplateFilterInput = {
  /** Gets the costs per project activity. */
  activityTemplateActivities?: InputMaybe<ListFilterInputTypeOfActivityTemplateActivityFilterInput>;
  and?: InputMaybe<Array<ActivityTemplateFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the name of the activity template. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActivityTemplateFilterInput>>;
};

/** Represents an activity template with activity template activities. */
export type ActivityTemplateSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the name of the activity template. */
  name?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ActivityTemplatesCollectionSegment = {
  __typename?: 'ActivityTemplatesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActivityTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** Properties for adding a new default product set. */
export type AddDefaultProductSetDtoInput = {
  /** Gets or sets the id of the category where this product will be a default. */
  productCategoryId: Scalars['UUID']['input'];
  /** Gets or sets the id of the product set. */
  productSetId: Scalars['UUID']['input'];
  /** Gets or sets a value indicating whether this default should be stored as project default. */
  setAsProjectDefault: Scalars['Boolean']['input'];
  /** Gets or sets the id of the design package wall. */
  wallId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AddOrUpdateProjectsInputType = {
  __typename?: 'AddOrUpdateProjectsInputType';
  customerContactLegalEntityName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  no: Scalars['String']['output'];
  offers: Array<OfferDto>;
  udfCasco: Scalars['Boolean']['output'];
  udfProcedure: Scalars['String']['output'];
};

export type AddOrUpdateProjectsInputTypeInput = {
  customerContactLegalEntityName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  no: Scalars['String']['input'];
  offers: Array<OfferDtoInput>;
  udfCasco: Scalars['Boolean']['input'];
  udfProcedure: Scalars['String']['input'];
};

export type AddOrUpdateProjectsResponseType = {
  __typename?: 'AddOrUpdateProjectsResponseType';
  importedProjects: AddOrUpdateProjectsInputType;
  message: Scalars['String']['output'];
};

/** Properties for adding a new pre-selected product set. */
export type AddPreselectedProductSetDtoInput = {
  /** Gets or sets the id of the category where this product will be a default. */
  productCategoryId: Scalars['UUID']['input'];
  /** Gets or sets the id of the product set. */
  productSetId: Scalars['UUID']['input'];
  /** Gets or sets the id of the design package wall. */
  wallId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Alternative path for the content item */
export type AliasPart = {
  __typename?: 'AliasPart';
  alias?: Maybe<Scalars['String']['output']>;
};

/** the alias part of the content item */
export type AliasPartInput = {
  /** the alias of the content item is equal to */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** the alias of the content item contains the string */
  alias_contains?: InputMaybe<Scalars['String']['input']>;
  /** the alias of the content item ends with the string */
  alias_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the alias of the content item is in collection */
  alias_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the alias of the content item is not equal to */
  alias_not?: InputMaybe<Scalars['String']['input']>;
  /** the alias of the content item does not contain the string */
  alias_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the alias of the content item does not end with the string */
  alias_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the alias of the content item is not in collection */
  alias_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the alias of the content item does not start with the string */
  alias_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the alias of the content item starts with the string */
  alias_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

/** A segment of a collection. */
export type AssignedCategoryProductSetsCollectionSegment = {
  __typename?: 'AssignedCategoryProductSetsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<ProductPackageSet>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AssignedProductSetsCollectionSegment = {
  __typename?: 'AssignedProductSetsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<ProductPackageSet>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** Represents a Become Partner Page. */
export type BecomePartnerPage = ContentItem & {
  __typename?: 'BecomePartnerPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Content stored as HTML. */
  htmlBody?: Maybe<HtmlBodyPart>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type BecomePartnerPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the BecomePartnerPage content item filters */
export type BecomePartnerPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<BecomePartnerPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<BecomePartnerPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<BecomePartnerPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type Block1 = {
  __typename?: 'Block1';
  /** Text field */
  text?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type Block2 = {
  __typename?: 'Block2';
  /** Text field */
  text?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type Block3 = {
  __typename?: 'Block3';
  /** Text field */
  text?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type Block4 = {
  __typename?: 'Block4';
  /** Text field */
  text?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Brand represents a single brand for decorating rooms. */
export type Brand = {
  __typename?: 'Brand';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the name of the brand. */
  name: Scalars['String']['output'];
  /** Gets the product package of the brand. */
  productPackage?: Maybe<ProductPackage>;
  /** Gets the identifier of the product package of the brand. */
  productPackageId?: Maybe<Scalars['UUID']['output']>;
  usedInDesignPackages: Array<DesignPackage>;
  usedInProjects: Array<ProjectBrand>;
};


/** Brand represents a single brand for decorating rooms. */
export type BrandUsedInDesignPackagesArgs = {
  where?: InputMaybe<DesignPackageFilterInput>;
};


/** Brand represents a single brand for decorating rooms. */
export type BrandUsedInProjectsArgs = {
  where?: InputMaybe<ProjectBrandFilterInput>;
};

/** Represents a Brand Detail. */
export type BrandDetail = ContentItem & {
  __typename?: 'BrandDetail';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  teaserImage?: Maybe<MediaField>;
  /** Text field */
  teaserText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  teaserTitle?: Maybe<Scalars['String']['output']>;
};

export type BrandDetailOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the BrandDetail content item filters */
export type BrandDetailWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<BrandDetailWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<BrandDetailWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<BrandDetailWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Brand represents a single brand for decorating rooms. */
export type BrandFilterInput = {
  and?: InputMaybe<Array<BrandFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the name of the brand. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BrandFilterInput>>;
  /** Gets the product package of the brand. */
  productPackage?: InputMaybe<ProductPackageFilterInput>;
  /** Gets the identifier of the product package of the brand. */
  productPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the collection of DesignPackage objects that reference this brand. */
  usedInDesignPackages?: InputMaybe<ListFilterInputTypeOfDesignPackageFilterInput>;
  /** Gets the collection of ProjectBrand objects that reference this brand. */
  usedInProjects?: InputMaybe<ListFilterInputTypeOfProjectBrandFilterInput>;
};

/** Represents a Brand Listing Page. */
export type BrandListingPage = ContentItem & {
  __typename?: 'BrandListingPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** HtmlField */
  description?: Maybe<HtmlField>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  goToBrand?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type BrandListingPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the BrandListingPage content item filters */
export type BrandListingPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<BrandListingPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<BrandListingPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<BrandListingPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type BrandOverviewBlock1 = {
  __typename?: 'BrandOverviewBlock1';
  /** HtmlField */
  text?: Maybe<HtmlField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type BrandOverviewBlock2 = {
  __typename?: 'BrandOverviewBlock2';
  /** HtmlField */
  text?: Maybe<HtmlField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a Brand Page. */
export type BrandPage = ContentItem & {
  __typename?: 'BrandPage';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** ContentPickerField */
  brandDetails?: Maybe<ContentPickerField>;
  /** MediaField */
  brandOverViewBanner?: Maybe<MediaField>;
  /** MediaField */
  brandOverViewImages?: Maybe<MediaField>;
  /** Represents a BrandOverviewBlock. */
  brandOverviewBlock1?: Maybe<BrandOverviewBlock1>;
  /** Represents a BrandOverviewBlock. */
  brandOverviewBlock2?: Maybe<BrandOverviewBlock2>;
  /** ContentPickerField */
  brandPartners?: Maybe<ContentPickerField>;
  /** Represents a BrandOverView. */
  brandoverview?: Maybe<Brandoverview>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Numeric field */
  position?: Maybe<Scalars['Decimal']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  teaserImage?: Maybe<MediaField>;
  /** Text field */
  teaserSubtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  teaserTitle?: Maybe<Scalars['String']['output']>;
};

export type BrandPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the BrandPage content item filters */
export type BrandPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<BrandPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<BrandPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<BrandPageWhereInput>>>;
  /** the alias part of the content item */
  alias?: InputMaybe<AliasPartInput>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a Brand Partner. */
export type BrandPartner = ContentItem & {
  __typename?: 'BrandPartner';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Text field */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** MediaField */
  detailPageBannerImage?: Maybe<MediaField>;
  /** MediaField */
  detailPageContentBlock1Image?: Maybe<MediaField>;
  /** HtmlField */
  detailPageContentBlock1Text?: Maybe<HtmlField>;
  /** MediaField */
  detailPageContentBlock2Images?: Maybe<MediaField>;
  /** HtmlField */
  detailPageContentBlock2Text?: Maybe<HtmlField>;
  /** MediaField */
  detailPagePromotionVideo?: Maybe<MediaField>;
  /** Text field */
  detailPageSubtitle?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  detailPageSummaryBlockDescription?: Maybe<HtmlField>;
  /** Text field */
  detailPageSummaryBlockTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  detailPageTitle?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** MediaField */
  logo?: Maybe<MediaField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  text?: Maybe<HtmlField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type BrandPartnerOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the BrandPartner content item filters */
export type BrandPartnerWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<BrandPartnerWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<BrandPartnerWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<BrandPartnerWhereInput>>>;
  /** the alias part of the content item */
  alias?: InputMaybe<AliasPartInput>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Brand represents a single brand for decorating rooms. */
export type BrandSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the name of the brand. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the product package of the brand. */
  productPackage?: InputMaybe<ProductPackageSortInput>;
  /** Gets the identifier of the product package of the brand. */
  productPackageId?: InputMaybe<SortEnumType>;
};

export type Brandoverview = {
  __typename?: 'Brandoverview';
  /** HtmlField */
  introduction?: Maybe<HtmlField>;
};

export type Bunnik = {
  __typename?: 'Bunnik';
  /** Text field */
  description?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  image?: Maybe<MediaField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a Category. */
export type Category = ContentItem & {
  __typename?: 'Category';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Text field */
  brandLineHeader?: Maybe<Scalars['String']['output']>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  explanationText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  name?: Maybe<Scalars['String']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  popupTriggerForRoomLayout?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type CategoryOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the Category content item filters */
export type CategoryWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<CategoryWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<CategoryWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<CategoryWhereInput>>>;
  /** the alias part of the content item */
  alias?: InputMaybe<AliasPartInput>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

/** Represents a Combination Product Sets Page. */
export type CombinationProductSetsPage = ContentItem & {
  __typename?: 'CombinationProductSetsPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  excludingVATLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  grossPriceLabel?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  noProductSetFoundLabel?: Maybe<Scalars['String']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  scanQrCodeButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  uScannedDescription?: Maybe<Scalars['String']['output']>;
  /** Text field */
  uScannedLabel?: Maybe<Scalars['String']['output']>;
};

export type CombinationProductSetsPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the CombinationProductSetsPage content item filters */
export type CombinationProductSetsPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<CombinationProductSetsPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<CombinationProductSetsPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<CombinationProductSetsPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The confirmed status types for a real estate */
export enum ConfirmedStatusType {
  /** Additional Work */
  AdditionalWork = 'ADDITIONAL_WORK',
  /** Casco */
  Casco = 'CASCO',
  /** Casco+ */
  CascoPlus = 'CASCO_PLUS',
  /** Custom quote for all rooms */
  GlobalCustom = 'GLOBAL_CUSTOM',
  /** Standard */
  Standard = 'STANDARD',
  /** Standard+ */
  StandardPlus = 'STANDARD_PLUS'
}

export type ContactDto = {
  __typename?: 'ContactDto';
  email: Scalars['String']['output'];
  formalName: Scalars['String']['output'];
  legalEntityName: Scalars['String']['output'];
  telNo: Scalars['String']['output'];
};

export type ContactDto2 = {
  __typename?: 'ContactDto2';
  email: Scalars['String']['output'];
  formalName: Scalars['String']['output'];
  legalEntityName: Scalars['String']['output'];
  telNo: Scalars['String']['output'];
};

export type ContactDto2Input = {
  email: Scalars['String']['input'];
  formalName: Scalars['String']['input'];
  legalEntityName: Scalars['String']['input'];
  telNo: Scalars['String']['input'];
};

export type ContactDtoInput = {
  email: Scalars['String']['input'];
  formalName: Scalars['String']['input'];
  legalEntityName: Scalars['String']['input'];
  telNo: Scalars['String']['input'];
};

/** The valid status for a contact request. */
export enum ContactRequestStatus {
  /** Closed */
  Closed = 'CLOSED',
  /** New */
  New = 'NEW',
  /** Pending */
  Pending = 'PENDING'
}

export type ContactRequestStatusOperationFilterInput = {
  eq?: InputMaybe<ContactRequestStatus>;
  in?: InputMaybe<Array<ContactRequestStatus>>;
  neq?: InputMaybe<ContactRequestStatus>;
  nin?: InputMaybe<Array<ContactRequestStatus>>;
};

/** Represents a Contact Request Unauthenticated Popup. */
export type ContactRequestUnauthenticatedPopup = ContentItem & {
  __typename?: 'ContactRequestUnauthenticatedPopup';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  emailLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  emailPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Text field */
  invalidEmailMessage?: Maybe<Scalars['String']['output']>;
  /** Text field */
  invalidPhoneNumberMessage?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** Text field */
  loginText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  loginTriggerText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  messageLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  messagePlaceholder?: Maybe<Scalars['String']['output']>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  nameLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  namePlaceholder?: Maybe<Scalars['String']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  phoneNumberLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  phoneNumberPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  salutationFemale?: Maybe<Scalars['String']['output']>;
  /** Text field */
  salutationLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  salutationMale?: Maybe<Scalars['String']['output']>;
  /** Text field */
  submit?: Maybe<Scalars['String']['output']>;
  /** Text field */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type ContactRequestUnauthenticatedPopupOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ContactRequestUnauthenticatedPopup content item filters */
export type ContactRequestUnauthenticatedPopupWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ContactRequestUnauthenticatedPopupWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ContactRequestUnauthenticatedPopupWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ContactRequestUnauthenticatedPopupWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** A segment of a collection. */
export type ContactRequestsCollectionSegment = {
  __typename?: 'ContactRequestsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RequestForContact>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** Contact type. */
export enum ContactType {
  /** E-mail. */
  Email = 'EMAIL',
  /** No preference. */
  NoPreference = 'NO_PREFERENCE',
  /** Phone. */
  Phone = 'PHONE'
}

export type ContactTypeOperationFilterInput = {
  eq?: InputMaybe<ContactType>;
  in?: InputMaybe<Array<ContactType>>;
  neq?: InputMaybe<ContactType>;
  nin?: InputMaybe<Array<ContactType>>;
};

export type ContactUnauthenticatedMessageDto = MessageBaseDto & {
  __typename?: 'ContactUnauthenticatedMessageDto';
  content: Scalars['String']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  operationId?: Maybe<Scalars['UUID']['output']>;
  operationType: OperationType;
  parentId?: Maybe<Scalars['UUID']['output']>;
  realEstateId: Scalars['UUID']['output'];
  sender: Scalars['String']['output'];
  senderRole: Scalars['String']['output'];
  status: MessageStatus;
};

export type ContentItem = {
  author: Scalars['String']['output'];
  contentItemId: Scalars['String']['output'];
  contentItemVersionId: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  displayText?: Maybe<Scalars['String']['output']>;
  latest: Scalars['Boolean']['output'];
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  owner: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentPickerField = {
  __typename?: 'ContentPickerField';
  /** content item ids */
  contentItemIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** the content items */
  contentItems?: Maybe<Array<Maybe<ContentItem>>>;
};


export type ContentPickerFieldContentItemIdsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentPickerFieldContentItemsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a cost. */
export type CostEntry = {
  __typename?: 'CostEntry';
  /** Gets or sets the cost value */
  cost: Money;
  /** Gets or sets the costy type. */
  type: CostType;
};

/** Available cost type in badkamer */
export enum CostType {
  /** Commission Costs for the builder */
  CoordinationCommissionBuilderCosts = 'COORDINATION_COMMISSION_BUILDER_COSTS',
  /** Commission Costs */
  CoordinationCommissionCosts = 'COORDINATION_COMMISSION_COSTS',
  /** Commission Costs for the installer */
  CoordinationCommissionInstallerCosts = 'COORDINATION_COMMISSION_INSTALLER_COSTS',
  /** Custom Offer Costs */
  CustomOfferCosts = 'CUSTOM_OFFER_COSTS',
  /** CV-installation costs */
  CvInstallationCosts = 'CV_INSTALLATION_COSTS',
  /** 3D Drawing Costs */
  DrawingCosts = 'DRAWING_COSTS',
  /** E-installation costs */
  EInstallationCosts = 'E_INSTALLATION_COSTS',
  /** For calculations - Tiler cost. */
  ForCalculationTilesInstaller = 'FOR_CALCULATION_TILES_INSTALLER',
  /** For calculations - Tiler cost per meter. */
  ForCalculationTilesInstallerM1 = 'FOR_CALCULATION_TILES_INSTALLER_M1',
  /** For calculations - Tiler cost per square meter. */
  ForCalculationTilesInstallerM2 = 'FOR_CALCULATION_TILES_INSTALLER_M2',
  /** Installation Costs */
  InstallationConstructionCosts = 'INSTALLATION_CONSTRUCTION_COSTS',
  /** CV-installation costs */
  KitterInstallationCosts = 'KITTER_INSTALLATION_COSTS',
  /** Lower Price Products Costs */
  LowerPriceStandardProductsCosts = 'LOWER_PRICE_STANDARD_PRODUCTS_COSTS',
  /** Product Costs */
  ProductsAndInstallationMaterialsCosts = 'PRODUCTS_AND_INSTALLATION_MATERIALS_COSTS',
  /** Tiler installation costs */
  TilerInstallationCosts = 'TILER_INSTALLATION_COSTS',
  /** Tiles Costs */
  TilesAndFastenersCosts = 'TILES_AND_FASTENERS_COSTS',
  /** Total Costs */
  TotalSurchargeCosts = 'TOTAL_SURCHARGE_COSTS',
  /** VAT costs */
  VatCosts = 'VAT_COSTS',
  /** W-installation costs */
  WInstallationCosts = 'W_INSTALLATION_COSTS'
}

export type CostTypeOperationFilterInput = {
  eq?: InputMaybe<CostType>;
  in?: InputMaybe<Array<CostType>>;
  neq?: InputMaybe<CostType>;
  nin?: InputMaybe<Array<CostType>>;
};

export enum CrudAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Update = 'UPDATE'
}

/** Available currencies in badkamer according to ISO 4217 standard */
export enum Currency {
  /** EURO */
  Eur = 'EUR'
}

export type CurrencyOperationFilterInput = {
  eq?: InputMaybe<Currency>;
  in?: InputMaybe<Array<Currency>>;
  neq?: InputMaybe<Currency>;
  nin?: InputMaybe<Array<Currency>>;
};

/** CustomOffer represents a CustomOffer. */
export type CustomOffer = {
  __typename?: 'CustomOffer';
  /** Gets the costs assigned to this custom offer room. */
  assignedRooms: Array<Maybe<CustomOfferRoom>>;
  /** Gets the creation date of the custom offer. */
  createdAtUtc: Scalars['DateTime']['output'];
  customOfferFiles?: Maybe<Array<Maybe<CustomOfferFileDto>>>;
  /** Gets or sets the custom offer request of the relation. */
  customOfferRequest: RequestForCustomOffer;
  /** Gets the custom offer request id of the relation. */
  customOfferRequestId: Scalars['UUID']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets a value indicating whether the current offer has been shared with the customer. */
  isSharedWithCustomer: Scalars['Boolean']['output'];
  /** Gets the 3d link for the offer. */
  link: Scalars['String']['output'];
  /** Gets the name of the offer. */
  name: Scalars['String']['output'];
  /** Gets the notes of the custom offer. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Gets the custom offer status. */
  status: CustomOfferStatus;
  /**
   * Gets the stringified version.
   *
   *
   * **Returns:**
   * The string representation of the version.
   */
  strVersion: Scalars['String']['output'];
  /** Gets the version of the custom offer. */
  version: Scalars['Int']['output'];
};

/** The type of a custom offer request. */
export enum CustomOfferAppointmentType {
  /** Custom offer by contact. */
  Contact = 'CONTACT',
  /** Custom offer by face-to-face appointment. */
  Meeting = 'MEETING',
  /** Custom offer without costs. */
  NoCosts = 'NO_COSTS'
}

export type CustomOfferAppointmentTypeOperationFilterInput = {
  eq?: InputMaybe<CustomOfferAppointmentType>;
  in?: InputMaybe<Array<CustomOfferAppointmentType>>;
  neq?: InputMaybe<CustomOfferAppointmentType>;
  nin?: InputMaybe<Array<CustomOfferAppointmentType>>;
};

/** Represents a Custom Offer Content. */
export type CustomOfferContent = ContentItem & {
  __typename?: 'CustomOfferContent';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Text field */
  blockButtonText?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  blockDescription?: Maybe<HtmlField>;
  /** HtmlField */
  blockDescriptionRequested?: Maybe<HtmlField>;
  /** HtmlField */
  blockDescriptionWhenCustomOfferIsAvailable?: Maybe<HtmlField>;
  /** Text field */
  blockTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  confirmRequestButtonText?: Maybe<Scalars['String']['output']>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** HtmlField */
  option1Description?: Maybe<HtmlField>;
  /** Text field */
  option1Title?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  option2Description?: Maybe<HtmlField>;
  /** Text field */
  option2Title?: Maybe<Scalars['String']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  popupTitle?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  requestChangeButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  requestChangePopUpSubmitButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  requestChangePopUpSubtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  requestChangePopUpTextAreaLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  requestChangePopUpTextAreaPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Text field */
  requestChangePopUpTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  requestNotesCompleteNewLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  requestNotesSomeChangesLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomSelection?: Maybe<Scalars['String']['output']>;
  /** Text field */
  successPopupDescription?: Maybe<Scalars['String']['output']>;
  /** Text field */
  successPopupTitle?: Maybe<Scalars['String']['output']>;
};

export type CustomOfferContentOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the CustomOfferContent content item filters */
export type CustomOfferContentWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<CustomOfferContentWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<CustomOfferContentWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<CustomOfferContentWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type CustomOfferFileDto = {
  __typename?: 'CustomOfferFileDto';
  /** Gets the name of the file. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Gets the type of the file. */
  type?: Maybe<CustomOfferFileType>;
};

/** Custom offer file types. */
export enum CustomOfferFileType {
  /** When is a drawing file. */
  Drawing = 'DRAWING',
  /** When is the offer file. */
  Offer = 'OFFER'
}

/** CustomOffer represents a CustomOffer. */
export type CustomOfferFilterInput = {
  and?: InputMaybe<Array<CustomOfferFilterInput>>;
  /** Gets the costs assigned to this custom offer room. */
  assignedRooms?: InputMaybe<ListFilterInputTypeOfCustomOfferRoomFilterInput>;
  /** Gets the creation date of the custom offer. */
  createdAtUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets or sets the custom offer request of the relation. */
  customOfferRequest?: InputMaybe<RequestForCustomOfferFilterInput>;
  /** Gets the custom offer request id of the relation. */
  customOfferRequestId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the custom offer has associated files. */
  hasFiles?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the current offer has been shared with the customer. */
  isSharedWithCustomer?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the 3d link for the offer. */
  link?: InputMaybe<StringOperationFilterInput>;
  /** Gets the name of the offer. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Gets the notes of the custom offer. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomOfferFilterInput>>;
  /** Gets the custom offer status. */
  status?: InputMaybe<CustomOfferStatusOperationFilterInput>;
  /**
   * Gets the stringified version.
   *
   *
   * **Returns:**
   * The string representation of the version.
   */
  strVersion?: InputMaybe<StringOperationFilterInput>;
  /** Gets the version of the custom offer. */
  version?: InputMaybe<IntOperationFilterInput>;
};

/** Represent a CustomOfferRequestAppointment. */
export type CustomOfferRequestAppointment = {
  __typename?: 'CustomOfferRequestAppointment';
  /** Gets the date of the custom offer request appointment. */
  appointmentDate: Scalars['DateTime']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the CustomOfferAppointmentType. */
  type: CustomOfferAppointmentType;
};

/** Represent a CustomOfferRequestAppointment. */
export type CustomOfferRequestAppointmentFilterInput = {
  and?: InputMaybe<Array<CustomOfferRequestAppointmentFilterInput>>;
  /** Gets the date of the custom offer request appointment. */
  appointmentDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the custom offer request identifier. */
  customOfferRequestId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CustomOfferRequestAppointmentFilterInput>>;
  /** Gets the CustomOfferAppointmentType. */
  type?: InputMaybe<CustomOfferAppointmentTypeOperationFilterInput>;
};

/** Represent a CustomOfferRequestAppointment. */
export type CustomOfferRequestAppointmentSortInput = {
  /** Gets the date of the custom offer request appointment. */
  appointmentDate?: InputMaybe<SortEnumType>;
  /** Gets the custom offer request identifier. */
  customOfferRequestId?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the CustomOfferAppointmentType. */
  type?: InputMaybe<SortEnumType>;
};

/** The valid status for a custom offer request. */
export enum CustomOfferRequestStatus {
  /** Make an appointment. */
  Appointment = 'APPOINTMENT',
  /** Offer cancelled. */
  Cancelled = 'CANCELLED',
  /** Completed custom offer. */
  Completed = 'COMPLETED',
  /** Create an offer */
  CreateOffer = 'CREATE_OFFER',
  /** New request. */
  New = 'NEW',
  /** Request a custom offer change. */
  RequestForChange = 'REQUEST_FOR_CHANGE',
  /** Offer shared with customer. */
  SharedWithCustomer = 'SHARED_WITH_CUSTOMER'
}

export type CustomOfferRequestStatusOperationFilterInput = {
  eq?: InputMaybe<CustomOfferRequestStatus>;
  in?: InputMaybe<Array<CustomOfferRequestStatus>>;
  neq?: InputMaybe<CustomOfferRequestStatus>;
  nin?: InputMaybe<Array<CustomOfferRequestStatus>>;
};

/** A segment of a collection. */
export type CustomOfferRequestsCollectionSegment = {
  __typename?: 'CustomOfferRequestsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RequestForCustomOffer>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** CustomOfferRoom represents the costs of using a CustomOfferRoom. */
export type CustomOfferRoom = {
  __typename?: 'CustomOfferRoom';
  /** Gets the costs assigned to this custom offer room. */
  assignedCosts: Array<Maybe<CustomOfferRoomCost>>;
  /** Gets or sets the custom offer of the relation. */
  customOffer: CustomOffer;
  /** Gets the custom offer id of the relation. */
  customOfferId: Scalars['UUID']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets or sets the room of the relation. */
  room?: Maybe<Room>;
  /** Gets the room id of the relation. */
  roomId?: Maybe<Scalars['UUID']['output']>;
};


/** CustomOfferRoom represents the costs of using a CustomOfferRoom. */
export type CustomOfferRoomAssignedCostsArgs = {
  where?: InputMaybe<CustomOfferRoomCostFilterInput>;
};

/** CustomOfferRoomCost represents the costs of using a CustomOfferRoomCost. */
export type CustomOfferRoomCost = {
  __typename?: 'CustomOfferRoomCost';
  /** Gets the cost for the Room for a specific CostType for a RequestForCustomOffer. */
  cost: Money;
  /** Gets the cost type of this value for a custom offer request room. */
  costType: CostType;
  /** Gets the custom offer room id of the relation. */
  customOfferRoomId: Scalars['UUID']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
};

/** CustomOfferRoomCost represents the costs of using a CustomOfferRoomCost. */
export type CustomOfferRoomCostFilterInput = {
  and?: InputMaybe<Array<CustomOfferRoomCostFilterInput>>;
  /** Gets the cost for the Room for a specific CostType for a RequestForCustomOffer. */
  cost?: InputMaybe<MoneyFilterInput>;
  /** Gets the cost type of this value for a custom offer request room. */
  costType?: InputMaybe<CostTypeOperationFilterInput>;
  /** Gets or sets the custom offer room of the relation. */
  customOfferRoom?: InputMaybe<CustomOfferRoomFilterInput>;
  /** Gets the custom offer room id of the relation. */
  customOfferRoomId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CustomOfferRoomCostFilterInput>>;
};

/** Contains information about a custom offer room. */
export type CustomOfferRoomDtoInput = {
  /** Gets or sets the costs for a custom offer room. */
  costs: Array<KeyValuePairOfCostTypeAndStringInput>;
  /** Gets or sets the room id. */
  roomId?: InputMaybe<Scalars['UUID']['input']>;
};

/** CustomOfferRoom represents the costs of using a CustomOfferRoom. */
export type CustomOfferRoomFilterInput = {
  and?: InputMaybe<Array<CustomOfferRoomFilterInput>>;
  /** Gets the costs assigned to this custom offer room. */
  assignedCosts?: InputMaybe<ListFilterInputTypeOfCustomOfferRoomCostFilterInput>;
  /** Gets or sets the custom offer of the relation. */
  customOffer?: InputMaybe<CustomOfferFilterInput>;
  /** Gets the custom offer id of the relation. */
  customOfferId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<CustomOfferRoomFilterInput>>;
  /** Gets or sets the room of the relation. */
  room?: InputMaybe<RoomFilterInput>;
  /** Gets the room id of the relation. */
  roomId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the room selection identifier. */
  roomSelectionId?: InputMaybe<UuidOperationFilterInput>;
};

/** Custom Offer Status. */
export enum CustomOfferStatus {
  /** Active status. */
  Active = 'ACTIVE',
  /** Deleted status. */
  Deleted = 'DELETED',
  /** Unshared status. */
  Unshared = 'UNSHARED'
}

export type CustomOfferStatusOperationFilterInput = {
  eq?: InputMaybe<CustomOfferStatus>;
  in?: InputMaybe<Array<CustomOfferStatus>>;
  neq?: InputMaybe<CustomOfferStatus>;
  nin?: InputMaybe<Array<CustomOfferStatus>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackage = {
  __typename?: 'DesignPackage';
  /** Gets the costs assigned to this design package. */
  assignedCosts?: Maybe<Array<Maybe<DesignPackageCost>>>;
  /** Gets the default product sets assigned to this design package. */
  assignedDefaultProducts?: Maybe<Array<Maybe<DesignPackageDefaultProductSet>>>;
  /** Gets the pre-selected product sets assigned to this design package. */
  assignedPreselectedProductSets?: Maybe<Array<Maybe<DesignPackagePreselectedProductSet>>>;
  /** Gets the product packages assigned restrictions to this project. */
  assignedRestrictions?: Maybe<Array<Maybe<DesignPackageProductSetRestriction>>>;
  /** Gets the walls assigned to this design package. */
  assignedWalls?: Maybe<Array<Maybe<DesignPackageWall>>>;
  availableProductCategories?: Maybe<Array<Maybe<ProductPackageCategory>>>;
  availableProductCombinations?: Maybe<Array<Maybe<ProductCombination>>>;
  availableProductSets?: Maybe<Array<Maybe<ProductPackageSet>>>;
  /** Gets Brand for the Design Package */
  brand?: Maybe<Brand>;
  /** Gets a value indicating whether the Design Package has a bath label. */
  hasBath: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a bathtub. */
  hasBathtub: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a fountain. */
  hasFountain: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a radiator. */
  hasRadiator: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a shower. */
  hasShower: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a tiles. */
  hasTiles: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a toilet. */
  hasToilet: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a toilet label. */
  hasToiletLabel: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a utilities. */
  hasUtilities: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has a washbasin. */
  hasWashbasin: Scalars['Boolean']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /**
   * Gets a value indicating whether the Design Package involves a fixed price,
   * or that the price is determines based on the smallest possible set of dimensions for similar rooms in the same project.
   */
  isFixedPrice: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package is a Standard one. */
  isStandard: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the Design Package has tiles selected to ceiling. */
  isTilesToCeiling: IsTilesToCeiling;
  /** Gets a value indicating whether the Design Package involves increasing the room size, i.e. XL label. */
  isXL: Scalars['Boolean']['output'];
  /** Gets Name for the Design Package */
  name: Scalars['String']['output'];
  overview?: Maybe<OverviewDto>;
  /** Gets the Position for the Design Package */
  position: Scalars['Int']['output'];
  /** Gets Price for the Design Package, based on smallest possible set of dimensions for this room. */
  price: Money;
  /** Gets price variant for the Design Package */
  priceVariant?: Maybe<PriceVariant>;
  /**
   * Gets the ProductCombinationType assigned for the DesignPackage.
   *
   *
   * **Returns:**
   * The list of ProductCombinationType assigned for this DesignPackage.
   */
  productCombinationTypes: Array<ProductCombinationType>;
  /** Gets product package for the Design Package */
  productPackage?: Maybe<ProductPackage>;
  /** Gets the Room for the Design Package */
  room: Room;
  selectedProductSets: Array<Maybe<RequestForQuoteRoomSelectionItemDto>>;
  /** Gets Style for the Design Package */
  style?: Maybe<Style>;
};


/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageAssignedRestrictionsArgs = {
  order?: InputMaybe<Array<DesignPackageProductSetRestrictionSortInput>>;
  where?: InputMaybe<DesignPackageProductSetRestrictionFilterInput>;
};


/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageAssignedWallsArgs = {
  order?: InputMaybe<Array<DesignPackageWallSortInput>>;
};


/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageAvailableProductCategoriesArgs = {
  combinationType?: InputMaybe<ProductCombinationType>;
  order?: InputMaybe<Array<ProductPackageCategorySortInput>>;
  selectionName?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductPackageCategoryFilterInput>;
};


/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageAvailableProductCombinationsArgs = {
  combinationType?: InputMaybe<ProductCombinationType>;
  order?: InputMaybe<Array<ProductCombinationSortInput>>;
};


/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageAvailableProductSetsArgs = {
  builtInOption?: InputMaybe<Scalars['Boolean']['input']>;
  combinationType?: InputMaybe<ProductCombinationType>;
  order?: InputMaybe<Array<ProductPackageSetSortInput>>;
  productCategoryId?: InputMaybe<Scalars['UUID']['input']>;
  selectedProductSets?: InputMaybe<Array<InputMaybe<SelectedProductSetDtoInput>>>;
  wallId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<ProductPackageSetFilterInput>;
};


/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageOverviewArgs = {
  selectionName?: InputMaybe<Scalars['String']['input']>;
};


/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageSelectedProductSetsArgs = {
  selectionName?: InputMaybe<Scalars['String']['input']>;
};

/** DesignPackageCost represents the costs of using a DesignPackage. */
export type DesignPackageCost = {
  __typename?: 'DesignPackageCost';
  /** Gets the cost for the DesignPackage for a specific CostType. */
  cost: Money;
  /** Gets the cost type of this value for a design package. */
  costType: CostType;
  /** Gets the design package id of the relation. */
  designPackageId: Scalars['UUID']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
};

/** DesignPackageCost represents the costs of using a DesignPackage. */
export type DesignPackageCostFilterInput = {
  and?: InputMaybe<Array<DesignPackageCostFilterInput>>;
  /** Gets the cost for the DesignPackage for a specific CostType. */
  cost?: InputMaybe<MoneyFilterInput>;
  /** Gets the cost type of this value for a design package. */
  costType?: InputMaybe<CostTypeOperationFilterInput>;
  /** Gets or sets the design package of the relation. */
  designPackage?: InputMaybe<DesignPackageFilterInput>;
  /** Gets the design package id of the relation. */
  designPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<DesignPackageCostFilterInput>>;
};

/** DesignPackageDefaultProductSet represents a default ProductSet for a ProductCategory in a DesignPackage. */
export type DesignPackageDefaultProductSet = {
  __typename?: 'DesignPackageDefaultProductSet';
  /** Gets or sets the wall of the relation. */
  designPackageWall?: Maybe<DesignPackageWall>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets or sets the product category of the relation. */
  productCategory?: Maybe<ProductCategory>;
  /** Gets or sets the product set of the relation. */
  productSet?: Maybe<ProductSet>;
};

/** DesignPackageDefaultProductSet represents a default ProductSet for a ProductCategory in a DesignPackage. */
export type DesignPackageDefaultProductSetFilterInput = {
  and?: InputMaybe<Array<DesignPackageDefaultProductSetFilterInput>>;
  /** Gets or sets the design package of the relation. */
  designPackage?: InputMaybe<DesignPackageFilterInput>;
  /** Gets the design package id of the relation. */
  designPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the wall of the relation. */
  designPackageWall?: InputMaybe<DesignPackageWallFilterInput>;
  /** Gets the wall id of the relation. */
  designPackageWallId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<DesignPackageDefaultProductSetFilterInput>>;
  /** Gets or sets the product category of the relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the product category id of the relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the product set of the relation. */
  productSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the product set id of the relation. */
  productSetId?: InputMaybe<UuidOperationFilterInput>;
};

/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageFilterInput = {
  and?: InputMaybe<Array<DesignPackageFilterInput>>;
  /** Gets the costs assigned to this design package. */
  assignedCosts?: InputMaybe<ListFilterInputTypeOfDesignPackageCostFilterInput>;
  /** Gets the default product sets assigned to this design package. */
  assignedDefaultProducts?: InputMaybe<ListFilterInputTypeOfDesignPackageDefaultProductSetFilterInput>;
  /** Gets the pre-selected product sets assigned to this design package. */
  assignedPreselectedProductSets?: InputMaybe<ListFilterInputTypeOfDesignPackagePreselectedProductSetFilterInput>;
  /** Gets the product packages assigned restrictions to this project. */
  assignedRestrictions?: InputMaybe<ListFilterInputTypeOfDesignPackageProductSetRestrictionFilterInput>;
  /** Gets the walls assigned to this design package. */
  assignedWalls?: InputMaybe<ListFilterInputTypeOfDesignPackageWallFilterInput>;
  /** Gets Brand for the Design Package */
  brand?: InputMaybe<BrandFilterInput>;
  /** Gets the brand id of the relation. */
  brandId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a bath label. */
  hasBath?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a bathtub. */
  hasBathtub?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a fountain. */
  hasFountain?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a radiator. */
  hasRadiator?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a shower. */
  hasShower?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a tiles. */
  hasTiles?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a toilet. */
  hasToilet?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a toilet label. */
  hasToiletLabel?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a utilities. */
  hasUtilities?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has a washbasin. */
  hasWashbasin?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /**
   * Gets a value indicating whether the Design Package involves a fixed price,
   * or that the price is determines based on the smallest possible set of dimensions for similar rooms in the same project.
   */
  isFixedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package is a Standard one. */
  isStandard?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the Design Package has tiles selected to ceiling. */
  isTilesToCeiling?: InputMaybe<IsTilesToCeilingOperationFilterInput>;
  /** Gets a value indicating whether the Design Package involves increasing the room size, i.e. XL label. */
  isXL?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets Name for the Design Package */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DesignPackageFilterInput>>;
  /** Gets the Position for the Design Package */
  position?: InputMaybe<IntOperationFilterInput>;
  /** Gets Price for the Design Package, based on smallest possible set of dimensions for this room. */
  price?: InputMaybe<MoneyFilterInput>;
  /** Gets price variant for the Design Package */
  priceVariant?: InputMaybe<NullableOfPriceVariantOperationFilterInput>;
  /** Gets product package for the Design Package */
  productPackage?: InputMaybe<ProductPackageFilterInput>;
  /** Gets the product package id of the relation. */
  productPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the Room for the Design Package */
  room?: InputMaybe<RoomFilterInput>;
  /** Gets Style for the Design Package */
  style?: InputMaybe<StyleFilterInput>;
  /** Gets the style id of the relation. */
  styleId?: InputMaybe<UuidOperationFilterInput>;
};

/** Represents a Design Package Page. */
export type DesignPackagePage = ContentItem & {
  __typename?: 'DesignPackagePage';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** MediaField */
  bannerImages?: Maybe<MediaField>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** HtmlField */
  description?: Maybe<HtmlField>;
  /** Text field */
  designPackagePopupSummary?: Maybe<Scalars['String']['output']>;
  /** Text field */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  information?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** MediaField */
  layoutImage?: Maybe<MediaField>;
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** MediaField */
  photos?: Maybe<MediaField>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  summary?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  teaserImage?: Maybe<MediaField>;
};

export type DesignPackagePageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the DesignPackagePage content item filters */
export type DesignPackagePageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<DesignPackagePageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<DesignPackagePageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<DesignPackagePageWhereInput>>>;
  /** the alias part of the content item */
  alias?: InputMaybe<AliasPartInput>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** DesignPackagePreselectedProductSet represents a pre-selected ProductSet for a ProductCategory in a DesignPackage. */
export type DesignPackagePreselectedProductSet = {
  __typename?: 'DesignPackagePreselectedProductSet';
  /** Gets or sets the wall of the relation. */
  designPackageWall?: Maybe<DesignPackageWall>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets or sets the product category of the relation. */
  productCategory?: Maybe<ProductCategory>;
  /** Gets or sets the product set of the relation. */
  productSet?: Maybe<ProductSet>;
};

/** DesignPackagePreselectedProductSet represents a pre-selected ProductSet for a ProductCategory in a DesignPackage. */
export type DesignPackagePreselectedProductSetFilterInput = {
  and?: InputMaybe<Array<DesignPackagePreselectedProductSetFilterInput>>;
  /** Gets or sets the design package of the relation. */
  designPackage?: InputMaybe<DesignPackageFilterInput>;
  /** Gets the design package id of the relation. */
  designPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the wall of the relation. */
  designPackageWall?: InputMaybe<DesignPackageWallFilterInput>;
  /** Gets the wall id of the relation. */
  designPackageWallId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<DesignPackagePreselectedProductSetFilterInput>>;
  /** Gets or sets the product category of the relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the product category id of the relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the product set of the relation. */
  productSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the product set id of the relation. */
  productSetId?: InputMaybe<UuidOperationFilterInput>;
};

/**
 * DesignPackageProductSetRestriction represents a retriction on using a ProductSet in a DesignPackage.
 * Restriction can be baucause of room dimensions or other.
 */
export type DesignPackageProductSetRestriction = {
  __typename?: 'DesignPackageProductSetRestriction';
  /** Gets or sets the design package of the relation. */
  designPackage?: Maybe<DesignPackage>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets or sets the ProductCategory parent on this relation. */
  productCategory?: Maybe<ProductCategory>;
  /** Gets or sets the compare operation to preform. */
  productSetInfoCompareOperation?: Maybe<ProductSetInfoCompareOperation>;
  /** Gets or sets the value to be used in the compare operation. */
  productSetInfoCompareValue: Scalars['String']['output'];
  /** Gets or sets the product set information key to be used to compare. */
  productSetInfoKey?: Maybe<ProductSetInfoKeyType>;
};

/**
 * DesignPackageProductSetRestriction represents a retriction on using a ProductSet in a DesignPackage.
 * Restriction can be baucause of room dimensions or other.
 */
export type DesignPackageProductSetRestrictionFilterInput = {
  and?: InputMaybe<Array<DesignPackageProductSetRestrictionFilterInput>>;
  /** Gets or sets the design package of the relation. */
  designPackage?: InputMaybe<DesignPackageFilterInput>;
  /** Gets the design package id of the relation. */
  designPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<DesignPackageProductSetRestrictionFilterInput>>;
  /** Gets or sets the ProductCategory parent on this relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets or sets the id of the ProductCategory parent on this relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the compare operation to preform. */
  productSetInfoCompareOperation?: InputMaybe<ProductSetInfoCompareOperationOperationFilterInput>;
  /** Gets or sets the value to be used in the compare operation. */
  productSetInfoCompareValue?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the product set information key to be used to compare. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeyTypeOperationFilterInput>;
};

/** ProductCombinationRestrictionInfoKey represents a valid key of information about a single DesignPackageProductSetRestriction. */
export type DesignPackageProductSetRestrictionInfoKey = {
  __typename?: 'DesignPackageProductSetRestrictionInfoKey';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets a value indicating whether the rule is optional. */
  isOptional: Scalars['Boolean']['output'];
  /** Gets the operation to use for the restriction rule. */
  operation: ProductSetInfoCompareOperation;
  /** Gets the integer by which the Restriction InfoKey should be ordered when displaying. */
  position: Scalars['Int']['output'];
  /** Gets or sets the product combination of the relation. */
  productCategory?: Maybe<ProductCategory>;
  /** Gets or sets the product combination of the relation. */
  productCombination?: Maybe<ProductCombination>;
  /** Gets or sets the product set information key of the relation. */
  productSetInfoKey?: Maybe<ProductSetInfoKey>;
};

/** ProductCombinationRestrictionInfoKey represents a valid key of information about a single DesignPackageProductSetRestriction. */
export type DesignPackageProductSetRestrictionInfoKeyFilterInput = {
  and?: InputMaybe<Array<DesignPackageProductSetRestrictionInfoKeyFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the rule is optional. */
  isOptional?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the operation to use for the restriction rule. */
  operation?: InputMaybe<ProductSetInfoCompareOperationOperationFilterInput>;
  or?: InputMaybe<Array<DesignPackageProductSetRestrictionInfoKeyFilterInput>>;
  /** Gets the integer by which the Restriction InfoKey should be ordered when displaying. */
  position?: InputMaybe<IntOperationFilterInput>;
  /** Gets or sets the product combination of the relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the product category id of the relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the product combination of the relation. */
  productCombination?: InputMaybe<ProductCombinationFilterInput>;
  /** Gets the product combination id of the relation. */
  productCombinationId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the product set information key of the relation. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeyFilterInput>;
  /** Gets the product set information key id of the relation. */
  productSetInfoKeyId?: InputMaybe<UuidOperationFilterInput>;
};

/** ProductCombinationRestrictionInfoKey represents a valid key of information about a single DesignPackageProductSetRestriction. */
export type DesignPackageProductSetRestrictionInfoKeySortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the rule is optional. */
  isOptional?: InputMaybe<SortEnumType>;
  /** Gets the operation to use for the restriction rule. */
  operation?: InputMaybe<SortEnumType>;
  /** Gets the integer by which the Restriction InfoKey should be ordered when displaying. */
  position?: InputMaybe<SortEnumType>;
  /** Gets or sets the product combination of the relation. */
  productCategory?: InputMaybe<ProductCategorySortInput>;
  /** Gets the product category id of the relation. */
  productCategoryId?: InputMaybe<SortEnumType>;
  /** Gets or sets the product combination of the relation. */
  productCombination?: InputMaybe<ProductCombinationSortInput>;
  /** Gets the product combination id of the relation. */
  productCombinationId?: InputMaybe<SortEnumType>;
  /** Gets or sets the product set information key of the relation. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeySortInput>;
  /** Gets the product set information key id of the relation. */
  productSetInfoKeyId?: InputMaybe<SortEnumType>;
};

/**
 * DesignPackageProductSetRestriction represents a retriction on using a ProductSet in a DesignPackage.
 * Restriction can be baucause of room dimensions or other.
 */
export type DesignPackageProductSetRestrictionSortInput = {
  /** Gets or sets the design package of the relation. */
  designPackage?: InputMaybe<DesignPackageSortInput>;
  /** Gets the design package id of the relation. */
  designPackageId?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductCategory parent on this relation. */
  productCategory?: InputMaybe<ProductCategorySortInput>;
  /** Gets or sets the id of the ProductCategory parent on this relation. */
  productCategoryId?: InputMaybe<SortEnumType>;
  /** Gets or sets the compare operation to preform. */
  productSetInfoCompareOperation?: InputMaybe<SortEnumType>;
  /** Gets or sets the value to be used in the compare operation. */
  productSetInfoCompareValue?: InputMaybe<SortEnumType>;
  /** Gets or sets the product set information key to be used to compare. */
  productSetInfoKey?: InputMaybe<SortEnumType>;
};

/** Design Package represents a set of materials, including installation costs, for a single room. */
export type DesignPackageSortInput = {
  /** Gets Brand for the Design Package */
  brand?: InputMaybe<BrandSortInput>;
  /** Gets the brand id of the relation. */
  brandId?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a bath label. */
  hasBath?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a bathtub. */
  hasBathtub?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a fountain. */
  hasFountain?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a radiator. */
  hasRadiator?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a shower. */
  hasShower?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a tiles. */
  hasTiles?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a toilet. */
  hasToilet?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a toilet label. */
  hasToiletLabel?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a utilities. */
  hasUtilities?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has a washbasin. */
  hasWashbasin?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether the Design Package involves a fixed price,
   * or that the price is determines based on the smallest possible set of dimensions for similar rooms in the same project.
   */
  isFixedPrice?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package is a Standard one. */
  isStandard?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package has tiles selected to ceiling. */
  isTilesToCeiling?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the Design Package involves increasing the room size, i.e. XL label. */
  isXL?: InputMaybe<SortEnumType>;
  /** Gets Name for the Design Package */
  name?: InputMaybe<SortEnumType>;
  /** Gets the Position for the Design Package */
  position?: InputMaybe<SortEnumType>;
  /** Gets Price for the Design Package, based on smallest possible set of dimensions for this room. */
  price?: InputMaybe<MoneySortInput>;
  /** Gets price variant for the Design Package */
  priceVariant?: InputMaybe<SortEnumType>;
  /** Gets product package for the Design Package */
  productPackage?: InputMaybe<ProductPackageSortInput>;
  /** Gets the product package id of the relation. */
  productPackageId?: InputMaybe<SortEnumType>;
  /** Gets the Room for the Design Package */
  room?: InputMaybe<RoomSortInput>;
  /** Gets Style for the Design Package */
  style?: InputMaybe<StyleSortInput>;
  /** Gets the style id of the relation. */
  styleId?: InputMaybe<SortEnumType>;
};

/** Represents a wall in a DesignPackage. */
export type DesignPackageWall = {
  __typename?: 'DesignPackageWall';
  /** Gets the wall area. */
  area: Scalars['Decimal']['output'];
  /** Gets the area of the wall to the ceiling. */
  ceilingArea: Scalars['Decimal']['output'];
  /** Gets the wall length close to the ceiling. */
  ceilingLength: Scalars['Decimal']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets a value indicating whether this is an accent wall. */
  isAccentWall: Scalars['Boolean']['output'];
  /** Gets the wall name. */
  name: Scalars['String']['output'];
  /** Gets the wall profile length. */
  profileLength: Scalars['Decimal']['output'];
};

/** Contains information a wall in a Design Package. */
export type DesignPackageWallDtoInput = {
  /** Gets the identifier of the product set to be default accent tile on this wall. */
  accentTileDefaultProductSetId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets the identifier of the product set to be pre-selected accent tile on this wall. */
  accentTilePreselectedProductSetId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets the wall area. */
  area: Scalars['Decimal']['input'];
  /** Gets the area of the wall to the ceiling. */
  ceilingArea: Scalars['Decimal']['input'];
  /** Gets the wall length close to the ceiling. */
  ceilingLength: Scalars['Decimal']['input'];
  /** Gets the wall identifier. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets a value indicating whether this is an accent wall. */
  isAccentWall: Scalars['Boolean']['input'];
  /** Gets the wall name. */
  name: Scalars['String']['input'];
  /** Gets the wall profile length. */
  profileLength: Scalars['Decimal']['input'];
};

/** Represents a wall in a DesignPackage. */
export type DesignPackageWallFilterInput = {
  and?: InputMaybe<Array<DesignPackageWallFilterInput>>;
  /** Gets the wall area. */
  area?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the area of the wall to the ceiling. */
  ceilingArea?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the wall length close to the ceiling. */
  ceilingLength?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the identifier of the DesignPackage this wall belongs. */
  designPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether this is an accent wall. */
  isAccentWall?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the wall name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DesignPackageWallFilterInput>>;
  /** Gets the wall profile length. */
  profileLength?: InputMaybe<DecimalOperationFilterInput>;
};

/** Represents a wall in a DesignPackage. */
export type DesignPackageWallSortInput = {
  /** Gets the wall area. */
  area?: InputMaybe<SortEnumType>;
  /** Gets the area of the wall to the ceiling. */
  ceilingArea?: InputMaybe<SortEnumType>;
  /** Gets the wall length close to the ceiling. */
  ceilingLength?: InputMaybe<SortEnumType>;
  /** Gets the identifier of the DesignPackage this wall belongs. */
  designPackageId?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this is an accent wall. */
  isAccentWall?: InputMaybe<SortEnumType>;
  /** Gets the wall name. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the wall profile length. */
  profileLength?: InputMaybe<SortEnumType>;
};

export type DictionaryField = {
  __typename?: 'DictionaryField';
  data?: Maybe<Array<Maybe<DictionaryItem>>>;
};

export type DictionaryItem = {
  __typename?: 'DictionaryItem';
  /** Dictionary item name */
  name: Scalars['String']['output'];
  /** Dictionary item value */
  value: Scalars['String']['output'];
};

export type Drachten = {
  __typename?: 'Drachten';
  /** Text field */
  description?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  image?: Maybe<MediaField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

/** The valid status for a drawing request. */
export enum DrawingRequestStatus {
  /** Drawing request cancelled */
  Cancelled = 'CANCELLED',
  /** Drawing has a drawer selected */
  InProgress = 'IN_PROGRESS',
  /** Drawing not requested */
  NotRequested = 'NOT_REQUESTED',
  /** Drawing ready for client. */
  Ready = 'READY',
  /** Drawing requested but not yet available. */
  Requested = 'REQUESTED'
}

export type DrawingRequestStatusOperationFilterInput = {
  eq?: InputMaybe<DrawingRequestStatus>;
  in?: InputMaybe<Array<DrawingRequestStatus>>;
  neq?: InputMaybe<DrawingRequestStatus>;
  nin?: InputMaybe<Array<DrawingRequestStatus>>;
};

/** Email object describes and Email address. */
export type Email = {
  __typename?: 'Email';
  /** Gets the Address */
  address: Scalars['String']['output'];
};

/** Email object describes and Email address. */
export type EmailFilterInput = {
  /** Gets the Address */
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EmailFilterInput>>;
  or?: InputMaybe<Array<EmailFilterInput>>;
};

/** Email object describes and Email address. */
export type EmailSortInput = {
  /** Gets the Address */
  address?: InputMaybe<SortEnumType>;
};

/** Represents a Error Definitions. */
export type ErrorDefinitions = ContentItem & {
  __typename?: 'ErrorDefinitions';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  defaultErrorMessage?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  errorTitle?: Maybe<Scalars['String']['output']>;
  /** DictionaryField */
  errors?: Maybe<DictionaryField>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type ErrorDefinitionsOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ErrorDefinitions content item filters */
export type ErrorDefinitionsWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ErrorDefinitionsWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ErrorDefinitionsWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ErrorDefinitionsWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a Experience Centres Page. */
export type ExperienceCentresPage = ContentItem & {
  __typename?: 'ExperienceCentresPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Represents a StepBlock. */
  bunnik?: Maybe<Bunnik>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** HtmlField */
  description?: Maybe<HtmlField>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Represents a StepBlock. */
  drachten?: Maybe<Drachten>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type ExperienceCentresPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ExperienceCentresPage content item filters */
export type ExperienceCentresPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ExperienceCentresPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ExperienceCentresPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ExperienceCentresPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a Frequently Asked Questions. */
export type FaqPage = ContentItem & {
  __typename?: 'FAQPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Content stored as HTML. */
  htmlBody?: Maybe<HtmlBodyPart>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  projectType?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type FaqPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the FAQPage content item filters */
export type FaqPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<FaqPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<FaqPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<FaqPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum FileExtension {
  Csv = 'CSV',
  Msg = 'MSG',
  Pdf = 'PDF',
  Url = 'URL',
  Xlsx = 'XLSX'
}

/** Represents a Home Page. */
export type HomePage = ContentItem & {
  __typename?: 'HomePage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** Text field */
  costSpecificationTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  createOrderButtonText?: Maybe<Scalars['String']['output']>;
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  customOfferDownloadDrawing?: Maybe<Scalars['String']['output']>;
  /** Text field */
  customOfferDownloadOffer?: Maybe<Scalars['String']['output']>;
  /** Text field */
  customOfferLink?: Maybe<Scalars['String']['output']>;
  /** Text field */
  customOfferSubmitOpenCustomOfferWillBeCanceled?: Maybe<Scalars['String']['output']>;
  /** Text field */
  customOfferSubmitOpenCustomOfferWillBeCompleted?: Maybe<Scalars['String']['output']>;
  /** Text field */
  customOfferSubmitPendingCustomOfferRequestConfirmMessage?: Maybe<Scalars['String']['output']>;
  /** Text field */
  customOfferUnavailableTooltip?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  footerText?: Maybe<HtmlField>;
  /** Text field */
  invalidConfigurationDialogButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  invalidConfigurationDialogText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  invalidConfigurationDialogTitle?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  myRoomsDescription?: Maybe<Scalars['String']['output']>;
  /** Text field */
  myRoomsTitle?: Maybe<Scalars['String']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** HtmlField */
  removeDesignPopupContent?: Maybe<HtmlField>;
  /** Text field */
  removeDesignPopupTitle?: Maybe<Scalars['String']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomListItemCascoOption?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomListItemCascoOptionTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomListItemChooseLayout?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomListItemCompleteAndInstalled?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  roomListItemFooterText?: Maybe<HtmlField>;
  /** Text field */
  roomListItemFooterTextTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomListItemNoSelectionYet?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomListItemStandardOfferSelectionName?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomListItemSurcharge?: Maybe<Scalars['String']['output']>;
  /** Text field */
  roomListItemUnavailableProductSetsMessage?: Maybe<Scalars['String']['output']>;
  /** Text field */
  unavailableProductSetsMessage?: Maybe<Scalars['String']['output']>;
};

export type HomePageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the HomePage content item filters */
export type HomePageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<HomePageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a How Does It Work - Content Item. */
export type HowDoesItWorkContentItem = ContentItem & {
  __typename?: 'HowDoesItWorkContentItem';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** ContentPickerField */
  howDoesItWorkTopics?: Maybe<ContentPickerField>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  subjectTitle?: Maybe<Scalars['String']['output']>;
  /** Boolean field */
  theme?: Maybe<Scalars['Boolean']['output']>;
};

export type HowDoesItWorkContentItemOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the HowDoesItWorkContentItem content item filters */
export type HowDoesItWorkContentItemWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<HowDoesItWorkContentItemWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<HowDoesItWorkContentItemWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<HowDoesItWorkContentItemWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a How Does It Work Page - About Us. */
export type HowDoesItWorkPageAboutUs = ContentItem & {
  __typename?: 'HowDoesItWorkPageAboutUs';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Represents a HowDoesItWorkPageContent. */
  howDoesItWorkPageContent?: Maybe<HowDoesItWorkPageContent>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type HowDoesItWorkPageAboutUsOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the HowDoesItWorkPageAboutUs content item filters */
export type HowDoesItWorkPageAboutUsWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageAboutUsWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageAboutUsWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageAboutUsWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type HowDoesItWorkPageContent = {
  __typename?: 'HowDoesItWorkPageContent';
  /** Text field */
  headerContentBlocks?: Maybe<Scalars['String']['output']>;
  /** ContentPickerField */
  howDoesItWorkTopics?: Maybe<ContentPickerField>;
  /** Text field */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a How Does It Work Page - Design Rooms. */
export type HowDoesItWorkPageDesignRooms = ContentItem & {
  __typename?: 'HowDoesItWorkPageDesignRooms';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Represents a HowDoesItWorkPageContent. */
  howDoesItWorkPageContent?: Maybe<HowDoesItWorkPageContent>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type HowDoesItWorkPageDesignRoomsOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the HowDoesItWorkPageDesignRooms content item filters */
export type HowDoesItWorkPageDesignRoomsWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageDesignRoomsWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageDesignRoomsWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageDesignRoomsWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a How Does It Work Page - New Home. */
export type HowDoesItWorkPageNewHome = ContentItem & {
  __typename?: 'HowDoesItWorkPageNewHome';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Represents a HowDoesItWorkPageContent. */
  howDoesItWorkPageContent?: Maybe<HowDoesItWorkPageContent>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type HowDoesItWorkPageNewHomeOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the HowDoesItWorkPageNewHome content item filters */
export type HowDoesItWorkPageNewHomeWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageNewHomeWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageNewHomeWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<HowDoesItWorkPageNewHomeWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a How Does It Work - Topic Item. */
export type HowDoesItWorkTopicItem = ContentItem & {
  __typename?: 'HowDoesItWorkTopicItem';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** HtmlField */
  content?: Maybe<HtmlField>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  image?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  topicTitle?: Maybe<Scalars['String']['output']>;
};

export type HowDoesItWorkTopicItemOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the HowDoesItWorkTopicItem content item filters */
export type HowDoesItWorkTopicItemWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<HowDoesItWorkTopicItemWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<HowDoesItWorkTopicItemWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<HowDoesItWorkTopicItemWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Content stored as HTML. */
export type HtmlBodyPart = {
  __typename?: 'HtmlBodyPart';
  /** the HTML content */
  html?: Maybe<Scalars['String']['output']>;
};

/** Content stored as HTML. */
export type HtmlField = {
  __typename?: 'HtmlField';
  /** the HTML content */
  html?: Maybe<Scalars['String']['output']>;
};

/** ImportProductPackage class represents a request to import a ProductPackage from an CVS file. */
export type ImportProductPackage = {
  __typename?: 'ImportProductPackage';
  /** Gets the file name. */
  filename: Scalars['String']['output'];
  /** Gets the date the import process ended. */
  finishDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the information gathered during processing of the import. */
  information?: Maybe<Scalars['String']['output']>;
  /** Gets the storage path to th~e file. */
  path: Scalars['String']['output'];
  /** Gets the product package name to import to. */
  productPackageName: Scalars['String']['output'];
  /** Gets the type of project the product package is going to be used on. */
  propositionType: Badkamercore_ProjectType;
  /** Gets the status of the import process. */
  status: ImportStatus;
  /** Gets the date the import file was uploaded. */
  uploadDate: Scalars['DateTime']['output'];
};

/** ImportProductPackage class represents a request to import a ProductPackage from an CVS file. */
export type ImportProductPackageFilterInput = {
  and?: InputMaybe<Array<ImportProductPackageFilterInput>>;
  /** Gets the file name. */
  filename?: InputMaybe<StringOperationFilterInput>;
  /** Gets the date the import process ended. */
  finishDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the information gathered during processing of the import. */
  information?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ImportProductPackageFilterInput>>;
  /** Gets the storage path to th~e file. */
  path?: InputMaybe<StringOperationFilterInput>;
  /** Gets the product package name to import to. */
  productPackageName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the type of project the product package is going to be used on. */
  propositionType?: InputMaybe<ProjectTypeOperationFilterInput>;
  /** Gets the status of the import process. */
  status?: InputMaybe<ImportStatusOperationFilterInput>;
  /** Gets the date the import file was uploaded. */
  uploadDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** ImportProductPackage class represents a request to import a ProductPackage from an CVS file. */
export type ImportProductPackageSortInput = {
  /** Gets the file name. */
  filename?: InputMaybe<SortEnumType>;
  /** Gets the date the import process ended. */
  finishDate?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the information gathered during processing of the import. */
  information?: InputMaybe<SortEnumType>;
  /** Gets the storage path to th~e file. */
  path?: InputMaybe<SortEnumType>;
  /** Gets the product package name to import to. */
  productPackageName?: InputMaybe<SortEnumType>;
  /** Gets the type of project the product package is going to be used on. */
  propositionType?: InputMaybe<SortEnumType>;
  /** Gets the status of the import process. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the date the import file was uploaded. */
  uploadDate?: InputMaybe<SortEnumType>;
};

/** Details about a Product Set to be added to Product Package. */
export type ImportProductSetInput = {
  /** Gets or sets a value indicating whether the product set is eligible for being a default in Design Packages. */
  isDefault: Scalars['Boolean']['input'];
  /** Gets or sets a value indicating whether the product set is assigned to higher price variant. */
  isHigherPriceVariant: Scalars['Boolean']['input'];
  /** Gets or sets a value indicating whether the product set is assigned to intermediate price variant. */
  isIntermediatePriceVariant: Scalars['Boolean']['input'];
  /** Gets or sets a value indicating whether the product set is assigned to lower price variant. */
  isLowerPriceVariant: Scalars['Boolean']['input'];
  /** Gets or sets the identifier of the category where the product set belongs. */
  productCategoryId: Scalars['UUID']['input'];
  /** Gets or sets article codes for the articles that compose this product set. */
  productCodes: Array<Scalars['String']['input']>;
  /** Gets or sets identifier of the brand line where this product set is included. */
  productSetBrandlineId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the name of the brand line. */
  productSetBrandlineName?: InputMaybe<Scalars['String']['input']>;
  /** Gets or sets information values about product set characteristics. */
  productSetInfoValues: Array<TupleOfGuidAndStringInput>;
  /** Gets or sets name of the product set. */
  productSetName: Scalars['String']['input'];
  /** Gets or sets the row number on the import file. */
  rowNumber: Scalars['String']['input'];
};

/** Staatus that an import process can have. */
export enum ImportStatus {
  /** The import process is complete. */
  Complete = 'COMPLETE',
  /** The import process ended with errors. */
  Error = 'ERROR',
  /** New request for import. Not handled yet. */
  New = 'NEW',
  /** While the import is being procesed. */
  Processing = 'PROCESSING'
}

export type ImportStatusOperationFilterInput = {
  eq?: InputMaybe<ImportStatus>;
  in?: InputMaybe<Array<ImportStatus>>;
  neq?: InputMaybe<ImportStatus>;
  nin?: InputMaybe<Array<ImportStatus>>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

/** Options to determine what the preselection is for wall tiles. */
export enum IsTilesToCeiling {
  /** No preselection is set -> default */
  NoPreselection = 'NO_PRESELECTION',
  /** Preselected to No to the ceiling */
  NoToCeiling = 'NO_TO_CEILING',
  /** Preselected to Yes to the ceiling */
  YesToCeiling = 'YES_TO_CEILING'
}

export type IsTilesToCeilingOperationFilterInput = {
  eq?: InputMaybe<IsTilesToCeiling>;
  in?: InputMaybe<Array<IsTilesToCeiling>>;
  neq?: InputMaybe<IsTilesToCeiling>;
  nin?: InputMaybe<Array<IsTilesToCeiling>>;
};

export type KeyValuePairOfCostTypeAndMoney = {
  __typename?: 'KeyValuePairOfCostTypeAndMoney';
  key: CostType;
  value: Money;
};

export type KeyValuePairOfCostTypeAndMoneyFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfCostTypeAndMoneyFilterInput>>;
  key?: InputMaybe<CostTypeOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfCostTypeAndMoneyFilterInput>>;
  value?: InputMaybe<MoneyFilterInput>;
};

export type KeyValuePairOfCostTypeAndStringInput = {
  key: CostType;
  value: Scalars['String']['input'];
};

export type KeyValuePairOfGuidAndListOfProjectActivityCostFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfGuidAndListOfProjectActivityCostFilterInput>>;
  key?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfGuidAndListOfProjectActivityCostFilterInput>>;
  value?: InputMaybe<ListFilterInputTypeOfProjectActivityCostFilterInput>;
};

export type KeyValuePairOfSelectedProductSetDictionaryKeyAndProductPackageSet = {
  __typename?: 'KeyValuePairOfSelectedProductSetDictionaryKeyAndProductPackageSet';
  key: SelectedProductSetDictionaryKey;
  value: ProductPackageSet;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Represents a Landing Page. */
export type LandingPage = ContentItem & {
  __typename?: 'LandingPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Represents a LandingPageContent. */
  block1?: Maybe<Block1>;
  /** Represents a LandingPageContent. */
  block2?: Maybe<Block2>;
  /** Represents a LandingPageContent. */
  block3?: Maybe<Block3>;
  /** Represents a LandingPageContent. */
  block4?: Maybe<Block4>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Numeric field */
  rotationTime?: Maybe<Scalars['Decimal']['output']>;
};

export type LandingPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the LandingPage content item filters */
export type LandingPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<LandingPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<LandingPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<LandingPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Layout for one or more RealEstate objects in a Project. */
export type Layout = {
  __typename?: 'Layout';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the collection of Room to Layout relations. */
  layoutRooms: Array<LayoutRoom>;
  /** Gets the name of this Layout. */
  name: Scalars['String']['output'];
};


/** Layout for one or more RealEstate objects in a Project. */
export type LayoutLayoutRoomsArgs = {
  where?: InputMaybe<LayoutRoomFilterInput>;
};

/** Layout for one or more RealEstate objects in a Project. */
export type LayoutFilterInput = {
  and?: InputMaybe<Array<LayoutFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the collection of Room to Layout relations. */
  layoutRooms?: InputMaybe<ListFilterInputTypeOfLayoutRoomFilterInput>;
  /** Gets the name of this Layout. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LayoutFilterInput>>;
  /** Gets the Project identifier this layout belongs. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
};

/** Relational class that keeps track of relations (many to many) between Layout and Room. */
export type LayoutRoom = {
  __typename?: 'LayoutRoom';
  /** Gets or sets the Layout part of this relation. */
  layout: Layout;
  /** Gets or sets the Room part of this relation. */
  room: Room;
};

/** Relational class that keeps track of relations (many to many) between Layout and Room. */
export type LayoutRoomFilterInput = {
  and?: InputMaybe<Array<LayoutRoomFilterInput>>;
  /** Gets or sets the Layout part of this relation. */
  layout?: InputMaybe<LayoutFilterInput>;
  /** Gets the id of the Layout part of this relation. */
  layoutId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<LayoutRoomFilterInput>>;
  /** Gets or sets the Room part of this relation. */
  room?: InputMaybe<RoomFilterInput>;
  /** Gets the id of the Room part of this relation. */
  roomId?: InputMaybe<UuidOperationFilterInput>;
};

/** Layout for one or more RealEstate objects in a Project. */
export type LayoutSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the name of this Layout. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the Project identifier this layout belongs. */
  projectId?: InputMaybe<SortEnumType>;
};

/** Represents a Layouts. */
export type Layouts = ContentItem & {
  __typename?: 'Layouts';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Represents a TranslationLayout. */
  translationLayout?: Maybe<TranslationLayout>;
};

export type LayoutsOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the Layouts content item filters */
export type LayoutsWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<LayoutsWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<LayoutsWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<LayoutsWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type LinkField = {
  __typename?: 'LinkField';
  /** the text of the link */
  text?: Maybe<Scalars['String']['output']>;
  /** the url of the link */
  url?: Maybe<Scalars['String']['output']>;
};

export type ListFilterInputTypeOfActivityTemplateActivityCostFilterInput = {
  all?: InputMaybe<ActivityTemplateActivityCostFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ActivityTemplateActivityCostFilterInput>;
  some?: InputMaybe<ActivityTemplateActivityCostFilterInput>;
};

export type ListFilterInputTypeOfActivityTemplateActivityFilterInput = {
  all?: InputMaybe<ActivityTemplateActivityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ActivityTemplateActivityFilterInput>;
  some?: InputMaybe<ActivityTemplateActivityFilterInput>;
};

export type ListFilterInputTypeOfCustomOfferFilterInput = {
  all?: InputMaybe<CustomOfferFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomOfferFilterInput>;
  some?: InputMaybe<CustomOfferFilterInput>;
};

export type ListFilterInputTypeOfCustomOfferRequestAppointmentFilterInput = {
  all?: InputMaybe<CustomOfferRequestAppointmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomOfferRequestAppointmentFilterInput>;
  some?: InputMaybe<CustomOfferRequestAppointmentFilterInput>;
};

export type ListFilterInputTypeOfCustomOfferRoomCostFilterInput = {
  all?: InputMaybe<CustomOfferRoomCostFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomOfferRoomCostFilterInput>;
  some?: InputMaybe<CustomOfferRoomCostFilterInput>;
};

export type ListFilterInputTypeOfCustomOfferRoomFilterInput = {
  all?: InputMaybe<CustomOfferRoomFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomOfferRoomFilterInput>;
  some?: InputMaybe<CustomOfferRoomFilterInput>;
};

export type ListFilterInputTypeOfDesignPackageCostFilterInput = {
  all?: InputMaybe<DesignPackageCostFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DesignPackageCostFilterInput>;
  some?: InputMaybe<DesignPackageCostFilterInput>;
};

export type ListFilterInputTypeOfDesignPackageDefaultProductSetFilterInput = {
  all?: InputMaybe<DesignPackageDefaultProductSetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DesignPackageDefaultProductSetFilterInput>;
  some?: InputMaybe<DesignPackageDefaultProductSetFilterInput>;
};

export type ListFilterInputTypeOfDesignPackageFilterInput = {
  all?: InputMaybe<DesignPackageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DesignPackageFilterInput>;
  some?: InputMaybe<DesignPackageFilterInput>;
};

export type ListFilterInputTypeOfDesignPackagePreselectedProductSetFilterInput = {
  all?: InputMaybe<DesignPackagePreselectedProductSetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DesignPackagePreselectedProductSetFilterInput>;
  some?: InputMaybe<DesignPackagePreselectedProductSetFilterInput>;
};

export type ListFilterInputTypeOfDesignPackageProductSetRestrictionFilterInput = {
  all?: InputMaybe<DesignPackageProductSetRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DesignPackageProductSetRestrictionFilterInput>;
  some?: InputMaybe<DesignPackageProductSetRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDesignPackageWallFilterInput = {
  all?: InputMaybe<DesignPackageWallFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DesignPackageWallFilterInput>;
  some?: InputMaybe<DesignPackageWallFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfCostTypeAndMoneyFilterInput = {
  all?: InputMaybe<KeyValuePairOfCostTypeAndMoneyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfCostTypeAndMoneyFilterInput>;
  some?: InputMaybe<KeyValuePairOfCostTypeAndMoneyFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfGuidAndListOfProjectActivityCostFilterInput = {
  all?: InputMaybe<KeyValuePairOfGuidAndListOfProjectActivityCostFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfGuidAndListOfProjectActivityCostFilterInput>;
  some?: InputMaybe<KeyValuePairOfGuidAndListOfProjectActivityCostFilterInput>;
};

export type ListFilterInputTypeOfLayoutFilterInput = {
  all?: InputMaybe<LayoutFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LayoutFilterInput>;
  some?: InputMaybe<LayoutFilterInput>;
};

export type ListFilterInputTypeOfLayoutRoomFilterInput = {
  all?: InputMaybe<LayoutRoomFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LayoutRoomFilterInput>;
  some?: InputMaybe<LayoutRoomFilterInput>;
};

export type ListFilterInputTypeOfProductCategoryFilterInput = {
  all?: InputMaybe<ProductCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductCategoryFilterInput>;
  some?: InputMaybe<ProductCategoryFilterInput>;
};

export type ListFilterInputTypeOfProductCategoryProductSetInfoKeyFilterInput = {
  all?: InputMaybe<ProductCategoryProductSetInfoKeyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductCategoryProductSetInfoKeyFilterInput>;
  some?: InputMaybe<ProductCategoryProductSetInfoKeyFilterInput>;
};

export type ListFilterInputTypeOfProductCombinationRestrictionFilterInput = {
  all?: InputMaybe<ProductCombinationRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductCombinationRestrictionFilterInput>;
  some?: InputMaybe<ProductCombinationRestrictionFilterInput>;
};

export type ListFilterInputTypeOfProductPackageCategoryFilterInput = {
  all?: InputMaybe<ProductPackageCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductPackageCategoryFilterInput>;
  some?: InputMaybe<ProductPackageCategoryFilterInput>;
};

export type ListFilterInputTypeOfProductPackageSetFilterInput = {
  all?: InputMaybe<ProductPackageSetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductPackageSetFilterInput>;
  some?: InputMaybe<ProductPackageSetFilterInput>;
};

export type ListFilterInputTypeOfProductPackageSetPriceVariantFilterInput = {
  all?: InputMaybe<ProductPackageSetPriceVariantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductPackageSetPriceVariantFilterInput>;
  some?: InputMaybe<ProductPackageSetPriceVariantFilterInput>;
};

export type ListFilterInputTypeOfProductSetAssignedActivityFilterInput = {
  all?: InputMaybe<ProductSetAssignedActivityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductSetAssignedActivityFilterInput>;
  some?: InputMaybe<ProductSetAssignedActivityFilterInput>;
};

export type ListFilterInputTypeOfProductSetBrandlineFilterInput = {
  all?: InputMaybe<ProductSetBrandlineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductSetBrandlineFilterInput>;
  some?: InputMaybe<ProductSetBrandlineFilterInput>;
};

export type ListFilterInputTypeOfProductSetFilterInput = {
  all?: InputMaybe<ProductSetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductSetFilterInput>;
  some?: InputMaybe<ProductSetFilterInput>;
};

export type ListFilterInputTypeOfProductSetInfoFilterInput = {
  all?: InputMaybe<ProductSetInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductSetInfoFilterInput>;
  some?: InputMaybe<ProductSetInfoFilterInput>;
};

export type ListFilterInputTypeOfProductSetProductFilterInput = {
  all?: InputMaybe<ProductSetProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductSetProductFilterInput>;
  some?: InputMaybe<ProductSetProductFilterInput>;
};

export type ListFilterInputTypeOfProductSetRestrictionFilterInput = {
  all?: InputMaybe<ProductSetRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductSetRestrictionFilterInput>;
  some?: InputMaybe<ProductSetRestrictionFilterInput>;
};

export type ListFilterInputTypeOfProjectActivityCostFilterInput = {
  all?: InputMaybe<ProjectActivityCostFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectActivityCostFilterInput>;
  some?: InputMaybe<ProjectActivityCostFilterInput>;
};

export type ListFilterInputTypeOfProjectAssignedActivityFilterInput = {
  all?: InputMaybe<ProjectAssignedActivityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectAssignedActivityFilterInput>;
  some?: InputMaybe<ProjectAssignedActivityFilterInput>;
};

export type ListFilterInputTypeOfProjectBrandFilterInput = {
  all?: InputMaybe<ProjectBrandFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectBrandFilterInput>;
  some?: InputMaybe<ProjectBrandFilterInput>;
};

export type ListFilterInputTypeOfProjectDefaultProductSetFilterInput = {
  all?: InputMaybe<ProjectDefaultProductSetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectDefaultProductSetFilterInput>;
  some?: InputMaybe<ProjectDefaultProductSetFilterInput>;
};

export type ListFilterInputTypeOfProjectDossierContactFilterInput = {
  all?: InputMaybe<ProjectDossierContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectDossierContactFilterInput>;
  some?: InputMaybe<ProjectDossierContactFilterInput>;
};

export type ListFilterInputTypeOfProjectProductPackageFilterInput = {
  all?: InputMaybe<ProjectProductPackageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectProductPackageFilterInput>;
  some?: InputMaybe<ProjectProductPackageFilterInput>;
};

export type ListFilterInputTypeOfProjectProductReturnPriceFilterInput = {
  all?: InputMaybe<ProjectProductReturnPriceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectProductReturnPriceFilterInput>;
  some?: InputMaybe<ProjectProductReturnPriceFilterInput>;
};

export type ListFilterInputTypeOfProjectStyleFilterInput = {
  all?: InputMaybe<ProjectStyleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectStyleFilterInput>;
  some?: InputMaybe<ProjectStyleFilterInput>;
};

export type ListFilterInputTypeOfRealEstateContactFilterInput = {
  all?: InputMaybe<RealEstateContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RealEstateContactFilterInput>;
  some?: InputMaybe<RealEstateContactFilterInput>;
};

export type ListFilterInputTypeOfRealEstateContactNotificationFilterInput = {
  all?: InputMaybe<RealEstateContactNotificationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RealEstateContactNotificationFilterInput>;
  some?: InputMaybe<RealEstateContactNotificationFilterInput>;
};

export type ListFilterInputTypeOfRealEstateExternalActionFilterInput = {
  all?: InputMaybe<RealEstateExternalActionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RealEstateExternalActionFilterInput>;
  some?: InputMaybe<RealEstateExternalActionFilterInput>;
};

export type ListFilterInputTypeOfRealEstateFilterInput = {
  all?: InputMaybe<RealEstateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RealEstateFilterInput>;
  some?: InputMaybe<RealEstateFilterInput>;
};

export type ListFilterInputTypeOfRequestFor3DDrawingFilterInput = {
  all?: InputMaybe<RequestFor3DDrawingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestFor3DDrawingFilterInput>;
  some?: InputMaybe<RequestFor3DDrawingFilterInput>;
};

export type ListFilterInputTypeOfRequestForContactFilterInput = {
  all?: InputMaybe<RequestForContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestForContactFilterInput>;
  some?: InputMaybe<RequestForContactFilterInput>;
};

export type ListFilterInputTypeOfRequestForContactStatusUpdateFilterInput = {
  all?: InputMaybe<RequestForContactStatusUpdateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestForContactStatusUpdateFilterInput>;
  some?: InputMaybe<RequestForContactStatusUpdateFilterInput>;
};

export type ListFilterInputTypeOfRequestForCustomOfferFilterInput = {
  all?: InputMaybe<RequestForCustomOfferFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestForCustomOfferFilterInput>;
  some?: InputMaybe<RequestForCustomOfferFilterInput>;
};

export type ListFilterInputTypeOfRequestForCustomOfferStatusUpdateFilterInput = {
  all?: InputMaybe<RequestForCustomOfferStatusUpdateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestForCustomOfferStatusUpdateFilterInput>;
  some?: InputMaybe<RequestForCustomOfferStatusUpdateFilterInput>;
};

export type ListFilterInputTypeOfRequestForQuoteFilterInput = {
  all?: InputMaybe<RequestForQuoteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestForQuoteFilterInput>;
  some?: InputMaybe<RequestForQuoteFilterInput>;
};

export type ListFilterInputTypeOfRequestForTechnicalDrawingFilterInput = {
  all?: InputMaybe<RequestForTechnicalDrawingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RequestForTechnicalDrawingFilterInput>;
  some?: InputMaybe<RequestForTechnicalDrawingFilterInput>;
};

export type ListFilterInputTypeOfRoomFilterInput = {
  all?: InputMaybe<RoomFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RoomFilterInput>;
  some?: InputMaybe<RoomFilterInput>;
};

/** the localization part of the content item */
export type LocalizationInputObjectType = {
  /** the culture of the content item to filter is equal to */
  culture?: InputMaybe<Scalars['String']['input']>;
  /** the culture of the content item to filter contains the string */
  culture_contains?: InputMaybe<Scalars['String']['input']>;
  /** the culture of the content item to filter ends with the string */
  culture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the culture of the content item to filter is in collection */
  culture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the culture of the content item to filter is not equal to */
  culture_not?: InputMaybe<Scalars['String']['input']>;
  /** the culture of the content item to filter does not contain the string */
  culture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the culture of the content item to filter does not end with the string */
  culture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the culture of the content item to filter is not in collection */
  culture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the culture of the content item to filter does not start with the string */
  culture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the culture of the content item to filter starts with the string */
  culture_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization set of the content item to filter */
  localizationSet?: InputMaybe<Scalars['String']['input']>;
};

/** Localization cultures for your content item. */
export type LocalizationPart = {
  __typename?: 'LocalizationPart';
  /** The culture for your content item. */
  culture: Scalars['String']['output'];
  /** The localization set for your content item. */
  localizationSet: Scalars['String']['output'];
  /** The localizations of the content item. */
  localizations?: Maybe<Array<Maybe<ContentItem>>>;
};


/** Localization cultures for your content item. */
export type LocalizationPartLocalizationsArgs = {
  culture?: InputMaybe<Scalars['String']['input']>;
};

export type MediaAsset = {
  __typename?: 'MediaAsset';
  /** The date and time in UTC when the asset was last modified. */
  lastModifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The length of the file. */
  length: Scalars['Long']['output'];
  /** The name of the asset. */
  name: Scalars['String']['output'];
  /** The url to the asset. */
  path?: Maybe<Scalars['String']['output']>;
};

export type MediaField = {
  __typename?: 'MediaField';
  /** the media paths */
  paths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** the absolute urls of the media items */
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MediaFieldPathsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaFieldUrlsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageBaseDto = {
  content: Scalars['String']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isPublic: Scalars['Boolean']['output'];
  operationId?: Maybe<Scalars['UUID']['output']>;
  operationType: OperationType;
  parentId?: Maybe<Scalars['UUID']['output']>;
  realEstateId: Scalars['UUID']['output'];
  sender: Scalars['String']['output'];
  senderRole: Scalars['String']['output'];
  status: MessageStatus;
};

export type MessageDto = MessageBaseDto & {
  __typename?: 'MessageDto';
  content: Scalars['String']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isPublic: Scalars['Boolean']['output'];
  operationId?: Maybe<Scalars['UUID']['output']>;
  operationType: OperationType;
  parentId?: Maybe<Scalars['UUID']['output']>;
  realEstate?: Maybe<RealEstate>;
  realEstateId: Scalars['UUID']['output'];
  sender: Scalars['String']['output'];
  senderRole: Scalars['String']['output'];
  status: MessageStatus;
};


export type MessageDtoRealEstateArgs = {
  where?: InputMaybe<RealEstateFilterInput>;
};

export enum MessageStatus {
  Closed = 'CLOSED',
  New = 'NEW',
  Pending = 'PENDING'
}

/** Money object represents money (currency and value). */
export type Money = {
  __typename?: 'Money';
  /** Gets the amount of money in the currency. */
  amount: Scalars['Decimal']['output'];
  /** Gets the currency of the money. */
  currency: Currency;
};

/** Money object represents money (currency and value). */
export type MoneyFilterInput = {
  /** Gets the amount of money in the currency. */
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<MoneyFilterInput>>;
  /** Gets the currency of the money. */
  currency?: InputMaybe<CurrencyOperationFilterInput>;
  or?: InputMaybe<Array<MoneyFilterInput>>;
};

/** Money object represents money (currency and value). */
export type MoneyInput = {
  /** Gets the amount of money in the currency. */
  amount: Scalars['Decimal']['input'];
  /** Gets the currency of the money. */
  currency: Currency;
};

/** Money object represents money (currency and value). */
export type MoneySortInput = {
  /** Gets the amount of money in the currency. */
  amount?: InputMaybe<SortEnumType>;
  /** Gets the currency of the money. */
  currency?: InputMaybe<SortEnumType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCustomOfferRequestAppointment: CustomOfferRequestAppointment;
  addCustomProductSetInfoKey: Scalars['UUID']['output'];
  addManualProduct: Product;
  addOrUpdateProjects: AddOrUpdateProjectsResponseType;
  addProductPackageFavourite: Scalars['Boolean']['output'];
  addToMySelection: Array<RealEstateRoomSelection>;
  assignAssigneeToContactRequest: Scalars['Boolean']['output'];
  assignBrandToProject: ProjectBrand;
  assignDrawerTo3DDrawing: Scalars['Boolean']['output'];
  assignDrawerToTechnicalDrawing: Scalars['Boolean']['output'];
  assignProductPackageToProject: ProjectProductPackage;
  assignSingleBrandToProject: ProjectBrand;
  assignSingleProductPackageToProject: ProjectProductPackage;
  assignStyleToProject: ProjectStyle;
  cancel3DDrawingForRoomSelection: Scalars['Boolean']['output'];
  cancelCustomOfferChangeRequest: Scalars['UUID']['output'];
  cancelCustomOfferRequest: Scalars['Boolean']['output'];
  cancelTechnicalDrawing: Scalars['Boolean']['output'];
  checkCustomOfferForProject: Scalars['Boolean']['output'];
  checkCustomOfferFromMySelection: Array<RealEstateCustomOfferSelection>;
  checkMySelection: Array<RealEstateRoomSelection>;
  checkUseReturnPriceCalculationForProject: Scalars['Boolean']['output'];
  closeProject: Project;
  completeCustomOfferRequest: Scalars['UUID']['output'];
  copyBrand: Scalars['UUID']['output'];
  copyDesignPackageToRooms: Array<DesignPackage>;
  copyProductPackage: Scalars['UUID']['output'];
  copyProductSet: Scalars['UUID']['output'];
  copyStyle: Scalars['UUID']['output'];
  createActivityTemplate: ActivityTemplate;
  createBrand: Brand;
  createCustomOffer: CustomOffer;
  createDesignPackage: Scalars['UUID']['output'];
  createNote: Scalars['UUID']['output'];
  createProductCategory: ProductCategory;
  createProductPackage: ProductPackage;
  createProductSet: Scalars['UUID']['output'];
  createProductSetBrandline: ProductSetBrandline;
  createRoom: Scalars['UUID']['output'];
  createStyle: Style;
  deleteActivityTemplate: Scalars['Boolean']['output'];
  deleteBrand: Scalars['Boolean']['output'];
  deleteCustomOffer: Scalars['Boolean']['output'];
  deleteCustomOfferRequestAppointment: Scalars['Boolean']['output'];
  deleteDesignPackage: Scalars['Boolean']['output'];
  deleteProductPackage: Scalars['Boolean']['output'];
  deleteProductSet: Scalars['Boolean']['output'];
  deleteProductSetBrandline: Scalars['Boolean']['output'];
  deleteProductSetInfoKey: Scalars['Boolean']['output'];
  deleteProject: Scalars['Boolean']['output'];
  deleteRealEstateFile: Scalars['Boolean']['output'];
  deleteRoom: Scalars['Boolean']['output'];
  deleteStyle: Scalars['Boolean']['output'];
  endProject: Project;
  endRealEstateExternalAction: Scalars['Boolean']['output'];
  endRequestForContact: Scalars['Boolean']['output'];
  enrichProject: Project;
  forceCancel3DDrawingForRoomSelection: Scalars['Boolean']['output'];
  forceRealEstateSelection: Scalars['Boolean']['output'];
  generateVariantDesignPackages: Scalars['Boolean']['output'];
  openRealEstateExternalAction: RealEstateExternalAction;
  processImportProductPackage: Scalars['Boolean']['output'];
  projectActivityTemplateImport: Array<ProjectAssignedActivity>;
  publishProject: Project;
  reOpenCustomOfferRequest: Scalars['Boolean']['output'];
  removeFromMySelection: Array<RealEstateRoomSelection>;
  removeProductPackageFavourite: Scalars['Boolean']['output'];
  request3DDrawingForRoomSelection: Array<RealEstateRoomSelection>;
  requestChangesCustomOffer: Scalars['Boolean']['output'];
  requestForContact: Scalars['UUID']['output'];
  requestForContactUnauthenticated: Scalars['UUID']['output'];
  requestForCustomOffer: RequestForCustomOffer;
  resetDesignPackageSelection: Scalars['Boolean']['output'];
  resetProjectStatus: Project;
  resetRealEstateSelections: Scalars['Boolean']['output'];
  resetUserPassword: Scalars['Boolean']['output'];
  resolveSharedWaitingCustomOffer: Scalars['Boolean']['output'];
  saveCustomOffer: CustomOffer;
  saveDesignPackages: Scalars['Decimal']['output'];
  saveStandardSelection: Scalars['Decimal']['output'];
  selectCustomDesignPackage: Scalars['Boolean']['output'];
  selectStandardDesignPackage: Scalars['Boolean']['output'];
  sendInvitation: Scalars['Boolean']['output'];
  sendInvitationToRealEstates: Scalars['Boolean']['output'];
  sendNoLoginNotification: Scalars['Boolean']['output'];
  sendNoQuoteNotification: Scalars['Boolean']['output'];
  sendNotification: Scalars['Boolean']['output'];
  sendRealEstateDossier: Scalars['Boolean']['output'];
  sendRealEstateQuote: Scalars['Boolean']['output'];
  setProductSetAvailability: Scalars['Boolean']['output'];
  setUserPassword: Scalars['Boolean']['output'];
  syncSelectionsCost: Scalars['Boolean']['output'];
  unassignBrandFromProject: Scalars['Boolean']['output'];
  unassignProductPackageFromProject: Scalars['Boolean']['output'];
  unassignStyleFromProject: Scalars['Boolean']['output'];
  uncheckCustomOfferFromMySelection: Array<RealEstateCustomOfferSelection>;
  uncheckMySelection: Array<RealEstateRoomSelection>;
  updateActivityTemplate: ActivityTemplateActivity;
  updateActivityTemplateName: Scalars['UUID']['output'];
  updateCustomOfferRequest: RequestForCustomOffer;
  updateCustomOfferRequestAppointment: CustomOfferRequestAppointment;
  updateCustomOfferShared: CustomOffer;
  updateDesignPackage: Scalars['UUID']['output'];
  updateImportProductPackage: ImportProductPackage;
  updateMultipleProductSetPrices: Array<Scalars['UUID']['output']>;
  updateProduct: Scalars['UUID']['output'];
  updateProductPackage: Scalars['UUID']['output'];
  updateProductPackageCategory: ProductPackageCategory;
  updateProductReturnPrice: Scalars['Boolean']['output'];
  updateProductSet: Scalars['UUID']['output'];
  updateProductSetInfoKey: Scalars['UUID']['output'];
  updateProjectActivityCosts: ProjectAssignedActivity;
  updateProjectBrands: Scalars['UUID']['output'];
  updateProjectCostSettings: Scalars['UUID']['output'];
  updateProjectDossierContacts: Array<ProjectDossierContact>;
  updateProjectStyles: Scalars['UUID']['output'];
  updateRealEstateExternalAction: RealEstateExternalAction;
  updateRealEstateNotificationsState: Scalars['Boolean']['output'];
  updateRoom: Scalars['UUID']['output'];
  updatesProductCategory: Scalars['UUID']['output'];
};


export type MutationAddCustomOfferRequestAppointmentArgs = {
  appointmentDate: Scalars['DateTime']['input'];
  appointmentType: CustomOfferAppointmentType;
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationAddCustomProductSetInfoKeyArgs = {
  dutchLabel: Scalars['String']['input'];
  englishLabel: Scalars['String']['input'];
  isDisplayable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddManualProductArgs = {
  priceType: ProjectActivityTarget;
  productCode: Scalars['String']['input'];
  productDescription: Scalars['String']['input'];
  productPriceEuros: Scalars['Decimal']['input'];
  productSupplierCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddOrUpdateProjectsArgs = {
  addOrUpdateProjectsInputType: AddOrUpdateProjectsInputTypeInput;
};


export type MutationAddProductPackageFavouriteArgs = {
  productPackageId: Scalars['UUID']['input'];
  productSetId: Scalars['UUID']['input'];
};


export type MutationAddToMySelectionArgs = {
  requestAddToSelectionItems: Array<RequestForQuoteAddToRoomSelectionDtoInput>;
};


export type MutationAssignAssigneeToContactRequestArgs = {
  assigneeId: Scalars['String']['input'];
  messageId: Scalars['UUID']['input'];
};


export type MutationAssignBrandToProjectArgs = {
  brandId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationAssignDrawerTo3DDrawingArgs = {
  drawerId: Scalars['String']['input'];
  requestId: Scalars['UUID']['input'];
};


export type MutationAssignDrawerToTechnicalDrawingArgs = {
  drawerId: Scalars['String']['input'];
  requestId: Scalars['UUID']['input'];
};


export type MutationAssignProductPackageToProjectArgs = {
  productPackageId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationAssignSingleBrandToProjectArgs = {
  brandId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationAssignSingleProductPackageToProjectArgs = {
  productPackageId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationAssignStyleToProjectArgs = {
  projectId: Scalars['UUID']['input'];
  styleId: Scalars['UUID']['input'];
};


export type MutationCancel3DDrawingForRoomSelectionArgs = {
  request3DDrawingId: Scalars['UUID']['input'];
};


export type MutationCancelCustomOfferChangeRequestArgs = {
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationCancelCustomOfferRequestArgs = {
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationCancelTechnicalDrawingArgs = {
  notes: Scalars['String']['input'];
  requestTechnicalDrawingId: Scalars['UUID']['input'];
};


export type MutationCheckCustomOfferForProjectArgs = {
  isActive: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationCheckCustomOfferFromMySelectionArgs = {
  selectionId: Scalars['UUID']['input'];
};


export type MutationCheckMySelectionArgs = {
  requestUpdateRoomSelections: Array<RequestForQuoteUpdateFromRoomSelectionDtoInput>;
};


export type MutationCheckUseReturnPriceCalculationForProjectArgs = {
  isActive: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationCloseProjectArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationCompleteCustomOfferRequestArgs = {
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationCopyBrandArgs = {
  brandId: Scalars['UUID']['input'];
  brandName: Scalars['String']['input'];
};


export type MutationCopyDesignPackageToRoomsArgs = {
  designPackageId: Scalars['UUID']['input'];
  roomIds: Array<Scalars['UUID']['input']>;
};


export type MutationCopyProductPackageArgs = {
  name: Scalars['String']['input'];
  productPackageId: Scalars['UUID']['input'];
};


export type MutationCopyProductSetArgs = {
  name: Scalars['String']['input'];
  productCombinationId: Scalars['UUID']['input'];
  productPackageId: Scalars['UUID']['input'];
  productSetId: Scalars['UUID']['input'];
};


export type MutationCopyStyleArgs = {
  styleId: Scalars['UUID']['input'];
  styleName: Scalars['String']['input'];
};


export type MutationCreateActivityTemplateArgs = {
  activityTemplateName: Scalars['String']['input'];
};


export type MutationCreateBrandArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateCustomOfferArgs = {
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationCreateDesignPackageArgs = {
  brandId: Scalars['UUID']['input'];
  designPackageDefaults?: InputMaybe<Array<AddDefaultProductSetDtoInput>>;
  designPackageName: Scalars['String']['input'];
  designPackagePreselected?: InputMaybe<Array<AddPreselectedProductSetDtoInput>>;
  designPackageRestrictionValues?: InputMaybe<Array<TupleOfGuidAndStringInput>>;
  designPackageWalls?: InputMaybe<Array<DesignPackageWallDtoInput>>;
  hasBath: Scalars['Boolean']['input'];
  hasBathtub?: InputMaybe<Scalars['Boolean']['input']>;
  hasFountain?: InputMaybe<Scalars['Boolean']['input']>;
  hasRadiator?: InputMaybe<Scalars['Boolean']['input']>;
  hasShower?: InputMaybe<Scalars['Boolean']['input']>;
  hasTiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasToilet?: InputMaybe<Scalars['Boolean']['input']>;
  hasToiletLabel: Scalars['Boolean']['input'];
  hasUtilities?: InputMaybe<Scalars['Boolean']['input']>;
  hasWashbasin?: InputMaybe<Scalars['Boolean']['input']>;
  isStandard: Scalars['Boolean']['input'];
  isTilesToCeiling: IsTilesToCeiling;
  isXL: Scalars['Boolean']['input'];
  position: Scalars['Int']['input'];
  priceAmount: Scalars['String']['input'];
  priceCurrency: Currency;
  priceDetails: Array<TupleOfCostTypeAndStringInput>;
  productPackageId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
  roomId: Scalars['UUID']['input'];
  styleId: Scalars['UUID']['input'];
};


export type MutationCreateNoteArgs = {
  note: Scalars['String']['input'];
  realEstateId: Scalars['UUID']['input'];
};


export type MutationCreateProductCategoryArgs = {
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  productCombinationId: Scalars['UUID']['input'];
};


export type MutationCreateProductPackageArgs = {
  name: Scalars['String']['input'];
  productPackageType: ProjectTypeEnum;
};


export type MutationCreateProductSetArgs = {
  activities: Array<TupleOfGuidAndNullableOfBooleanInput>;
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priceVariants: Array<TupleOfGuidAndPriceVariantInput>;
  productCodes: Array<TupleOfStringAndBooleanInput>;
  productPackageCategoryId: Scalars['UUID']['input'];
  productSetBrandlineId?: InputMaybe<Scalars['UUID']['input']>;
  productSetInfoValues: Array<TupleOfGuidAndStringInput>;
};


export type MutationCreateProductSetBrandlineArgs = {
  brandlineName: Scalars['String']['input'];
  categoryId: Scalars['UUID']['input'];
};


export type MutationCreateRoomArgs = {
  layoutIds: Array<Scalars['UUID']['input']>;
  projectId: Scalars['UUID']['input'];
  roomName: Scalars['String']['input'];
  roomPosition: Scalars['Int']['input'];
};


export type MutationCreateStyleArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteActivityTemplateArgs = {
  activityTemplateId: Scalars['UUID']['input'];
};


export type MutationDeleteBrandArgs = {
  brandId: Scalars['UUID']['input'];
};


export type MutationDeleteCustomOfferArgs = {
  customOfferId: Scalars['UUID']['input'];
};


export type MutationDeleteCustomOfferRequestAppointmentArgs = {
  customOfferRequestAppointmentId: Scalars['UUID']['input'];
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationDeleteDesignPackageArgs = {
  designPackageId: Scalars['UUID']['input'];
};


export type MutationDeleteProductPackageArgs = {
  productPackageId: Scalars['UUID']['input'];
};


export type MutationDeleteProductSetArgs = {
  id: Scalars['UUID']['input'];
  productPackageCategoryId: Scalars['UUID']['input'];
};


export type MutationDeleteProductSetBrandlineArgs = {
  productSetBrandlineId: Scalars['UUID']['input'];
};


export type MutationDeleteProductSetInfoKeyArgs = {
  productSetInfoKeyId: Scalars['UUID']['input'];
};


export type MutationDeleteProjectArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationDeleteRealEstateFileArgs = {
  fileName: Scalars['String']['input'];
  realEstateId: Scalars['UUID']['input'];
};


export type MutationDeleteRoomArgs = {
  roomId: Scalars['UUID']['input'];
};


export type MutationDeleteStyleArgs = {
  styleId: Scalars['UUID']['input'];
};


export type MutationEndProjectArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationEndRealEstateExternalActionArgs = {
  closingNote: Scalars['String']['input'];
  description: Scalars['String']['input'];
  realEstateId: Scalars['UUID']['input'];
  target: RealEstateExternalActionTargetType;
};


export type MutationEndRequestForContactArgs = {
  closingNote: Scalars['String']['input'];
  messageId: Scalars['UUID']['input'];
};


export type MutationEnrichProjectArgs = {
  layoutToCopyFromId: Scalars['UUID']['input'];
  layoutToCopyTowardsId: Scalars['UUID']['input'];
  projectToCopyFromId: Scalars['UUID']['input'];
  projectToCopyTowardsId: Scalars['UUID']['input'];
};


export type MutationForceCancel3DDrawingForRoomSelectionArgs = {
  request3DDrawingId: Scalars['UUID']['input'];
};


export type MutationForceRealEstateSelectionArgs = {
  realEstateId: Scalars['UUID']['input'];
  selectionType: SelectionType;
};


export type MutationGenerateVariantDesignPackagesArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationOpenRealEstateExternalActionArgs = {
  description: Scalars['String']['input'];
  realEstateId: Scalars['UUID']['input'];
  target: RealEstateExternalActionTargetType;
};


export type MutationProcessImportProductPackageArgs = {
  crudAction: CrudAction;
  importProductPackageId: Scalars['UUID']['input'];
  productPackageName: Scalars['String']['input'];
  productSets: Array<ImportProductSetInput>;
};


export type MutationProjectActivityTemplateImportArgs = {
  activityTemplateId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationPublishProjectArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationReOpenCustomOfferRequestArgs = {
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationRemoveFromMySelectionArgs = {
  requestRemoveFromSelectionItems: Array<RequestForQuoteUpdateFromRoomSelectionDtoInput>;
};


export type MutationRemoveProductPackageFavouriteArgs = {
  productPackageId: Scalars['UUID']['input'];
  productSetId: Scalars['UUID']['input'];
};


export type MutationRequest3DDrawingForRoomSelectionArgs = {
  requestUpdateRoomSelections: Array<RequestForQuoteUpdateFromRoomSelectionDtoInput>;
};


export type MutationRequestChangesCustomOfferArgs = {
  changesNotes: Scalars['String']['input'];
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationRequestForContactArgs = {
  contactType: ContactType;
  messageText: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestForContactUnauthenticatedArgs = {
  email: Scalars['String']['input'];
  messageText: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
};


export type MutationRequestForCustomOfferArgs = {
  appointmentType: CustomOfferAppointmentType;
  contactType?: InputMaybe<ContactType>;
  phone?: InputMaybe<Scalars['String']['input']>;
  realEstateId?: InputMaybe<Scalars['UUID']['input']>;
  requestNotes?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationResetDesignPackageSelectionArgs = {
  realEstateId: Scalars['UUID']['input'];
};


export type MutationResetProjectStatusArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationResetRealEstateSelectionsArgs = {
  realEstateId: Scalars['UUID']['input'];
};


export type MutationResetUserPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationResolveSharedWaitingCustomOfferArgs = {
  customOfferRequestId: Scalars['UUID']['input'];
  notes: Scalars['String']['input'];
};


export type MutationSaveCustomOfferArgs = {
  customOfferId: Scalars['UUID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  priceCurrency: Currency;
  rooms: Array<CustomOfferRoomDtoInput>;
  shareWithCustomer: Scalars['Boolean']['input'];
};


export type MutationSaveDesignPackagesArgs = {
  requestForQuoteSelectionItems: Array<RequestForQuoteRoomSelectionItemDtoInput>;
};


export type MutationSaveStandardSelectionArgs = {
  requestForQuoteSelectionItems: Array<RequestForQuoteRoomSelectionItemDtoInput>;
};


export type MutationSelectCustomDesignPackageArgs = {
  designPackageId: Scalars['UUID']['input'];
};


export type MutationSelectStandardDesignPackageArgs = {
  designPackageId: Scalars['UUID']['input'];
};


export type MutationSendInvitationArgs = {
  realEstateId: Scalars['UUID']['input'];
};


export type MutationSendInvitationToRealEstatesArgs = {
  realEstateIds: Array<Scalars['UUID']['input']>;
};


export type MutationSendNoLoginNotificationArgs = {
  realEstateId: Scalars['UUID']['input'];
};


export type MutationSendNoQuoteNotificationArgs = {
  realEstateId: Scalars['UUID']['input'];
};


export type MutationSendNotificationArgs = {
  fromEmailAddress: Scalars['String']['input'];
  fromName?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  toEmailAddress: Scalars['String']['input'];
};


export type MutationSendRealEstateDossierArgs = {
  emailRecipients: Array<Scalars['String']['input']>;
  files: Array<TupleOfStringAndUploadFileTypeInput>;
  realEstateId: Scalars['UUID']['input'];
  resendReasons: Array<Scalars['String']['input']>;
};


export type MutationSendRealEstateQuoteArgs = {
  requestForQuoteGlobalSelectionItems: Array<RequestForQuoteGlobalSelectionItemDtoInput>;
  requestForQuoteRoomSelectionItems: Array<RequestForQuoteRoomSelectionItemDtoInput>;
};


export type MutationSetProductSetAvailabilityArgs = {
  id: Scalars['UUID']['input'];
  isAvailable: Scalars['Boolean']['input'];
  productPackageCategoryId: Scalars['UUID']['input'];
};


export type MutationSetUserPasswordArgs = {
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationUnassignBrandFromProjectArgs = {
  brandId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationUnassignProductPackageFromProjectArgs = {
  productPackageId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationUnassignStyleFromProjectArgs = {
  projectId: Scalars['UUID']['input'];
  styleId: Scalars['UUID']['input'];
};


export type MutationUncheckCustomOfferFromMySelectionArgs = {
  selectionId: Scalars['UUID']['input'];
};


export type MutationUncheckMySelectionArgs = {
  requestUpdateRoomSelections: Array<RequestForQuoteUpdateFromRoomSelectionDtoInput>;
};


export type MutationUpdateActivityTemplateArgs = {
  activityTemplateId: Scalars['UUID']['input'];
  costs: Array<ProjectActivityCostDtoInput>;
  projectActivityId: Scalars['UUID']['input'];
};


export type MutationUpdateActivityTemplateNameArgs = {
  activityTemplateId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateCustomOfferRequestArgs = {
  appointmentType: CustomOfferAppointmentType;
  assignedSpecialistId?: InputMaybe<Scalars['String']['input']>;
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationUpdateCustomOfferRequestAppointmentArgs = {
  appointmentDate: Scalars['DateTime']['input'];
  appointmentType: CustomOfferAppointmentType;
  customOfferRequestAppointmentId: Scalars['UUID']['input'];
  customOfferRequestId: Scalars['UUID']['input'];
};


export type MutationUpdateCustomOfferSharedArgs = {
  customOfferId: Scalars['UUID']['input'];
  isShared: Scalars['Boolean']['input'];
};


export type MutationUpdateDesignPackageArgs = {
  designPackageDefaults?: InputMaybe<Array<AddDefaultProductSetDtoInput>>;
  designPackageId: Scalars['UUID']['input'];
  designPackageName: Scalars['String']['input'];
  designPackagePreselected?: InputMaybe<Array<AddPreselectedProductSetDtoInput>>;
  designPackageRestrictionValues?: InputMaybe<Array<TupleOfGuidAndStringInput>>;
  designPackageWalls?: InputMaybe<Array<DesignPackageWallDtoInput>>;
  hasBath: Scalars['Boolean']['input'];
  hasBathtub?: InputMaybe<Scalars['Boolean']['input']>;
  hasFountain?: InputMaybe<Scalars['Boolean']['input']>;
  hasRadiator?: InputMaybe<Scalars['Boolean']['input']>;
  hasShower?: InputMaybe<Scalars['Boolean']['input']>;
  hasTiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasToilet?: InputMaybe<Scalars['Boolean']['input']>;
  hasToiletLabel: Scalars['Boolean']['input'];
  hasUtilities?: InputMaybe<Scalars['Boolean']['input']>;
  hasWashbasin?: InputMaybe<Scalars['Boolean']['input']>;
  isStandard: Scalars['Boolean']['input'];
  isTilesToCeiling: IsTilesToCeiling;
  isXL: Scalars['Boolean']['input'];
  position: Scalars['Int']['input'];
  priceAmount: Scalars['String']['input'];
  priceCurrency: Currency;
  priceDetails: Array<TupleOfCostTypeAndStringInput>;
  projectId: Scalars['UUID']['input'];
};


export type MutationUpdateImportProductPackageArgs = {
  importProductPackageId: Scalars['UUID']['input'];
  isComplete: Scalars['Boolean']['input'];
  isError: Scalars['Boolean']['input'];
  logInformation?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMultipleProductSetPricesArgs = {
  activities: Array<TupleOfGuidAndNullableOfBooleanInput>;
  brandlineId?: InputMaybe<Scalars['UUID']['input']>;
  productPackageCategoryId: Scalars['UUID']['input'];
  productSetIds: Array<Scalars['UUID']['input']>;
  productSetInfos: Array<TupleOfGuidAndStringInput>;
  shouldReplaceAllActivities: Scalars['Boolean']['input'];
};


export type MutationUpdateProductArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  costPrice: Scalars['Decimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  grossSalesPrice: Scalars['Decimal']['input'];
  isAvailable: Scalars['Boolean']['input'];
  longDescription?: InputMaybe<Scalars['String']['input']>;
  marktingText?: InputMaybe<Scalars['String']['input']>;
  packagingUnits?: InputMaybe<Scalars['Decimal']['input']>;
  priceType: Scalars['String']['input'];
  statusCode: Scalars['Int']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProductPackageArgs = {
  productPackageId: Scalars['UUID']['input'];
  productPackageName: Scalars['String']['input'];
};


export type MutationUpdateProductPackageCategoryArgs = {
  allowPickByBrand: Scalars['Boolean']['input'];
  categoryId: Scalars['UUID']['input'];
  productPackageId: Scalars['UUID']['input'];
};


export type MutationUpdateProductReturnPriceArgs = {
  productCombinationId: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
  returnPrice: Scalars['String']['input'];
};


export type MutationUpdateProductSetArgs = {
  activities: Array<TupleOfGuidAndNullableOfBooleanInput>;
  id: Scalars['UUID']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priceVariants: Array<TupleOfGuidAndPriceVariantInput>;
  productCodes: Array<TupleOfStringAndBooleanInput>;
  productPackageCategoryId: Scalars['UUID']['input'];
  productSetBrandlineId?: InputMaybe<Scalars['UUID']['input']>;
  productSetInfoValues: Array<TupleOfGuidAndStringInput>;
};


export type MutationUpdateProductSetInfoKeyArgs = {
  dutchLabel: Scalars['String']['input'];
  englishLabel: Scalars['String']['input'];
  isDisplayable?: InputMaybe<Scalars['Boolean']['input']>;
  productSetInfoKeyId: Scalars['UUID']['input'];
};


export type MutationUpdateProjectActivityCostsArgs = {
  costs: Array<ProjectActivityCostDtoInput>;
  projectActivityId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationUpdateProjectBrandsArgs = {
  brandIds: Array<Scalars['UUID']['input']>;
  projectId: Scalars['UUID']['input'];
};


export type MutationUpdateProjectCostSettingsArgs = {
  companyMarginSanitary?: InputMaybe<Scalars['String']['input']>;
  companyMarginTiles?: InputMaybe<Scalars['String']['input']>;
  correctionConstructionFactor?: InputMaybe<Scalars['String']['input']>;
  correctionInstallationCVFactor?: InputMaybe<Scalars['String']['input']>;
  correctionInstallationEFactor?: InputMaybe<Scalars['String']['input']>;
  correctionInstallationWFactor?: InputMaybe<Scalars['String']['input']>;
  correctionTilerFactor?: InputMaybe<Scalars['String']['input']>;
  marginBuilder?: InputMaybe<Scalars['String']['input']>;
  marginInstaller?: InputMaybe<Scalars['String']['input']>;
  marginTiler?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['UUID']['input'];
  purchasingSurchargeInstaller?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectDossierContactsArgs = {
  contacts: Array<ProjectDossierContactDtoInput>;
  projectId: Scalars['UUID']['input'];
};


export type MutationUpdateProjectStylesArgs = {
  projectId: Scalars['UUID']['input'];
  styleIds: Array<Scalars['UUID']['input']>;
};


export type MutationUpdateRealEstateExternalActionArgs = {
  description: Scalars['String']['input'];
  realEstateId: Scalars['UUID']['input'];
  target: RealEstateExternalActionTargetType;
};


export type MutationUpdateRealEstateNotificationsStateArgs = {
  enabled: Scalars['Boolean']['input'];
  realEstateId: Scalars['UUID']['input'];
};


export type MutationUpdateRoomArgs = {
  layoutIds: Array<Scalars['UUID']['input']>;
  roomId: Scalars['UUID']['input'];
  roomName: Scalars['String']['input'];
  roomPosition: Scalars['Int']['input'];
};


export type MutationUpdatesProductCategoryArgs = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  productCombinationId: Scalars['UUID']['input'];
  productSetInfoKeys: Array<ProductCategoryPropertyKeyDtoInput>;
};

export type NullableOfContactRequestStatusOperationFilterInput = {
  eq?: InputMaybe<ContactRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<ContactRequestStatus>>>;
  neq?: InputMaybe<ContactRequestStatus>;
  nin?: InputMaybe<Array<InputMaybe<ContactRequestStatus>>>;
};

export type NullableOfContactTypeOperationFilterInput = {
  eq?: InputMaybe<ContactType>;
  in?: InputMaybe<Array<InputMaybe<ContactType>>>;
  neq?: InputMaybe<ContactType>;
  nin?: InputMaybe<Array<InputMaybe<ContactType>>>;
};

export type NullableOfCustomOfferRequestStatusOperationFilterInput = {
  eq?: InputMaybe<CustomOfferRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<CustomOfferRequestStatus>>>;
  neq?: InputMaybe<CustomOfferRequestStatus>;
  nin?: InputMaybe<Array<InputMaybe<CustomOfferRequestStatus>>>;
};

export type NullableOfDrawingRequestStatusOperationFilterInput = {
  eq?: InputMaybe<DrawingRequestStatus>;
  in?: InputMaybe<Array<InputMaybe<DrawingRequestStatus>>>;
  neq?: InputMaybe<DrawingRequestStatus>;
  nin?: InputMaybe<Array<InputMaybe<DrawingRequestStatus>>>;
};

export type NullableOfPriceVariantOperationFilterInput = {
  eq?: InputMaybe<PriceVariant>;
  in?: InputMaybe<Array<InputMaybe<PriceVariant>>>;
  neq?: InputMaybe<PriceVariant>;
  nin?: InputMaybe<Array<InputMaybe<PriceVariant>>>;
};

export type NullableOfProductSetInfoCompareOperationOperationFilterInput = {
  eq?: InputMaybe<ProductSetInfoCompareOperation>;
  in?: InputMaybe<Array<InputMaybe<ProductSetInfoCompareOperation>>>;
  neq?: InputMaybe<ProductSetInfoCompareOperation>;
  nin?: InputMaybe<Array<InputMaybe<ProductSetInfoCompareOperation>>>;
};

export type NullableOfProductSetInfoKeyTypeOperationFilterInput = {
  eq?: InputMaybe<ProductSetInfoKeyType>;
  in?: InputMaybe<Array<InputMaybe<ProductSetInfoKeyType>>>;
  neq?: InputMaybe<ProductSetInfoKeyType>;
  nin?: InputMaybe<Array<InputMaybe<ProductSetInfoKeyType>>>;
};

export type NullableOfProjectTypeOperationFilterInput = {
  eq?: InputMaybe<Badkamercore_ProjectType>;
  in?: InputMaybe<Array<InputMaybe<Badkamercore_ProjectType>>>;
  neq?: InputMaybe<Badkamercore_ProjectType>;
  nin?: InputMaybe<Array<InputMaybe<Badkamercore_ProjectType>>>;
};

export type NullableOfShowroomLocationOperationFilterInput = {
  eq?: InputMaybe<ShowroomLocation>;
  in?: InputMaybe<Array<InputMaybe<ShowroomLocation>>>;
  neq?: InputMaybe<ShowroomLocation>;
  nin?: InputMaybe<Array<InputMaybe<ShowroomLocation>>>;
};

export type OfferDto = {
  __typename?: 'OfferDto';
  endUser2Contact: ContactDto2;
  endUserContact: ContactDto;
  isArchived: Scalars['Boolean']['output'];
  no: Scalars['String']['output'];
  projectNo: Scalars['String']['output'];
  udfBouwdeelOrg: Scalars['String']['output'];
  udfBouwnummer: Scalars['String']['output'];
  udfDatumRuwbouw1?: Maybe<Scalars['DateTime']['output']>;
};

export type OfferDtoInput = {
  endUser2Contact: ContactDto2Input;
  endUserContact: ContactDtoInput;
  isArchived: Scalars['Boolean']['input'];
  no: Scalars['String']['input'];
  projectNo: Scalars['String']['input'];
  udfBouwdeelOrg: Scalars['String']['input'];
  udfBouwnummer: Scalars['String']['input'];
  udfDatumRuwbouw1?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OperationType {
  Contact = 'CONTACT',
  ContactUnauthenticated = 'CONTACT_UNAUTHENTICATED',
  CustomOffer = 'CUSTOM_OFFER',
  DrawingRequest = 'DRAWING_REQUEST',
  ExternalAction = 'EXTERNAL_ACTION',
  Note = 'NOTE'
}

/** Activities information */
export type OrderActivity = {
  __typename?: 'OrderActivity';
  /** Gets or sets the activity identifier. */
  activityId: Scalars['UUID']['output'];
  /** Gets or sets the activity costs. */
  costs: Array<Maybe<CostEntry>>;
};

/** Articles information. */
export type OrderArticle = {
  __typename?: 'OrderArticle';
  /** Gets or sets article identifier. */
  articleId: Scalars['UUID']['output'];
  /** Gets or sets article code. */
  code: Scalars['String']['output'];
  /** Gets or sets article consumer price. */
  consumerPrice?: Maybe<Money>;
  /** Gets or sets article cost price. */
  costPrice?: Maybe<Money>;
  /** Gets or sets article gross sales price. */
  grossSalesPrice?: Maybe<Money>;
  /**
   * Gets or sets article installer price.
   * This could be the price for the installer or tiler.
   * Depending on whether it is a sanitary product or a tile.
   */
  installerPrice?: Maybe<Money>;
  /** Gets or sets article code. */
  name?: Maybe<Scalars['String']['output']>;
  priceType: ProjectActivityTarget;
  /** Gets or sets supplier code. */
  supplierCode?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** the order by direction */
export enum OrderByDirection {
  /** orders content items in ascending order */
  Asc = 'ASC',
  /** orders content items in descending order */
  Desc = 'DESC'
}

/** Represents a Order Confirmation Page. */
export type OrderConfirmationPage = ContentItem & {
  __typename?: 'OrderConfirmationPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** HtmlField */
  bottomContent?: Maybe<HtmlField>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  homeButton?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  image?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Represents a ProjectType. */
  projectType?: Maybe<ProjectType>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type OrderConfirmationPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the OrderConfirmationPage content item filters */
export type OrderConfirmationPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<OrderConfirmationPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<OrderConfirmationPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<OrderConfirmationPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Order global custom offer information. */
export type OrderCustomOffer = {
  __typename?: 'OrderCustomOffer';
  /** Gets or sets confirmed status type. */
  confirmedStatusType: ConfirmedStatusType;
  /** Gets or sets the selection costs. */
  costs: Array<Maybe<CostEntry>>;
  /** Gets or sets the custom offer identifier. */
  customOfferId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the room selection identifier. */
  selectionId: Scalars['UUID']['output'];
  /** Gets or sets room selection name. */
  selectionName: Scalars['String']['output'];
  /** Gets or sets selection type. */
  selectionType: SelectionType;
};

/** Product combination sets information. */
export type OrderProductCombinationSet = {
  __typename?: 'OrderProductCombinationSet';
  /** Gets or sets the product combination costs. */
  costs: Array<Maybe<CostEntry>>;
  name: Scalars['String']['output'];
  /** Gets the combination position. */
  position: Scalars['Int']['output'];
  /** Gets or sets product combination type. */
  productCombinationId: Scalars['UUID']['output'];
  /** Gets or sets product combination type. */
  productCombinationType: ProductCombinationType;
  /** Gets or sets returned product sets information. */
  returnedProductSets: Array<OrderProductSet>;
  /** Gets or sets selected product sets information. */
  selectedProductSets: Array<OrderProductSet>;
};

/** Product sets information. */
export type OrderProductSet = {
  __typename?: 'OrderProductSet';
  /** Gets or sets the product set assigned activities using project's activity costs. */
  activities: Array<OrderActivity>;
  /** Gets or sets the answer yes no. */
  answerYesNo?: Maybe<Scalars['String']['output']>;
  /** Gets or sets the area. */
  area?: Maybe<Scalars['Decimal']['output']>;
  /** Gets or sets articles information. */
  articles: Array<OrderArticle>;
  /**
   * Gets or sets the product set costs. These include all non-installation costs, unless project.DontUseProjectActivityCosts is true,
   * then installation costs are included as well. Else, Activities constitute the installation costs.
   */
  costs: Array<Maybe<CostEntry>>;
  displayableProductSetInfos?: Maybe<Array<Maybe<ProductSetInfo>>>;
  /** Gets or sets the fallback product identifier. */
  fallBackProductId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets a value indicating whether gets or sets is default. */
  isDefault: Scalars['Boolean']['output'];
  /** Gets or sets the is to the ceiling. */
  isToTheCeiling?: Maybe<Scalars['Boolean']['output']>;
  /** Gets or sets the length. */
  length?: Maybe<Scalars['Decimal']['output']>;
  /** Gets or sets the product set name. */
  name: Scalars['String']['output'];
  /** Gets or sets the product category identifier. */
  productCategoryId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the product set name. */
  productSetId: Scalars['UUID']['output'];
  /** Gets or sets the wall identifier. */
  wallId?: Maybe<Scalars['UUID']['output']>;
};


/** Product sets information. */
export type OrderProductSetDisplayableProductSetInfosArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ProductSetInfoSortInput>>;
  where?: InputMaybe<ProductSetInfoFilterInput>;
};

/** Order room information. */
export type OrderRoom = {
  __typename?: 'OrderRoom';
  /** Gets or sets the brand identifier. */
  brandId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the brand name. */
  brandName?: Maybe<Scalars['String']['output']>;
  /** Gets or sets confirmed status type. */
  confirmedStatusType: ConfirmedStatusType;
  /** Gets or sets the selection costs. */
  costs: Array<Maybe<CostEntry>>;
  /** Gets or sets the custom offer identifier. */
  customOfferId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the custom offer version. */
  customOfferVersion?: Maybe<Scalars['Int']['output']>;
  /** Gets or sets design package identifier. */
  designPackageId?: Maybe<Scalars['UUID']['output']>;
  /** Gets position of room. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Gets or sets product combination sets information. */
  productCombinationSets?: Maybe<Array<OrderProductCombinationSet>>;
  /** Gets or sets the product package identifier. */
  productPackageId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the product package name. */
  productPackageName?: Maybe<Scalars['String']['output']>;
  /** Gets or sets room id. */
  roomId: Scalars['UUID']['output'];
  /** Gets or sets room name. */
  roomName: Scalars['String']['output'];
  /** Gets or sets the room selection identifier. */
  selectionId: Scalars['UUID']['output'];
  /** Gets or sets room selection name. */
  selectionName: Scalars['String']['output'];
  /** Gets or sets selection type. */
  selectionType: SelectionType;
  /** Gets or sets the style identifier. */
  styleId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the style name. */
  styleName?: Maybe<Scalars['String']['output']>;
};

/** Contains information about the project overview. */
export type OverviewDto = {
  __typename?: 'OverviewDto';
  /** Gets or sets contains the cost overview specifications. */
  costOverviewSpecifications?: Maybe<Array<KeyValuePairOfCostTypeAndMoney>>;
  /** Gets or sets the products combinations cost overviews. */
  productCombinationCostOverviews?: Maybe<Array<ProductCombinationCostOverviewDto>>;
};

/** PhoneNumber object describes a phone number. */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  /** Gets the phone number. */
  number: Scalars['String']['output'];
};

/** PhoneNumber object describes a phone number. */
export type PhoneNumberFilterInput = {
  and?: InputMaybe<Array<PhoneNumberFilterInput>>;
  /** Gets the phone number. */
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PhoneNumberFilterInput>>;
};

/** PhoneNumber object describes a phone number. */
export type PhoneNumberSortInput = {
  /** Gets the phone number. */
  number?: InputMaybe<SortEnumType>;
};

/** Price variant for Design Packages and Product Sets */
export enum PriceVariant {
  /** Lower price variant. */
  Comfort = 'COMFORT',
  /** Higher price variant. */
  Excellent = 'EXCELLENT',
  /** Intermediate price variant. */
  Premium = 'PREMIUM'
}

export type PriceVariantOperationFilterInput = {
  eq?: InputMaybe<PriceVariant>;
  in?: InputMaybe<Array<PriceVariant>>;
  neq?: InputMaybe<PriceVariant>;
  nin?: InputMaybe<Array<PriceVariant>>;
};

/** Represents a Privacy Policy Page. */
export type PrivacyPolicyPage = ContentItem & {
  __typename?: 'PrivacyPolicyPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** HtmlField */
  content?: Maybe<HtmlField>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type PrivacyPolicyPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the PrivacyPolicyPage content item filters */
export type PrivacyPolicyPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<PrivacyPolicyPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<PrivacyPolicyPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<PrivacyPolicyPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Product item represents a single product that is used in product sets. */
export type Product = {
  __typename?: 'Product';
  /** Gets the brand of the product. */
  brand?: Maybe<Scalars['String']['output']>;
  /** Gets item code */
  code: Scalars['String']['output'];
  /** Gets the cost price of the product. */
  costPrice: Money;
  /** Gets the description of the product. */
  description?: Maybe<Scalars['String']['output']>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the long description of the product. */
  longDescription?: Maybe<Scalars['String']['output']>;
  /** Gets the marketing text of the product. */
  marketingText?: Maybe<Scalars['String']['output']>;
  /** Gets the amount of m2/m1 per unit in a package of the product */
  packagingUnits?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the price type. */
  priceType: ProjectActivityTarget;
  /** Gets the status code of the product. */
  statusCode: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['URL']['output']>;
};

/** Represents a Product Brand Line Details. */
export type ProductBrandLineDetails = ContentItem & {
  __typename?: 'ProductBrandLineDetails';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  detailsLink?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  images?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type ProductBrandLineDetailsOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ProductBrandLineDetails content item filters */
export type ProductBrandLineDetailsWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ProductBrandLineDetailsWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ProductBrandLineDetailsWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ProductBrandLineDetailsWhereInput>>>;
  /** the alias part of the content item */
  alias?: InputMaybe<AliasPartInput>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/**
 * ProductCategory represents a category of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCategory
 */
export type ProductCategory = {
  __typename?: 'ProductCategory';
  /** Gets the brand lines assigned to this category. */
  assignedBrandlines?: Maybe<Array<Maybe<ProductSetBrandline>>>;
  /** Gets the collection of ProductCategoryProductSetInfoKey objects that belongs to this category. */
  assignedProductCategoryProductSetInfoKeys?: Maybe<Array<Maybe<ProductCategoryProductSetInfoKey>>>;
  /**
   * Gets the header of the brandline.
   * @deprecated This field was replaced by content in CMS
   */
  brandlineHeader: Scalars['String']['output'];
  /** @deprecated This field was replaced by content in CMS */
  categoryBrandlineHeader: Scalars['String']['output'];
  /** @deprecated This field was replaced by content in CMS */
  categoryName: Scalars['String']['output'];
  /** @deprecated This field was replaced by content in CMS */
  categoryTitle: Scalars['String']['output'];
  /** Gets a value indicating whether the ProductCategory has a Yes/No question. */
  hasYesNoQuestion: Scalars['Boolean']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  isAccentTiles: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the ProductCategory is the accent wall tiles category. */
  isAccentWallTiles: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the ProductCategory is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the ProductCategory selection is optional. */
  isSelectionOptional: Scalars['Boolean']['output'];
  isToTheCeiling: Scalars['Boolean']['output'];
  /** Gets the additional ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromAdditionalCategory?: Maybe<ProductCategory>;
  /** Gets the identifier of the additional ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromAdditionalCategoryId?: Maybe<Scalars['UUID']['output']>;
  /** Gets the ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromCategory?: Maybe<ProductCategory>;
  /** Gets the identifier of the ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromCategoryId?: Maybe<Scalars['UUID']['output']>;
  /** Gets the name of the product combination. */
  name: Scalars['String']['output'];
  /** Gets the identifier of the ProductSet that is the No Product for this Category. */
  noProductProductSetId?: Maybe<Scalars['UUID']['output']>;
  /** Gets the integer by which the ProductCombination should be ordered when displaying. */
  position: Scalars['Int']['output'];
  /** Gets the ProductCombination the Category is attached. */
  productCombination?: Maybe<ProductCombination>;
  /**
   * Gets the title of the product category.
   * @deprecated This field was replaced by content in CMS
   */
  title: Scalars['String']['output'];
  /**
   * Gets the translated header of the BrandlineHeader.
   * @deprecated This field was replaced by content in CMS
   */
  translatedBrandlineHeader?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the translated name of the product category.
   * @deprecated This field was replaced by content in CMS
   */
  translatedName?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the translated title of the product category.
   * @deprecated This field was replaced by content in CMS
   */
  translatedTitle?: Maybe<Scalars['String']['output']>;
};


/**
 * ProductCategory represents a category of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCategory
 */
export type ProductCategoryAssignedProductCategoryProductSetInfoKeysArgs = {
  order?: InputMaybe<Array<ProductCategoryProductSetInfoKeySortInput>>;
  where?: InputMaybe<ProductCategoryProductSetInfoKeyFilterInput>;
};


/**
 * ProductCategory represents a category of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCategory
 */
export type ProductCategoryCategoryBrandlineHeaderArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * ProductCategory represents a category of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCategory
 */
export type ProductCategoryCategoryNameArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * ProductCategory represents a category of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCategory
 */
export type ProductCategoryCategoryTitleArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * ProductCategory represents a category of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCategory
 */
export type ProductCategoryFilterInput = {
  and?: InputMaybe<Array<ProductCategoryFilterInput>>;
  /** Gets the brand lines assigned to this category. */
  assignedBrandlines?: InputMaybe<ListFilterInputTypeOfProductSetBrandlineFilterInput>;
  /** Gets the collection of ProductCategoryProductSetInfoKey objects that belongs to this category. */
  assignedProductCategoryProductSetInfoKeys?: InputMaybe<ListFilterInputTypeOfProductCategoryProductSetInfoKeyFilterInput>;
  /** Gets the collection of ProductSetRestriction objects that compose this category. */
  assignedProductSetRestrictions?: InputMaybe<ListFilterInputTypeOfProductSetRestrictionFilterInput>;
  /** Gets the header of the brandline. */
  brandlineHeader?: InputMaybe<StringOperationFilterInput>;
  /** Gets a value indicating whether the ProductCategory has a Yes/No question. */
  hasYesNoQuestion?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the ProductCategory is the accent wall tiles category. */
  isAccentWallTiles?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the ProductCategory is hidden. */
  isHidden?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the ProductCategory selection is optional. */
  isSelectionOptional?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the additional ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromAdditionalCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the identifier of the additional ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromAdditionalCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the identifier of the ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the name of the product combination. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Gets the ProductSet that is the No Product Needed for this Category. */
  noProductNeededProductSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the identifier of the ProductSet that is the No Product Needed for this Category. */
  noProductNeededProductSetId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the ProductSet that is the No Product for this Category. */
  noProductProductSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the identifier of the ProductSet that is the No Product for this Category. */
  noProductProductSetId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProductCategoryFilterInput>>;
  /** Gets the integer by which the ProductCombination should be ordered when displaying. */
  position?: InputMaybe<IntOperationFilterInput>;
  /** Gets the ProductCombination the Category is attached. */
  productCombination?: InputMaybe<ProductCombinationFilterInput>;
  /** Gets the identifier of the ProductCombination the Category is attached. */
  productCombinationId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the title of the product category. */
  title?: InputMaybe<StringOperationFilterInput>;
  /** Gets the translated header of the BrandlineHeader. */
  translatedBrandlineHeader?: InputMaybe<StringOperationFilterInput>;
  /** Gets the translated name of the product category. */
  translatedName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the translated title of the product category. */
  translatedTitle?: InputMaybe<StringOperationFilterInput>;
  /** Gets the ProductSet that is the "No" answer to a YesNoQuestion. */
  yesNoQuestionNoProductSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the identifier of the ProductSet that is the "No" answer to a YesNoQuestion. */
  yesNoQuestionNoProductSetId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the ProductSet that is the "Yes" answer to a YesNoQuestion. */
  yesNoQuestionYesProductSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the identifier of the ProductSet that is the "Yes" answer to a YesNoQuestion. */
  yesNoQuestionYesProductSetId?: InputMaybe<UuidOperationFilterInput>;
};

/** ProductCategoryProductSetInfoKey represents a valid key of information about a single ProductSet item of a ProductCategory. */
export type ProductCategoryProductSetInfoKey = {
  __typename?: 'ProductCategoryProductSetInfoKey';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets a value indicating whether the property can be displayed to Customer. */
  isDisplayable: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the property can be used for filtering. */
  isFilterable: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the property is optional. */
  isOptional: Scalars['Boolean']['output'];
  /** Gets the integer by which the Category InfoKey should be ordered when displaying. */
  position: Scalars['Int']['output'];
  productCategory: ProductCategory;
  /** Gets or sets the product set information key of the relation. */
  productSetInfoKey: ProductSetInfoKey;
};


/** ProductCategoryProductSetInfoKey represents a valid key of information about a single ProductSet item of a ProductCategory. */
export type ProductCategoryProductSetInfoKeyProductCategoryArgs = {
  order?: InputMaybe<Array<ProductCategorySortInput>>;
  where?: InputMaybe<ProductCategoryFilterInput>;
};


/** ProductCategoryProductSetInfoKey represents a valid key of information about a single ProductSet item of a ProductCategory. */
export type ProductCategoryProductSetInfoKeyProductSetInfoKeyArgs = {
  where?: InputMaybe<ProductSetInfoKeyFilterInput>;
};

/** ProductCategoryProductSetInfoKey represents a valid key of information about a single ProductSet item of a ProductCategory. */
export type ProductCategoryProductSetInfoKeyFilterInput = {
  and?: InputMaybe<Array<ProductCategoryProductSetInfoKeyFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the property can be displayed to Customer. */
  isDisplayable?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the property can be used for filtering. */
  isFilterable?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the property is optional. */
  isOptional?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductCategoryProductSetInfoKeyFilterInput>>;
  /** Gets the integer by which the Category InfoKey should be ordered when displaying. */
  position?: InputMaybe<IntOperationFilterInput>;
  /** Gets or sets the product combination of the relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the product category id of the relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the product set information key of the relation. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeyFilterInput>;
  /** Gets the product set information key id of the relation. */
  productSetInfoKeyId?: InputMaybe<UuidOperationFilterInput>;
};

/** ProductCategoryProductSetInfoKey represents a valid key of information about a single ProductSet item of a ProductCategory. */
export type ProductCategoryProductSetInfoKeySortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the property can be displayed to Customer. */
  isDisplayable?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the property can be used for filtering. */
  isFilterable?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the property is optional. */
  isOptional?: InputMaybe<SortEnumType>;
  /** Gets the integer by which the Category InfoKey should be ordered when displaying. */
  position?: InputMaybe<SortEnumType>;
  /** Gets or sets the product combination of the relation. */
  productCategory?: InputMaybe<ProductCategorySortInput>;
  /** Gets the product category id of the relation. */
  productCategoryId?: InputMaybe<SortEnumType>;
  /** Gets or sets the product set information key of the relation. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeySortInput>;
  /** Gets the product set information key id of the relation. */
  productSetInfoKeyId?: InputMaybe<SortEnumType>;
};

/** Contains information about a single ProductSetInfoKey assigned to a ProductCategory. */
export type ProductCategoryPropertyKeyDtoInput = {
  /** Gets a value indicating whether the property can be displayed to Customer. */
  isDisplayable: Scalars['Boolean']['input'];
  /** Gets a value indicating whether the property can be used for filtering. */
  isFilterable: Scalars['Boolean']['input'];
  /** Gets a value indicating whether the property is optional. */
  isOptional: Scalars['Boolean']['input'];
  /** Gets the integer by which the Category InfoKey should be ordered when displaying. */
  position: Scalars['Int']['input'];
  /** Gets the ProductCategoryProductSetInfoKey identifier. */
  productCategoryProductSetInfoKeyId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets the ProductSetInfoKey identifier. */
  productSetInfoKeyId: Scalars['UUID']['input'];
};

/** Contains information about the selected product category and product set. */
export type ProductCategorySet = {
  __typename?: 'ProductCategorySet';
  /** Gets or sets the id of the product category. */
  productCategoryId: Scalars['UUID']['output'];
  /** Gets or sets the id of the product set. */
  productSetId: Scalars['UUID']['output'];
  /** Gets or sets the wall identifier where the selected ProductSet will be placed. */
  wallId?: Maybe<Scalars['UUID']['output']>;
};

/** Contains information about the selected product category and product set. */
export type ProductCategorySetInput = {
  /** Gets or sets the id of the product category. */
  productCategoryId: Scalars['UUID']['input'];
  /** Gets or sets the id of the product set. */
  productSetId: Scalars['UUID']['input'];
  /** Gets or sets the wall identifier where the selected ProductSet will be placed. */
  wallId?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * ProductCategory represents a category of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCategory
 */
export type ProductCategorySortInput = {
  /** Gets the header of the brandline. */
  brandlineHeader?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the ProductCategory has a Yes/No question. */
  hasYesNoQuestion?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the ProductCategory is the accent wall tiles category. */
  isAccentWallTiles?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the ProductCategory is hidden. */
  isHidden?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the ProductCategory selection is optional. */
  isSelectionOptional?: InputMaybe<SortEnumType>;
  /** Gets the additional ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromAdditionalCategory?: InputMaybe<ProductCategorySortInput>;
  /** Gets the identifier of the additional ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromAdditionalCategoryId?: InputMaybe<SortEnumType>;
  /** Gets the ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromCategory?: InputMaybe<ProductCategorySortInput>;
  /** Gets the identifier of the ProductCategory that is used to load ProductSets for this ProductCategory. */
  loadProductSetsFromCategoryId?: InputMaybe<SortEnumType>;
  /** Gets the name of the product combination. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the ProductSet that is the No Product Needed for this Category. */
  noProductNeededProductSet?: InputMaybe<ProductSetSortInput>;
  /** Gets the identifier of the ProductSet that is the No Product Needed for this Category. */
  noProductNeededProductSetId?: InputMaybe<SortEnumType>;
  /** Gets the ProductSet that is the No Product for this Category. */
  noProductProductSet?: InputMaybe<ProductSetSortInput>;
  /** Gets the identifier of the ProductSet that is the No Product for this Category. */
  noProductProductSetId?: InputMaybe<SortEnumType>;
  /** Gets the integer by which the ProductCombination should be ordered when displaying. */
  position?: InputMaybe<SortEnumType>;
  /** Gets the ProductCombination the Category is attached. */
  productCombination?: InputMaybe<ProductCombinationSortInput>;
  /** Gets the identifier of the ProductCombination the Category is attached. */
  productCombinationId?: InputMaybe<SortEnumType>;
  /** Gets the title of the product category. */
  title?: InputMaybe<SortEnumType>;
  /** Gets the translated header of the BrandlineHeader. */
  translatedBrandlineHeader?: InputMaybe<SortEnumType>;
  /** Gets the translated name of the product category. */
  translatedName?: InputMaybe<SortEnumType>;
  /** Gets the translated title of the product category. */
  translatedTitle?: InputMaybe<SortEnumType>;
  /** Gets the ProductSet that is the "No" answer to a YesNoQuestion. */
  yesNoQuestionNoProductSet?: InputMaybe<ProductSetSortInput>;
  /** Gets the identifier of the ProductSet that is the "No" answer to a YesNoQuestion. */
  yesNoQuestionNoProductSetId?: InputMaybe<SortEnumType>;
  /** Gets the ProductSet that is the "Yes" answer to a YesNoQuestion. */
  yesNoQuestionYesProductSet?: InputMaybe<ProductSetSortInput>;
  /** Gets the identifier of the ProductSet that is the "Yes" answer to a YesNoQuestion. */
  yesNoQuestionYesProductSetId?: InputMaybe<SortEnumType>;
};

/**
 * ProductCombination represents a combination of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCombination
 */
export type ProductCombination = {
  __typename?: 'ProductCombination';
  /** Gets the type of combination. */
  combinationType: ProductCombinationType;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the name of the product combination. */
  name: Scalars['String']['output'];
  /** Gets the integer by which the ProductCombination should be ordered when displaying. */
  position: Scalars['Int']['output'];
  /**
   * Value that indicated if a filter for taps position is to be displayed.
   *
   *
   * **Returns:**
   * If a filter for Built in taps should be displayed.
   */
  showBuiltInOption: Scalars['Boolean']['output'];
};

/** Contains information about a product combination cost overview. */
export type ProductCombinationCostOverviewDto = {
  __typename?: 'ProductCombinationCostOverviewDto';
  /** Gets or sets the product combination cost overviews. */
  productCombinationCostOverviewSpecification?: Maybe<Array<KeyValuePairOfCostTypeAndMoney>>;
  /** Gets or sets the type of the product combination. */
  productCombinationType: ProductCombinationType;
  /** Gets or sets the product package sets selected on each category. */
  productPackageSets?: Maybe<Array<KeyValuePairOfSelectedProductSetDictionaryKeyAndProductPackageSet>>;
};

/**
 * ProductCombination represents a combination of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCombination
 */
export type ProductCombinationFilterInput = {
  and?: InputMaybe<Array<ProductCombinationFilterInput>>;
  /** Gets the categories assigned to this combination. */
  assignedCategories?: InputMaybe<ListFilterInputTypeOfProductCategoryFilterInput>;
  /** Gets the product packages assigned restrictions to this project. */
  assignedRestrictions?: InputMaybe<ListFilterInputTypeOfProductCombinationRestrictionFilterInput>;
  /** Gets the type of combination. */
  combinationType?: InputMaybe<ProductCombinationTypeOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the name of the product combination. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductCombinationFilterInput>>;
  /** Gets the integer by which the ProductCombination should be ordered when displaying. */
  position?: InputMaybe<IntOperationFilterInput>;
};

/** Available product set info Keys in badkamer */
export enum ProductCombinationInfoKeyType {
  /** Has some walls for accent tiles. */
  HasAccentWalls = 'HAS_ACCENT_WALLS',
  /** Has BATHTUB combination. */
  HasBathtubCombination = 'HAS_BATHTUB_COMBINATION',
  /** Has some bath casing area to be filled with tiles. */
  HasBathCasingArea = 'HAS_BATH_CASING_AREA',
  /** Has built-in taps */
  HasBuiltintaps = 'HAS_BUILTINTAPS',
  /** Has FOUNTAIN combination. */
  HasFountainCombination = 'HAS_FOUNTAIN_COMBINATION',
  /** Has RADIATOR combination. */
  HasRadiatorCombination = 'HAS_RADIATOR_COMBINATION',
  /** Has SHOWER combination. */
  HasShowerCombination = 'HAS_SHOWER_COMBINATION',
  /** Has some shower floor area to be filled with tiles. */
  HasShowerFloorArea = 'HAS_SHOWER_FLOOR_AREA',
  /** Has some shower partition wall area to be filled with tiles. */
  HasShowerPartitionwallArea = 'HAS_SHOWER_PARTITIONWALL_AREA',
  /** Has TILES combination. */
  HasTilesCombination = 'HAS_TILES_COMBINATION',
  /** Has some toilet casing area to be filled with tiles. */
  HasToiletCasingArea = 'HAS_TOILET_CASING_AREA',
  /** Has TOILET combination. */
  HasToiletCombination = 'HAS_TOILET_COMBINATION',
  /** Has some plafond are between tiles and ceiling that can be covered with additional tiles. */
  HasToCeilingArea = 'HAS_TO_CEILING_AREA',
  /** Has WASHBASIN combination. */
  HasWashbasinCombination = 'HAS_WASHBASIN_COMBINATION',
  /** Not set */
  NotSet = 'NOT_SET'
}

export type ProductCombinationInfoKeyTypeOperationFilterInput = {
  eq?: InputMaybe<ProductCombinationInfoKeyType>;
  in?: InputMaybe<Array<ProductCombinationInfoKeyType>>;
  neq?: InputMaybe<ProductCombinationInfoKeyType>;
  nin?: InputMaybe<Array<ProductCombinationInfoKeyType>>;
};

/** Represents a Product Combination Page. */
export type ProductCombinationPage = ContentItem & {
  __typename?: 'ProductCombinationPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  description?: Maybe<Scalars['String']['output']>;
  /** Text field */
  disabledText?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  positionSelectionTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productCombinationType?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type ProductCombinationPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ProductCombinationPage content item filters */
export type ProductCombinationPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ProductCombinationPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ProductCombinationPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ProductCombinationPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a Product Combination Position. */
export type ProductCombinationPosition = ContentItem & {
  __typename?: 'ProductCombinationPosition';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  description?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  image?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  position?: Maybe<Scalars['String']['output']>;
  /** Text field */
  priceRange?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productCombinationType?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type ProductCombinationPositionOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ProductCombinationPosition content item filters */
export type ProductCombinationPositionWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ProductCombinationPositionWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ProductCombinationPositionWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ProductCombinationPositionWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/**
 * ProductCombinationRestriction represents a restriction on using a ProductSet in a ProductCombination.
 * Restriction can be because of room dimensions or other.
 */
export type ProductCombinationRestrictionFilterInput = {
  and?: InputMaybe<Array<ProductCombinationRestrictionFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProductCombinationRestrictionFilterInput>>;
  /** Gets or sets the ProductCategory parent on this relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets or sets the id of the ProductCategory parent on this relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the product combination of the relation. */
  productCombination?: InputMaybe<ProductCombinationFilterInput>;
  /** Gets the product combination id of the relation. */
  productCombinationId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the product combination info key that triggers the rule. */
  productCombinationInfoKey?: InputMaybe<ProductCombinationInfoKeyTypeOperationFilterInput>;
  /** Gets the product combination info value that triggers the rule. */
  productCombinationInfoValue?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the compare operation to preform. */
  productSetInfoCompareOperation?: InputMaybe<ProductSetInfoCompareOperationOperationFilterInput>;
  /** Gets the 2nd compare operation to preform. */
  productSetInfoCompareOperation2?: InputMaybe<NullableOfProductSetInfoCompareOperationOperationFilterInput>;
  /** Gets or sets the value to be used in the compare operation. */
  productSetInfoCompareValue?: InputMaybe<StringOperationFilterInput>;
  /** Gets the 2nd value to be used in the compare operation. */
  productSetInfoCompareValue2?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the product set information key to be used to compare. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeyTypeOperationFilterInput>;
  /** Gets the 2nd product set information key to be used to compare. */
  productSetInfoKey2?: InputMaybe<NullableOfProductSetInfoKeyTypeOperationFilterInput>;
};

/** Contains information about the selected product combination and product category sets. */
export type ProductCombinationSets = {
  __typename?: 'ProductCombinationSets';
  /** Gets or sets the list of selected ProductCategorySet. */
  productCategorySets?: Maybe<Array<ProductCategorySet>>;
  /** Gets or sets the id of the product combination. */
  productCombinationId: Scalars['UUID']['output'];
};

/** Contains information about the selected product combination and product category sets. */
export type ProductCombinationSetsInput = {
  /** Gets or sets the list of selected ProductCategorySet. */
  productCategorySets?: InputMaybe<Array<ProductCategorySetInput>>;
  /** Gets or sets the id of the product combination. */
  productCombinationId: Scalars['UUID']['input'];
};

/**
 * ProductCombination represents a combination of product sets present in one ProductPackage.
 * ProductSet are grouped into ProductCombination
 */
export type ProductCombinationSortInput = {
  /** Gets the type of combination. */
  combinationType?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the name of the product combination. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the integer by which the ProductCombination should be ordered when displaying. */
  position?: InputMaybe<SortEnumType>;
};

/** Available product combinations in badkamer */
export enum ProductCombinationType {
  /** Bathtub */
  Bathtub = 'BATHTUB',
  /** Fountain */
  Fountain = 'FOUNTAIN',
  /** Value not Set */
  NotSet = 'NOT_SET',
  /** Radiator */
  Radiator = 'RADIATOR',
  /** Shower */
  Shower = 'SHOWER',
  /** Tiles */
  Tiles = 'TILES',
  /** Toilet */
  Toilet = 'TOILET',
  /** Utilities */
  Utilities = 'UTILITIES',
  /** Wash basin */
  Washbasin = 'WASHBASIN'
}

export type ProductCombinationTypeOperationFilterInput = {
  eq?: InputMaybe<ProductCombinationType>;
  in?: InputMaybe<Array<ProductCombinationType>>;
  neq?: InputMaybe<ProductCombinationType>;
  nin?: InputMaybe<Array<ProductCombinationType>>;
};

/** Represents a Product Configuration Name Popup. */
export type ProductConfigurationNamePopup = ContentItem & {
  __typename?: 'ProductConfigurationNamePopup';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  errorAlreadyExists?: Maybe<Scalars['String']['output']>;
  /** Text field */
  errorMaxLength?: Maybe<Scalars['String']['output']>;
  /** Text field */
  errorRequired?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** Numeric field */
  maxLength?: Maybe<Scalars['Decimal']['output']>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  text?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type ProductConfigurationNamePopupOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ProductConfigurationNamePopup content item filters */
export type ProductConfigurationNamePopupWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ProductConfigurationNamePopupWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ProductConfigurationNamePopupWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ProductConfigurationNamePopupWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Product item represents a single product that is used in product sets. */
export type ProductFilterInput = {
  and?: InputMaybe<Array<ProductFilterInput>>;
  /** Gets the brand of the product. */
  brand?: InputMaybe<StringOperationFilterInput>;
  /** Gets item code */
  code?: InputMaybe<StringOperationFilterInput>;
  /** Gets the cost price of the product. */
  costPrice?: InputMaybe<MoneyFilterInput>;
  /** Gets the description of the product. */
  description?: InputMaybe<StringOperationFilterInput>;
  grossSalesPrice?: InputMaybe<MoneyFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the product was added manually. */
  isManualAdded?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Gets a value indicating whether product is available.
   *
   *
   * **Returns:**
   * True if product not available, false otherwise.
   */
  isNotAvailable?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the long description of the product. */
  longDescription?: InputMaybe<StringOperationFilterInput>;
  /** Gets the marketing text of the product. */
  marketingText?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  /** Gets the amount of m2/m1 per unit in a package of the product */
  packagingUnits?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the price type. */
  priceType?: InputMaybe<ProjectActivityTargetOperationFilterInput>;
  /** Gets the status code of the product. */
  statusCode?: InputMaybe<IntOperationFilterInput>;
  /** Gets item supplier code */
  supplierCode?: InputMaybe<StringOperationFilterInput>;
};

/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackage = {
  __typename?: 'ProductPackage';
  assignedCategoryProductSets?: Maybe<AssignedCategoryProductSetsCollectionSegment>;
  assignedProductPackageCategories: Array<ProductPackageCategory>;
  assignedProductSets: Array<ProductPackageSet>;
  availableCombinations: Array<ProductCombination>;
  hasImportFile: Scalars['Boolean']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  isBeingUpdated: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether the product package is a main product package.
   * Main product packages can not be removed. Only product package sets from main product packages can be used for QR code generation.
   */
  isMain: Scalars['Boolean']['output'];
  /** Gets the name of the product package. */
  name: Scalars['String']['output'];
  /** Gets the target project type. */
  targetProjectType?: Maybe<Badkamercore_ProjectType>;
  usedInDesignPackages: Array<DesignPackage>;
  usedInProjects: Array<ProjectProductPackage>;
};


/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackageAssignedCategoryProductSetsArgs = {
  order?: InputMaybe<Array<ProductPackageSetSortInput>>;
  productPackageCategoryId: Scalars['UUID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductPackageSetFilterInput>;
};


/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackageAssignedProductPackageCategoriesArgs = {
  order?: InputMaybe<Array<ProductPackageCategorySortInput>>;
  where?: InputMaybe<ProductPackageCategoryFilterInput>;
};


/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackageAssignedProductSetsArgs = {
  order?: InputMaybe<Array<ProductPackageSetSortInput>>;
  where?: InputMaybe<ProductPackageSetFilterInput>;
};


/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackageAvailableCombinationsArgs = {
  order?: InputMaybe<Array<ProductCombinationSortInput>>;
  where?: InputMaybe<ProductCombinationFilterInput>;
};


/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackageUsedInDesignPackagesArgs = {
  where?: InputMaybe<DesignPackageFilterInput>;
};


/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackageUsedInProjectsArgs = {
  where?: InputMaybe<ProjectProductPackageFilterInput>;
};

/**
 * ProductPackageCategory represents a category of product sets present in one DesignPackage.
 * ProductSet are grouped into ProductCategory and this class represents the specific settings in a given DesignPackage.
 */
export type ProductPackageCategory = {
  __typename?: 'ProductPackageCategory';
  /** Gets a value indicating whether ProductCategory allows grouping ProductSet by brandline for the DesignPackage. */
  allowPickByBrand: Scalars['Boolean']['output'];
  assignedProductSets?: Maybe<AssignedProductSetsCollectionSegment>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets or sets the ProductCategory part of this relation. */
  productCategory?: Maybe<ProductCategory>;
};


/**
 * ProductPackageCategory represents a category of product sets present in one DesignPackage.
 * ProductSet are grouped into ProductCategory and this class represents the specific settings in a given DesignPackage.
 */
export type ProductPackageCategoryAssignedProductSetsArgs = {
  order?: InputMaybe<Array<ProductPackageSetSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductPackageSetFilterInput>;
};

/**
 * ProductPackageCategory represents a category of product sets present in one DesignPackage.
 * ProductSet are grouped into ProductCategory and this class represents the specific settings in a given DesignPackage.
 */
export type ProductPackageCategoryFilterInput = {
  /** Gets a value indicating whether ProductCategory allows grouping ProductSet by brandline for the DesignPackage. */
  allowPickByBrand?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductPackageCategoryFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProductPackageCategoryFilterInput>>;
  /** Gets or sets the ProductCategory part of this relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the id of the ProductCategory part of this relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the ProductPackage part of this relation. */
  productPackage?: InputMaybe<ProductPackageFilterInput>;
  /** Gets the id of the ProductPackage part of this relation. */
  productPackageId?: InputMaybe<UuidOperationFilterInput>;
};

/**
 * ProductPackageCategory represents a category of product sets present in one DesignPackage.
 * ProductSet are grouped into ProductCategory and this class represents the specific settings in a given DesignPackage.
 */
export type ProductPackageCategorySortInput = {
  /** Gets a value indicating whether ProductCategory allows grouping ProductSet by brandline for the DesignPackage. */
  allowPickByBrand?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductCategory part of this relation. */
  productCategory?: InputMaybe<ProductCategorySortInput>;
  /** Gets the id of the ProductCategory part of this relation. */
  productCategoryId?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductPackage part of this relation. */
  productPackage?: InputMaybe<ProductPackageSortInput>;
  /** Gets the id of the ProductPackage part of this relation. */
  productPackageId?: InputMaybe<SortEnumType>;
};

/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackageFilterInput = {
  and?: InputMaybe<Array<ProductPackageFilterInput>>;
  /** Gets the collection of ProductPackageCategory objects that compose this product package. */
  assignedProductPackageCategories?: InputMaybe<ListFilterInputTypeOfProductPackageCategoryFilterInput>;
  /** Gets the collection of ProductPackageSet objects that compose this product package. */
  assignedProductPackageSets?: InputMaybe<ListFilterInputTypeOfProductPackageSetFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /**
   * Gets a value indicating whether the product package is a main product package.
   * Main product packages can not be removed. Only product package sets from main product packages can be used for QR code generation.
   */
  isMain?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the name of the product package. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductPackageFilterInput>>;
  /** Gets the status of the product package. */
  status?: InputMaybe<ProductPackageStatusOperationFilterInput>;
  /** Gets the target project type. */
  targetProjectType?: InputMaybe<NullableOfProjectTypeOperationFilterInput>;
  /** Gets the collection of DesignPackage objects that reference this product package. */
  usedInDesignPackages?: InputMaybe<ListFilterInputTypeOfDesignPackageFilterInput>;
  /** Gets the collection of ProjectProductPackage objects that reference this product package. */
  usedInProjects?: InputMaybe<ListFilterInputTypeOfProjectProductPackageFilterInput>;
};

/** Represents a Product Package Page. */
export type ProductPackagePage = ContentItem & {
  __typename?: 'ProductPackagePage';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Text field */
  baseColor?: Maybe<Scalars['String']['output']>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type ProductPackagePageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ProductPackagePage content item filters */
export type ProductPackagePageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ProductPackagePageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ProductPackagePageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ProductPackagePageWhereInput>>>;
  /** the alias part of the content item */
  alias?: InputMaybe<AliasPartInput>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/**
 * Relational class that keeps track of relations (many to many) between ProductPackage,
 * a  ProductSet, a ProductCombination and optional ProductCategory.
 */
export type ProductPackageSet = {
  __typename?: 'ProductPackageSet';
  /** Gets the area the ProductPackageSet. */
  area?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the collection of price variants assigned. */
  assignedPriceVariants?: Maybe<Array<Maybe<ProductPackageSetPriceVariant>>>;
  displayableProductSetInfos?: Maybe<Array<Maybe<ProductSetInfo>>>;
  /** Gets the fallback product for the ProductPackageSet. */
  fallBackProduct?: Maybe<ProductPackageSet>;
  /** Gets a value indicating whether the ProductSet is the default in the category for the DesignPackage. */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gets a value indicating whether the product set is a no product.
   *
   *
   * **Returns:**
   * True if this is not an actual product.
   */
  isNoProduct: Scalars['Boolean']['output'];
  /**
   * Gets a value indicating whether the product set is a no product needed.
   *
   *
   * **Returns:**
   * True if this is for when no product is needed.
   */
  isNoProductNeeded: Scalars['Boolean']['output'];
  /** Gets a value indicating whether the ProductSet is the default in the category for the ProductPackage. */
  isProductPackageDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Gets a value indicating whether the ProductSet is a favorite in the category for the ProductPackage. */
  isProductPackageFavourite?: Maybe<Scalars['Boolean']['output']>;
  /** Gets the length for the ProductPackageSet. */
  length?: Maybe<Scalars['Decimal']['output']>;
  priceVariants: Scalars['String']['output'];
  /** Gets or sets the ProductCombination part of this relation. */
  productCombination: ProductCombination;
  /** Gets or sets the ProductPackage part of this relation. */
  productPackage: ProductPackage;
  /** Gets or sets the ProductPackageCategory parent on this relation. */
  productPackageCategory?: Maybe<ProductPackageCategory>;
  /** Gets or sets the ProductSet part of this relation. */
  productSet: ProductSet;
  /** Gets the coordination and provision sale price for the ProductSet. */
  saleCoordinationPrice?: Maybe<Money>;
  /** Gets the sale installation price for the ProductSet. */
  saleInstallationPrice?: Maybe<Money>;
  /** Gets the NON M1 sale price for the ProductSet. */
  salePrice?: Maybe<Money>;
  /** Gets the M1 sale price for the ProductSet. */
  salePriceM1?: Maybe<Money>;
  saleProductsPrice?: Maybe<Money>;
  /** Gets the status of the product set. */
  status: ProductSetStatus;
};


/**
 * Relational class that keeps track of relations (many to many) between ProductPackage,
 * a  ProductSet, a ProductCombination and optional ProductCategory.
 */
export type ProductPackageSetAssignedPriceVariantsArgs = {
  order?: InputMaybe<Array<ProductPackageSetPriceVariantSortInput>>;
  where?: InputMaybe<ProductPackageSetPriceVariantFilterInput>;
};


/**
 * Relational class that keeps track of relations (many to many) between ProductPackage,
 * a  ProductSet, a ProductCombination and optional ProductCategory.
 */
export type ProductPackageSetDisplayableProductSetInfosArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ProductSetInfoSortInput>>;
  where?: InputMaybe<ProductSetInfoFilterInput>;
};


/**
 * Relational class that keeps track of relations (many to many) between ProductPackage,
 * a  ProductSet, a ProductCombination and optional ProductCategory.
 */
export type ProductPackageSetProductCombinationArgs = {
  where?: InputMaybe<ProductCombinationFilterInput>;
};

/**
 * Relational class that keeps track of relations (many to many) between ProductPackage,
 * a  ProductSet, a ProductCombination and optional ProductCategory.
 */
export type ProductPackageSetFilterInput = {
  and?: InputMaybe<Array<ProductPackageSetFilterInput>>;
  /** Gets the area the ProductPackageSet. */
  area?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the collection of price variants assigned. */
  assignedPriceVariants?: InputMaybe<ListFilterInputTypeOfProductPackageSetPriceVariantFilterInput>;
  /** Gets the fallback product for the ProductPackageSet. */
  fallBackProduct?: InputMaybe<ProductPackageSetFilterInput>;
  /** Gets the collection of costs tha make the SaleInstallation price. */
  installationCostComponents?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfCostTypeAndMoneyFilterInput>;
  /** Gets a value indicating whether the ProductSet is the default in the category for the DesignPackage. */
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Gets a value indicating whether the product set is a no product.
   *
   *
   * **Returns:**
   * True if this is not an actual product.
   */
  isNoProduct?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Gets a value indicating whether the product set is a no product needed.
   *
   *
   * **Returns:**
   * True if this is for when no product is needed.
   */
  isNoProductNeeded?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the ProductSet is the default in the category for the ProductPackage. */
  isProductPackageDefault?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the ProductSet is a favorite in the category for the ProductPackage. */
  isProductPackageFavourite?: InputMaybe<BooleanOperationFilterInput>;
  /**
   * Gets a value indicating whether the product set is yes or no answer.
   *
   *
   * **Returns:**
   * True if this is a yes or no product set.
   */
  isYesNoAnswer?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the length for the ProductPackageSet. */
  length?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductPackageSetFilterInput>>;
  /** Gets or sets the ProductCombination part of this relation. */
  productCombination?: InputMaybe<ProductCombinationFilterInput>;
  /** Gets the id of the ProductCombination part of this relation. */
  productCombinationId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the ProductPackage part of this relation. */
  productPackage?: InputMaybe<ProductPackageFilterInput>;
  /** Gets or sets the ProductPackageCategory parent on this relation. */
  productPackageCategory?: InputMaybe<ProductPackageCategoryFilterInput>;
  /** Gets the id of the ProductPackageCategory parent on this relation. */
  productPackageCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the id of the ProductPackage part of this relation. */
  productPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the ProductSet part of this relation. */
  productSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the collection of the product set assigned activities using project's activities costs. */
  productSetActivitiesCosts?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfGuidAndListOfProjectActivityCostFilterInput>;
  /** Gets the id of the ProductSet part of this relation. */
  productSetId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the coordination and provision sale price for the ProductSet. */
  saleCoordinationPrice?: InputMaybe<MoneyFilterInput>;
  /** Gets the sale installation price for the ProductSet. */
  saleInstallationPrice?: InputMaybe<MoneyFilterInput>;
  /** Gets the NON M1 sale price for the ProductSet. */
  salePrice?: InputMaybe<MoneyFilterInput>;
  /** Gets the M1 sale price for the ProductSet. */
  salePriceM1?: InputMaybe<MoneyFilterInput>;
  /** Gets the status of the product set. */
  status?: InputMaybe<ProductSetStatusOperationFilterInput>;
};

/** Represents a price variant assignment to a ProductPackageSet. */
export type ProductPackageSetPriceVariant = {
  __typename?: 'ProductPackageSetPriceVariant';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the price variant. */
  priceVariant: PriceVariant;
  /** Gets the Product Category. */
  productCategory: ProductCategory;
  /** Gets the Product Category identifier. */
  productCategoryId: Scalars['UUID']['output'];
};

/** Represents a price variant assignment to a ProductPackageSet. */
export type ProductPackageSetPriceVariantFilterInput = {
  and?: InputMaybe<Array<ProductPackageSetPriceVariantFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProductPackageSetPriceVariantFilterInput>>;
  /** Gets the price variant. */
  priceVariant?: InputMaybe<PriceVariantOperationFilterInput>;
  /** Gets the Product Category. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the Product Category identifier. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the ProductPackageSet part of this relation. */
  productPackageSet?: InputMaybe<ProductPackageSetFilterInput>;
  /** Gets the id of the ProductCombination part of this relation. */
  productPackageSetProductCombinationId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the id of the ProductPackage part of this relation. */
  productPackageSetProductPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the id of the ProductSet part of this relation. */
  productPackageSetProductSetId?: InputMaybe<UuidOperationFilterInput>;
};

/** Represents a price variant assignment to a ProductPackageSet. */
export type ProductPackageSetPriceVariantSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the price variant. */
  priceVariant?: InputMaybe<SortEnumType>;
  /** Gets the Product Category. */
  productCategory?: InputMaybe<ProductCategorySortInput>;
  /** Gets the Product Category identifier. */
  productCategoryId?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductPackageSet part of this relation. */
  productPackageSet?: InputMaybe<ProductPackageSetSortInput>;
  /** Gets the id of the ProductCombination part of this relation. */
  productPackageSetProductCombinationId?: InputMaybe<SortEnumType>;
  /** Gets the id of the ProductPackage part of this relation. */
  productPackageSetProductPackageId?: InputMaybe<SortEnumType>;
  /** Gets the id of the ProductSet part of this relation. */
  productPackageSetProductSetId?: InputMaybe<SortEnumType>;
};

/**
 * Relational class that keeps track of relations (many to many) between ProductPackage,
 * a  ProductSet, a ProductCombination and optional ProductCategory.
 */
export type ProductPackageSetSortInput = {
  /** Gets the area the ProductPackageSet. */
  area?: InputMaybe<SortEnumType>;
  /** Gets the fallback product for the ProductPackageSet. */
  fallBackProduct?: InputMaybe<ProductPackageSetSortInput>;
  /** Gets a value indicating whether the ProductSet is the default in the category for the DesignPackage. */
  isDefault?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether the product set is a no product.
   *
   *
   * **Returns:**
   * True if this is not an actual product.
   */
  isNoProduct?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether the product set is a no product needed.
   *
   *
   * **Returns:**
   * True if this is for when no product is needed.
   */
  isNoProductNeeded?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the ProductSet is the default in the category for the ProductPackage. */
  isProductPackageDefault?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the ProductSet is a favorite in the category for the ProductPackage. */
  isProductPackageFavourite?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether the product set is yes or no answer.
   *
   *
   * **Returns:**
   * True if this is a yes or no product set.
   */
  isYesNoAnswer?: InputMaybe<SortEnumType>;
  /** Gets the length for the ProductPackageSet. */
  length?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductCombination part of this relation. */
  productCombination?: InputMaybe<ProductCombinationSortInput>;
  /** Gets the id of the ProductCombination part of this relation. */
  productCombinationId?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductPackage part of this relation. */
  productPackage?: InputMaybe<ProductPackageSortInput>;
  /** Gets or sets the ProductPackageCategory parent on this relation. */
  productPackageCategory?: InputMaybe<ProductPackageCategorySortInput>;
  /** Gets the id of the ProductPackageCategory parent on this relation. */
  productPackageCategoryId?: InputMaybe<SortEnumType>;
  /** Gets the id of the ProductPackage part of this relation. */
  productPackageId?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductSet part of this relation. */
  productSet?: InputMaybe<ProductSetSortInput>;
  /** Gets the id of the ProductSet part of this relation. */
  productSetId?: InputMaybe<SortEnumType>;
  /** Gets the coordination and provision sale price for the ProductSet. */
  saleCoordinationPrice?: InputMaybe<MoneySortInput>;
  /** Gets the sale installation price for the ProductSet. */
  saleInstallationPrice?: InputMaybe<MoneySortInput>;
  /** Gets the NON M1 sale price for the ProductSet. */
  salePrice?: InputMaybe<MoneySortInput>;
  /** Gets the M1 sale price for the ProductSet. */
  salePriceM1?: InputMaybe<MoneySortInput>;
  /** Gets the status of the product set. */
  status?: InputMaybe<SortEnumType>;
};

/** ProductPackage represents a single product package for decorating rooms. */
export type ProductPackageSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether the product package is a main product package.
   * Main product packages can not be removed. Only product package sets from main product packages can be used for QR code generation.
   */
  isMain?: InputMaybe<SortEnumType>;
  /** Gets the name of the product package. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the status of the product package. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the target project type. */
  targetProjectType?: InputMaybe<SortEnumType>;
};

/** Available product package status in badkamer */
export enum ProductPackageStatus {
  /** Product package available for selection */
  Available = 'AVAILABLE',
  /** Product package disabled. Not available for selection but can become available again. */
  Disabled = 'DISABLED'
}

export type ProductPackageStatusOperationFilterInput = {
  eq?: InputMaybe<ProductPackageStatus>;
  in?: InputMaybe<Array<ProductPackageStatus>>;
  neq?: InputMaybe<ProductPackageStatus>;
  nin?: InputMaybe<Array<ProductPackageStatus>>;
};

/** ProductSet present in one or more ProductPackage. */
export type ProductSet = {
  __typename?: 'ProductSet';
  /** Gets the product set activities. */
  assignedProductSetActivities: Array<ProductSetAssignedActivity>;
  /** Gets the collection of ProductSetInfo objects that compose this product package. */
  assignedProductSetInfos: Array<ProductSetInfo>;
  /** Gets the collection of ProductSetProduct objects that compose this product package. */
  assignedProductSetProducts: Array<ProductSetProduct>;
  /** Gets the brandline for the product set */
  brandline?: Maybe<ProductSetBrandline>;
  /**
   * Gets the sum cost price of NON M1 products that compose the ProductSet.
   *
   *
   * **Returns:**
   * The NON M1 cost price.
   */
  costPrice: Money;
  /**
   * Gets the sum cost price of M1 products that compose the ProductSet.
   *
   *
   * **Returns:**
   * The M1 cost price.
   */
  costPriceM1: Money;
  /** Gets the sum cost price M1 plus project margins of NON M1 product. <br><br>PAY ATTENTION: This resolver can only calculate the Cost Price M1 Plus when a consumer is logged in, because the relevant project margins are retrieved via the login. */
  costPriceM1Plus: Money;
  /** Gets the sum cost price plus project margins of NON M1 product. <br><br>PAY ATTENTION: This resolver can only calculate the Cost Price Plus when a consumer is logged in, because the relevant project margins are retrieved via the login. */
  costPricePlus: Money;
  /** Gets the fixed price of the product set. */
  fixedPrice?: Maybe<Money>;
  /**
   * Gets the sum gross sales price of NON M1 products that compose the ProductSet.
   *
   *
   * **Returns:**
   * The NON M1 gross sales price.
   */
  grossSalesPrice: Money;
  /**
   * Gets the sum gross sales price of M1 products that compose the ProductSet.
   *
   *
   * **Returns:**
   * The M1 gross sales price.
   */
  grossSalesPriceM1: Money;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the name of this ProductSet. */
  name: Scalars['String']['output'];
};


/** ProductSet present in one or more ProductPackage. */
export type ProductSetAssignedProductSetInfosArgs = {
  where?: InputMaybe<ProductSetInfoFilterInput>;
};


/** ProductSet present in one or more ProductPackage. */
export type ProductSetAssignedProductSetProductsArgs = {
  where?: InputMaybe<ProductSetProductFilterInput>;
};

/** Represents an activity assigned to a project with installations costs. */
export type ProductSetAssignedActivity = {
  __typename?: 'ProductSetAssignedActivity';
  /** Gets the activity. */
  activity?: Maybe<ProjectActivity>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets a value indicating whether this activity costs are applicable for products sets in a design package with standard included. */
  isForStandardProductSet?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents an activity assigned to a project with installations costs. */
export type ProductSetAssignedActivityFilterInput = {
  /** Gets the activity. */
  activity?: InputMaybe<ProjectActivityFilterInput>;
  /** Gets the Product Set. */
  activityId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<ProductSetAssignedActivityFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether this activity costs are applicable for products sets in a design package with standard included. */
  isForStandardProductSet?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductSetAssignedActivityFilterInput>>;
  /** Gets the Product Set. */
  productSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the Product Set. */
  productSetId?: InputMaybe<UuidOperationFilterInput>;
};

/** ProductSetBrandline represents a single brandline of product sets. */
export type ProductSetBrandline = {
  __typename?: 'ProductSetBrandline';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the name of the brandline. */
  name: Scalars['String']['output'];
  /** Gets the integer by which the ProductSetBrandline should be ordered when displaying. */
  position: Scalars['Int']['output'];
  /** Gets the ProductCategory the brandline is attached. */
  productCategory?: Maybe<ProductCategory>;
};

/** ProductSetBrandline represents a single brandline of product sets. */
export type ProductSetBrandlineFilterInput = {
  and?: InputMaybe<Array<ProductSetBrandlineFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the ProductSets assigned to this brandline. */
  includedProductSets?: InputMaybe<ListFilterInputTypeOfProductSetFilterInput>;
  /** Gets the name of the brandline. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductSetBrandlineFilterInput>>;
  /** Gets the integer by which the ProductSetBrandline should be ordered when displaying. */
  position?: InputMaybe<IntOperationFilterInput>;
  /** Gets the ProductCategory the brandline is attached. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the identifier of the ProductCategory the brandline is attached. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
};

/** ProductSetBrandline represents a single brandline of product sets. */
export type ProductSetBrandlineSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the name of the brandline. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the integer by which the ProductSetBrandline should be ordered when displaying. */
  position?: InputMaybe<SortEnumType>;
  /** Gets the ProductCategory the brandline is attached. */
  productCategory?: InputMaybe<ProductCategorySortInput>;
  /** Gets the identifier of the ProductCategory the brandline is attached. */
  productCategoryId?: InputMaybe<SortEnumType>;
};

/** Represents a Product Set Details. */
export type ProductSetDetails = ContentItem & {
  __typename?: 'ProductSetDetails';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  images?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  shortDescriptionHTML?: Maybe<HtmlField>;
  /** Text field */
  subInfo?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  thumbnail?: Maybe<MediaField>;
  /** MediaField */
  thumbnailColorVariation?: Maybe<MediaField>;
};

export type ProductSetDetailsOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ProductSetDetails content item filters */
export type ProductSetDetailsWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ProductSetDetailsWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ProductSetDetailsWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ProductSetDetailsWhereInput>>>;
  /** the alias part of the content item */
  alias?: InputMaybe<AliasPartInput>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** ProductSet present in one or more ProductPackage. */
export type ProductSetFilterInput = {
  and?: InputMaybe<Array<ProductSetFilterInput>>;
  /** Gets the product set activities. */
  assignedProductSetActivities?: InputMaybe<ListFilterInputTypeOfProductSetAssignedActivityFilterInput>;
  /** Gets the collection of ProductSetInfo objects that compose this product package. */
  assignedProductSetInfos?: InputMaybe<ListFilterInputTypeOfProductSetInfoFilterInput>;
  /** Gets the collection of ProductSetProduct objects that compose this product package. */
  assignedProductSetProducts?: InputMaybe<ListFilterInputTypeOfProductSetProductFilterInput>;
  /** Gets the brandline for the product set */
  brandline?: InputMaybe<ProductSetBrandlineFilterInput>;
  /** Gets the fixed price of the product set. */
  fixedPrice?: InputMaybe<MoneyFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /**
   * Gets a value indicating whether product set is available.
   *
   *
   * **Returns:**
   * True if not available.
   */
  isNotAvailable?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the name of this ProductSet. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductSetFilterInput>>;
  /** Gets the brandline Id for the product set */
  productSetBrandlineId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the status of the product set. */
  status?: InputMaybe<ProductSetStatusOperationFilterInput>;
};

/** ProductSetInfo represents a piece of information about a single ProductSet. */
export type ProductSetInfo = {
  __typename?: 'ProductSetInfo';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /**
   * Gets the information key
   *
   *
   * **Returns:**
   * The key of this information field.
   */
  key?: Maybe<ProductSetInfoKeyType>;
  label: Scalars['String']['output'];
  /** Gets the information language */
  languageCode?: Maybe<Scalars['String']['output']>;
  localizedValue: Array<Scalars['String']['output']>;
  /** Gets or sets the ProductSetInfoKey part of this relation. */
  productSetInfoKey: ProductSetInfoKey;
  /** Gets the id of the ProductSetInfoKey part of this relation. */
  productSetInfoKeyId: Scalars['UUID']['output'];
  /** Gets the unit of the information. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Gets the value of the information. */
  value?: Maybe<Scalars['String']['output']>;
};


/** ProductSetInfo represents a piece of information about a single ProductSet. */
export type ProductSetInfoLabelArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};


/** ProductSetInfo represents a piece of information about a single ProductSet. */
export type ProductSetInfoLocalizedValueArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};

/** Available Product Set Info compare operations */
export enum ProductSetInfoCompareOperation {
  /** Different */
  Diff = 'DIFF',
  /** Equals */
  Eq = 'EQ',
  /** Greater or equal */
  Geq = 'GEQ',
  /** Greater than */
  Gt = 'GT',
  /** Lower or equal */
  Leq = 'LEQ',
  /** Lower than */
  Lt = 'LT',
  /** No operation */
  None = 'NONE'
}

export type ProductSetInfoCompareOperationOperationFilterInput = {
  eq?: InputMaybe<ProductSetInfoCompareOperation>;
  in?: InputMaybe<Array<ProductSetInfoCompareOperation>>;
  neq?: InputMaybe<ProductSetInfoCompareOperation>;
  nin?: InputMaybe<Array<ProductSetInfoCompareOperation>>;
};

/** ProductSetInfo represents a piece of information about a single ProductSet. */
export type ProductSetInfoFilterInput = {
  and?: InputMaybe<Array<ProductSetInfoFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /**
   * Gets the information key
   *
   *
   * **Returns:**
   * The key of this information field.
   */
  key?: InputMaybe<ProductSetInfoKeyTypeOperationFilterInput>;
  /** Gets the information language */
  languageCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductSetInfoFilterInput>>;
  /** Gets or sets the ProductSet part of this relation. */
  productSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the id of the ProductSet part of this relation. */
  productSetId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the ProductSetInfoKey part of this relation. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeyFilterInput>;
  /** Gets the id of the ProductSetInfoKey part of this relation. */
  productSetInfoKeyId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the unit of the information. */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** Gets the value of the information. */
  value?: InputMaybe<StringOperationFilterInput>;
};

/** ProductSetInfoKey represents a valid key of information about a single ProductSet. */
export type ProductSetInfoKey = {
  __typename?: 'ProductSetInfoKey';
  /** Gets the data type to be used in operations. */
  dataType: ProductSetInfoKeyDataType;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  infoLabel: Scalars['String']['output'];
  /** Gets a value indicating whether this field is editable from the admin. */
  isNotEditable: Scalars['Boolean']['output'];
  /** Gets the information key */
  key: ProductSetInfoKeyType;
  keyLabel: Scalars['String']['output'];
  keyPossibleValues: Array<KeyValuePairOfStringAndString>;
  possibleValues: Array<KeyValuePairOfStringAndString>;
};


/** ProductSetInfoKey represents a valid key of information about a single ProductSet. */
export type ProductSetInfoKeyInfoLabelArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};


/** ProductSetInfoKey represents a valid key of information about a single ProductSet. */
export type ProductSetInfoKeyKeyLabelArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};


/** ProductSetInfoKey represents a valid key of information about a single ProductSet. */
export type ProductSetInfoKeyKeyPossibleValuesArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};


/** ProductSetInfoKey represents a valid key of information about a single ProductSet. */
export type ProductSetInfoKeyPossibleValuesArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};

/** Available data types for Information. */
export enum ProductSetInfoKeyDataType {
  /** A area measurement value. Values are stored as mm2. */
  AreaMeasurement = 'AREA_MEASUREMENT',
  /** A boolean value. Will be used as a bool for operations. */
  Bool = 'BOOL',
  /** A color value. Will be used as a text for operations. */
  Color = 'COLOR',
  /** A numeric value with decimal. */
  Decimal = 'DECIMAL',
  /** A enum value fom a list. Will be used as a string for operations. */
  Enum = 'ENUM',
  /** A length measurement value. Values are stored as millimeters. */
  LengthMeasurement = 'LENGTH_MEASUREMENT',
  /** A multi enum value from a list. Will be used as a string for operations. */
  MultiEnum = 'MULTI_ENUM',
  /** A numeric value. */
  Number = 'NUMBER',
  /** A percentage value. */
  Percentage = 'PERCENTAGE',
  /** A percentage value in range 0 -100. */
  Percentage_0_100 = 'PERCENTAGE_0_100',
  /** A text value. Will be used as a string for operations. */
  Text = 'TEXT'
}

export type ProductSetInfoKeyDataTypeOperationFilterInput = {
  eq?: InputMaybe<ProductSetInfoKeyDataType>;
  in?: InputMaybe<Array<ProductSetInfoKeyDataType>>;
  neq?: InputMaybe<ProductSetInfoKeyDataType>;
  nin?: InputMaybe<Array<ProductSetInfoKeyDataType>>;
};

/** ProductSetInfoKey represents a valid key of information about a single ProductSet. */
export type ProductSetInfoKeyFilterInput = {
  and?: InputMaybe<Array<ProductSetInfoKeyFilterInput>>;
  /** Gets the data type to be used in operations. */
  dataType?: InputMaybe<ProductSetInfoKeyDataTypeOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether this field should be displayed for clients. */
  isDisplayable?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether this field is editable from the admin. */
  isNotEditable?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the information key */
  key?: InputMaybe<ProductSetInfoKeyTypeOperationFilterInput>;
  /** Gets the label of the information. */
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductSetInfoKeyFilterInput>>;
  /** Gets the translated label of the information. */
  translatedLabel?: InputMaybe<StringOperationFilterInput>;
};

/** ProductSetInfoKey represents a valid key of information about a single ProductSet. */
export type ProductSetInfoKeySortInput = {
  /** Gets the data type to be used in operations. */
  dataType?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this field should be displayed for clients. */
  isDisplayable?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether this field is editable from the admin. */
  isNotEditable?: InputMaybe<SortEnumType>;
  /** Gets the information key */
  key?: InputMaybe<SortEnumType>;
  /** Gets the label of the information. */
  label?: InputMaybe<SortEnumType>;
  /** Gets the translated label of the information. */
  translatedLabel?: InputMaybe<SortEnumType>;
};

/** Available product set info Keys in badkamer */
export enum ProductSetInfoKeyType {
  /** Types of the shower enclosure allowed. */
  AllowedShowerEnclosureType = 'ALLOWED_SHOWER_ENCLOSURE_TYPE',
  /** If the bathtub of type Freestanding is allowed. */
  AllowBathtypeFreestanding = 'ALLOW_BATHTYPE_FREESTANDING',
  /** If the bathtub of type Whirlpool is allowed. */
  AllowBathtypeWhirlpool = 'ALLOW_BATHTYPE_WHIRLPOOL',
  /** If the drainage is allowed. */
  AllowDrainage = 'ALLOW_DRAINAGE',
  /**
   * If the drainage of type Gutter is allowed.
   * @deprecated Use only ALLOW_DRAINAGE
   */
  AllowDrainageGutter = 'ALLOW_DRAINAGE_GUTTER',
  /** If the position taps of type Built in is allowed. */
  AllowPositionTapsBuiltin = 'ALLOW_POSITION_TAPS_BUILTIN',
  /** If the shower toilet is allowed. */
  AllowShowerToilet = 'ALLOW_SHOWER_TOILET',
  /** Answer to Yes/No question. */
  AnswerYesNo = 'ANSWER_YES_NO',
  /** Is included in Basic room */
  BasicIncluded = 'BASIC_INCLUDED',
  /** Bath type */
  Bathtype = 'BATHTYPE',
  /** The area of bath casing to cover with tiles. In square meters (m2). */
  BathCasingArea = 'BATH_CASING_AREA',
  /** The length of bath casing profile. In meters (m1). */
  BathCasingLinear = 'BATH_CASING_LINEAR',
  /** Bath Drainage */
  BathDrainage = 'BATH_DRAINAGE',
  /** Bathtub Position of the taps */
  BathPositionTaps = 'BATH_POSITION_TAPS',
  /** Brand */
  Brand = 'BRAND',
  /** Colour */
  Colour = 'COLOUR',
  /** If this is a corner basin. */
  CornerBasin = 'CORNER_BASIN',
  /** Depth */
  Depth = 'DEPTH',
  /** Depth Range */
  DepthRange = 'DEPTH_RANGE',
  /**
   * Drainage
   * @deprecated Use SHOWER_DRAINAGE or BATH_DRAINAGE
   */
  Drainage = 'DRAINAGE',
  /** Has electricity */
  Electricity = 'ELECTRICITY',
  /** Area of the floor. */
  FloorArea = 'FLOOR_AREA',
  /** Type of a reservoir of a Toilet that a flash plate is for. */
  ForReservoirType = 'FOR_RESERVOIR_TYPE',
  /** Fontain Position of the taps */
  FountainPositionTaps = 'FOUNTAIN_POSITION_TAPS',
  /** Defines the position of the taps relative to the fountain */
  FountainTapsSide = 'FOUNTAIN_TAPS_SIDE',
  /** Grip */
  Grip = 'GRIP',
  /** Has Bowl */
  HasBowl = 'HAS_BOWL',
  /** Has built-in taps */
  HasBuiltintaps = 'HAS_BUILTINTAPS',
  /** Has shower partition wall */
  HasPartitionwall = 'HAS_PARTITIONWALL',
  /** Has Tapholes */
  HasTapholes = 'HAS_TAPHOLES',
  /** Bath has whirlpool */
  HasWhirlpool = 'HAS_WHIRLPOOL',
  /** Height */
  Height = 'HEIGHT',
  /** Total width required for installation. */
  InstallWidth = 'INSTALL_WIDTH',
  /** Is Accent wall compatible? */
  IsAccentWallCompatible = 'IS_ACCENT_WALL_COMPATIBLE',
  /** Is Bath casing compatible? */
  IsBathCasingCompatible = 'IS_BATH_CASING_COMPATIBLE',
  /** Indicates if this product set is a no product selection. */
  IsNoProduct = 'IS_NO_PRODUCT',
  /** IsPartition wall compatible? */
  IsPartitionWallCompatible = 'IS_PARTITION_WALL_COMPATIBLE',
  /**
   * If the shower door is between two walls.
   * @deprecated Use SHOWER_ENCLOSURE_TYPE
   */
  IsShowerDoorBetweenWalls = 'IS_SHOWER_DOOR_BETWEEN_WALLS',
  /** Is Shower floor compatible? */
  IsShowerFloorCompatible = 'IS_SHOWER_FLOOR_COMPATIBLE',
  /** Is Toilet casing compatible? */
  IsToiletCasingCompatible = 'IS_TOILET_CASING_COMPATIBLE',
  /** Is wall filled with tiles to the ceiling? */
  IsWallTilesToCeiling = 'IS_WALL_TILES_TO_CEILING',
  /** Length */
  Length = 'LENGTH',
  /** Material */
  Material = 'MATERIAL',
  /** Minimum depth allowed. */
  MinDepth = 'MIN_DEPTH',
  /** Minimum length allowed. */
  MinLength = 'MIN_LENGTH',
  /** Minimum width allowed. */
  MinWidth = 'MIN_WIDTH',
  /** Not set */
  NotSet = 'NOT_SET',
  /** Number of drawers */
  NumberDrawers = 'NUMBER_DRAWERS',
  /** Number of taps */
  NumberTaps = 'NUMBER_TAPS',
  /** Number of washbasins */
  NumberWashbasins = 'NUMBER_WASHBASINS',
  /** Custom properties. */
  Other = 'OTHER',
  /** Number of items in a package. */
  PackingUnits = 'PACKING_UNITS',
  /**
   * Position of the taps
   * @deprecated Use WASHBASIN_POSITION_TAPS or SHOWER_POSITION_TAPS or BATH_POSITION_TAPS or FOUNTAIN_POSITION_TAPS
   */
  PositionTaps = 'POSITION_TAPS',
  /** Radiator capacity */
  RadiatorCapacity = 'RADIATOR_CAPACITY',
  /** Type of Radiator */
  RadiatorType = 'RADIATOR_TYPE',
  /** Type of a reservoir of a Toilet */
  ReservoirType = 'RESERVOIR_TYPE',
  /** Series */
  Series = 'SERIES',
  /** Color that identify the Product Set in a series. */
  SeriesColorCode = 'SERIES_COLOR_CODE',
  /** Shower Drainage */
  ShowerDrainage = 'SHOWER_DRAINAGE',
  /** The are of shower floor. In square meters (m2). */
  ShowerEnclosureProfileArea = 'SHOWER_ENCLOSURE_PROFILE_AREA',
  /** The length of shower profile. In meters (m1). */
  ShowerEnclosureProfileLinear = 'SHOWER_ENCLOSURE_PROFILE_LINEAR',
  /** Type of the shower enclosure. */
  ShowerEnclosureType = 'SHOWER_ENCLOSURE_TYPE',
  /** The area of shower partition wall to cover with tiles. In square meters (m2). */
  ShowerPartitionWallArea = 'SHOWER_PARTITION_WALL_AREA',
  /** The length of shower partition wall profile. In meters (m1). */
  ShowerPartitionWallLinear = 'SHOWER_PARTITION_WALL_LINEAR',
  /** Shower Position of the taps */
  ShowerPositionTaps = 'SHOWER_POSITION_TAPS',
  /** Has shower toilet */
  ShowerToilet = 'SHOWER_TOILET',
  /** The standard height to each wall will have tiles. */
  StandardWallTileHeight = 'STANDARD_WALL_TILE_HEIGHT',
  /** The percentage of tiles lost with cutting tiles. */
  TilesCutLoss = 'TILES_CUT_LOSS',
  /** Where can a tile be installed. */
  TileApplicableOn = 'TILE_APPLICABLE_ON',
  /** Area of the part surrounding the toilet. */
  ToiletSurroundArea = 'TOILET_SURROUND_AREA',
  /** Length of the profile surrounding the toilet. */
  ToiletSurroundLinear = 'TOILET_SURROUND_LINEAR',
  /** Washbasin Position of the taps */
  WashbasinPositionTaps = 'WASHBASIN_POSITION_TAPS',
  /** Width */
  Width = 'WIDTH'
}

export type ProductSetInfoKeyTypeOperationFilterInput = {
  eq?: InputMaybe<ProductSetInfoKeyType>;
  in?: InputMaybe<Array<ProductSetInfoKeyType>>;
  neq?: InputMaybe<ProductSetInfoKeyType>;
  nin?: InputMaybe<Array<ProductSetInfoKeyType>>;
};

/** ProductSetInfo represents a piece of information about a single ProductSet. */
export type ProductSetInfoSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Gets the information key
   *
   *
   * **Returns:**
   * The key of this information field.
   */
  key?: InputMaybe<SortEnumType>;
  /** Gets the information language */
  languageCode?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductSet part of this relation. */
  productSet?: InputMaybe<ProductSetSortInput>;
  /** Gets the id of the ProductSet part of this relation. */
  productSetId?: InputMaybe<SortEnumType>;
  /** Gets or sets the ProductSetInfoKey part of this relation. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeySortInput>;
  /** Gets the id of the ProductSetInfoKey part of this relation. */
  productSetInfoKeyId?: InputMaybe<SortEnumType>;
  /** Gets the unit of the information. */
  unit?: InputMaybe<SortEnumType>;
  /** Gets the value of the information. */
  value?: InputMaybe<SortEnumType>;
};

/** Represents a Product Set Page. */
export type ProductSetPage = ContentItem & {
  __typename?: 'ProductSetPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** Text field */
  costPricePlusLabel?: Maybe<Scalars['String']['output']>;
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  excludingVATLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  grossPriceLabel?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  noProductSetFoundLabel?: Maybe<Scalars['String']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  priceInformationLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productSetNavigationPositionLabel?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  scanQrCodeButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  uScannedLabel?: Maybe<Scalars['String']['output']>;
};

export type ProductSetPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ProductSetPage content item filters */
export type ProductSetPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ProductSetPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ProductSetPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ProductSetPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Relational class that keeps track of relations (many to many) between ProductSet and Product. */
export type ProductSetProduct = {
  __typename?: 'ProductSetProduct';
  /** Gets a value indicating whether the product/article is the primary in the product set. */
  isPrimary: Scalars['Boolean']['output'];
  /** Gets the Product part of this relation. */
  product: Product;
};

/** Relational class that keeps track of relations (many to many) between ProductSet and Product. */
export type ProductSetProductFilterInput = {
  and?: InputMaybe<Array<ProductSetProductFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the product/article is the primary in the product set. */
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductSetProductFilterInput>>;
  /** Gets the Product part of this relation. */
  product?: InputMaybe<ProductFilterInput>;
  /** Gets the id of the Product part of this relation. */
  productId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the ProductSet part of this relation. */
  productSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the id of the ProductSet part of this relation. */
  productSetId?: InputMaybe<UuidOperationFilterInput>;
};

/**
 * ProductSetRestriction represents a retriction on using a ProductSet in a DesignPackage.
 * Restriction can be baucause of previous ProductSet properties.
 */
export type ProductSetRestrictionFilterInput = {
  and?: InputMaybe<Array<ProductSetRestrictionFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets a value indicating whether this is a campare operation on the same property on parent and child. */
  isCompareParentToChildProperty?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductSetRestrictionFilterInput>>;
  /** Gets or sets the ProductCategory parent on this relation. */
  parentProductCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets or sets the id of the ProductCategory parent on this relation. */
  parentProductCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the compare operation to preform on parent. */
  parentProductSetInfoCompareOperation?: InputMaybe<ProductSetInfoCompareOperationOperationFilterInput>;
  /** Gets or sets the value to be used in the compare operation on parent. */
  parentProductSetInfoCompareValue?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the product set information key to be used to compare on parent. */
  parentProductSetInfoKey?: InputMaybe<ProductSetInfoKeyTypeOperationFilterInput>;
  /** Gets or sets the ProductCategory parent on this relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets or sets the id of the ProductCategory parent on this relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the id of the ProductPackage part of this relation. */
  productPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the compare operation to preform. */
  productSetInfoCompareOperation?: InputMaybe<ProductSetInfoCompareOperationOperationFilterInput>;
  /** Gets or sets the value to be used in the compare operation. */
  productSetInfoCompareValue?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the product set information key to be used to compare. */
  productSetInfoKey?: InputMaybe<ProductSetInfoKeyTypeOperationFilterInput>;
};

/** ProductSet present in one or more ProductPackage. */
export type ProductSetSortInput = {
  /** Gets the brandline for the product set */
  brandline?: InputMaybe<ProductSetBrandlineSortInput>;
  /** Gets the fixed price of the product set. */
  fixedPrice?: InputMaybe<MoneySortInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether product set is available.
   *
   *
   * **Returns:**
   * True if not available.
   */
  isNotAvailable?: InputMaybe<SortEnumType>;
  /** Gets the name of this ProductSet. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the brandline Id for the product set */
  productSetBrandlineId?: InputMaybe<SortEnumType>;
  /** Gets the status of the product set. */
  status?: InputMaybe<SortEnumType>;
};

/** Available product set status in badkamer */
export enum ProductSetStatus {
  /** Product set available for selection */
  Available = 'AVAILABLE',
  /** Product set disabled. Not available for selection but can become available again. */
  Disabled = 'DISABLED',
  /** Product set obsolete. May not be available to selection */
  Obsolete = 'OBSOLETE',
  /** Product set retired. Not available to selection */
  Retired = 'RETIRED'
}

export type ProductSetStatusOperationFilterInput = {
  eq?: InputMaybe<ProductSetStatus>;
  in?: InputMaybe<Array<ProductSetStatus>>;
  neq?: InputMaybe<ProductSetStatus>;
  nin?: InputMaybe<Array<ProductSetStatus>>;
};

/** Product item represents a single product that is used in product sets. */
export type ProductSortInput = {
  /** Gets the brand of the product. */
  brand?: InputMaybe<SortEnumType>;
  /** Gets item code */
  code?: InputMaybe<SortEnumType>;
  /** Gets the cost price of the product. */
  costPrice?: InputMaybe<MoneySortInput>;
  /** Gets the description of the product. */
  description?: InputMaybe<SortEnumType>;
  grossSalesPrice?: InputMaybe<MoneySortInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the product was added manually. */
  isManualAdded?: InputMaybe<SortEnumType>;
  /**
   * Gets a value indicating whether product is available.
   *
   *
   * **Returns:**
   * True if product not available, false otherwise.
   */
  isNotAvailable?: InputMaybe<SortEnumType>;
  /** Gets the long description of the product. */
  longDescription?: InputMaybe<SortEnumType>;
  /** Gets the marketing text of the product. */
  marketingText?: InputMaybe<SortEnumType>;
  /** Gets the amount of m2/m1 per unit in a package of the product */
  packagingUnits?: InputMaybe<SortEnumType>;
  /** Gets the price type. */
  priceType?: InputMaybe<SortEnumType>;
  /** Gets the status code of the product. */
  statusCode?: InputMaybe<SortEnumType>;
  /** Gets item supplier code */
  supplierCode?: InputMaybe<SortEnumType>;
};

/** Extended properties for Project used for listing. */
export type Project = {
  __typename?: 'Project';
  /** Gets the brands assigned to this project. */
  assignedBrands: Array<ProjectBrand>;
  /** Gets the default products assigned to this project. */
  assignedDefaultProducts: Array<Maybe<ProjectDefaultProductSet>>;
  /** Gets the product packages assigned to this project. */
  assignedProductPackages: Array<ProjectProductPackage>;
  /** Gets the costs per project activity. */
  assignedProjectActivities: Array<ProjectAssignedActivity>;
  /** Gets the Dossier contacts assigned to this project. */
  assignedProjectDossierContacts: Array<ProjectDossierContact>;
  /** Gets the styles assigned to this project. */
  assignedStyles: Array<ProjectStyle>;
  /** Gets the date and time the project was last closed on. */
  closedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the company margin applied on each sanitary ProductSet in the ProductPackage for the project. */
  companyMarginSanitary?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the company margin applied on each tiles ProductSet in the ProductPackage for the project. */
  companyMarginTiles?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the correction factor for construction prices applied on each ProductSet in the ProductPackage for the project. */
  correctionConstructionFactor?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the correction factor for installation CV prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationCVFactor?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the correction factor for installation E prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationEFactor?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the correction factor for installation W prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationWFactor?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the correction factor for tiler prices applied on each ProductSet in the ProductPackage for the project. */
  correctionTilerFactor?: Maybe<Scalars['Decimal']['output']>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets a value indicating whether the custom offer feature is active. */
  isCustomOfferFeatureActive: Scalars['Boolean']['output'];
  /**
   * Gets whether a project is currently allowed to have its status changed to Open.
   * Business rule: Projects are only publishable if all rooms in all real estates have at least one design package assigned to it.
   *
   *
   * **Returns:**
   * true if all real estates have one or more design packages, otherwise false
   */
  isPublishable: Scalars['Boolean']['output'];
  /** Gets the date and time the project was last imported on. */
  lastImportedOn?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the distinct layouts (for the real estates) of this project. */
  layouts: Array<Layout>;
  /** Gets the builder margin applied on each ProductSet in the ProductPackage for the project. */
  marginBuilder?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the installer margin applied on each ProductSet in the ProductPackage for the project. */
  marginInstaller?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the tiler margin applied on each tiles ProductSet in the ProductPackage for the project. */
  marginTiler?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the name of the project, according to Estimate. */
  name: Scalars['String']['output'];
  /** Gets the number of the project in Estimate. */
  number: Scalars['String']['output'];
  projectActivities: Array<ProjectAssignedActivity>;
  /** Gets the name of the project developer, according to Estimate. */
  projectDeveloperName: Scalars['String']['output'];
  projectProductReturnPrices?: Maybe<ProjectProductReturnPricesCollectionSegment>;
  /** Gets the projectType. */
  projectType: Badkamercore_ProjectType;
  /** Gets the date and time the project was last published on. */
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  purchasingSurchargeInstaller?: Maybe<Scalars['Decimal']['output']>;
  /** Gets the real estates of this project. */
  realEstates: Array<RealEstate>;
  /** Gets the rooms of this project. */
  rooms: Array<Room>;
  /** Gets a value indicating whether the project allows ShellOnly delivery for rooms, according to Estimate. */
  shellOnlyAllowed: Scalars['Boolean']['output'];
  /** Gets the current status of the project. */
  status: ProjectStatus;
  /** Gets the number of RealEstate still not invited. */
  uninvitedCount: Scalars['Int']['output'];
  /** Gets a value indicating whether the project uses the Minus Return Price method for prices calculations. */
  useMinusReturnPriceCalculation: Scalars['Boolean']['output'];
  /** Gets the VAT for the project. */
  vat?: Maybe<Scalars['Decimal']['output']>;
};


/** Extended properties for Project used for listing. */
export type ProjectAssignedBrandsArgs = {
  where?: InputMaybe<ProjectBrandFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectAssignedDefaultProductsArgs = {
  where?: InputMaybe<ProjectDefaultProductSetFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectAssignedProductPackagesArgs = {
  where?: InputMaybe<ProjectProductPackageFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectAssignedProjectActivitiesArgs = {
  order?: InputMaybe<Array<ProjectAssignedActivitySortInput>>;
  where?: InputMaybe<ProjectAssignedActivityFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectAssignedProjectDossierContactsArgs = {
  order?: InputMaybe<Array<ProjectDossierContactSortInput>>;
  where?: InputMaybe<ProjectDossierContactFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectAssignedStylesArgs = {
  where?: InputMaybe<ProjectStyleFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectLayoutsArgs = {
  where?: InputMaybe<LayoutFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectProjectActivitiesArgs = {
  order?: InputMaybe<Array<ProjectAssignedActivitySortInput>>;
  where?: InputMaybe<ProjectAssignedActivityFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectProjectProductReturnPricesArgs = {
  order?: InputMaybe<Array<ProjectProductReturnPriceSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectProductReturnPriceFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectRealEstatesArgs = {
  where?: InputMaybe<RealEstateFilterInput>;
};


/** Extended properties for Project used for listing. */
export type ProjectRoomsArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  where?: InputMaybe<RoomFilterInput>;
};

/** Represents an activity in a project. */
export type ProjectActivity = {
  __typename?: 'ProjectActivity';
  activityAdditionalInfo?: Maybe<Scalars['String']['output']>;
  activityName: Scalars['String']['output'];
  /** Gets the target of the activity. */
  activityTarget: ProjectActivityTarget;
  /** Gets the additional information. */
  additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the activity name. */
  name: Scalars['String']['output'];
  /** Gets the activity position label. */
  position: Scalars['Int']['output'];
  /** Gets the activity position label. */
  positionLabel: Scalars['String']['output'];
  /** Gets the product combination. */
  productCombination?: Maybe<ProductCombination>;
  /** Gets the additional information in English. */
  translatedAdditionalInfo?: Maybe<Scalars['String']['output']>;
  /** Gets the activity name in English. */
  translatedName: Scalars['String']['output'];
};


/** Represents an activity in a project. */
export type ProjectActivityActivityAdditionalInfoArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};


/** Represents an activity in a project. */
export type ProjectActivityActivityNameArgs = {
  cultureCode?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a cost of an activity in a particular project. */
export type ProjectActivityCost = {
  __typename?: 'ProjectActivityCost';
  /** Gets the type of cost. */
  costType: CostType;
  /** Gets the cost value. */
  costValue?: Maybe<Money>;
};

/** Represents a cost of a project activity. */
export type ProjectActivityCostDtoInput = {
  /** Gets the amount. */
  amount: Scalars['String']['input'];
  /** Gets the cost type. */
  costType: CostType;
};

/** Represents a cost of an activity in a particular project. */
export type ProjectActivityCostFilterInput = {
  and?: InputMaybe<Array<ProjectActivityCostFilterInput>>;
  /** Gets the type of cost. */
  costType?: InputMaybe<CostTypeOperationFilterInput>;
  /** Gets the cost value. */
  costValue?: InputMaybe<MoneyFilterInput>;
  or?: InputMaybe<Array<ProjectActivityCostFilterInput>>;
  /** Gets the project assigned activity. */
  projectAssignedActivity?: InputMaybe<ProjectAssignedActivityFilterInput>;
  /** Gets the project assigned activity identifier. */
  projectAssignedActivityId?: InputMaybe<UuidOperationFilterInput>;
};

/** Represents an activity in a project. */
export type ProjectActivityFilterInput = {
  /** Gets the target of the activity. */
  activityTarget?: InputMaybe<ProjectActivityTargetOperationFilterInput>;
  /** Gets the additional information. */
  additionalInfo?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProjectActivityFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the activity name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectActivityFilterInput>>;
  /** Gets the activity position label. */
  position?: InputMaybe<IntOperationFilterInput>;
  /** Gets the activity position label. */
  positionLabel?: InputMaybe<StringOperationFilterInput>;
  /** Gets the product combination. */
  productCombination?: InputMaybe<ProductCombinationFilterInput>;
  /** Gets the product combination identifier. */
  productCombinationId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the additional information in English. */
  translatedAdditionalInfo?: InputMaybe<StringOperationFilterInput>;
  /** Gets the activity name in English. */
  translatedName?: InputMaybe<StringOperationFilterInput>;
};

/** Represents an activity in a project. */
export type ProjectActivitySortInput = {
  /** Gets the target of the activity. */
  activityTarget?: InputMaybe<SortEnumType>;
  /** Gets the additional information. */
  additionalInfo?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the activity name. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the activity position label. */
  position?: InputMaybe<SortEnumType>;
  /** Gets the activity position label. */
  positionLabel?: InputMaybe<SortEnumType>;
  /** Gets the product combination. */
  productCombination?: InputMaybe<ProductCombinationSortInput>;
  /** Gets the product combination identifier. */
  productCombinationId?: InputMaybe<SortEnumType>;
  /** Gets the additional information in English. */
  translatedAdditionalInfo?: InputMaybe<SortEnumType>;
  /** Gets the activity name in English. */
  translatedName?: InputMaybe<SortEnumType>;
};

/** Where is the activity applied. */
export enum ProjectActivityTarget {
  /** Activity applied per meter. */
  Meters = 'METERS',
  /** Activity on a product set. */
  ProductSet = 'PRODUCT_SET',
  /** Activity applied per square meter. */
  SquareMeters = 'SQUARE_METERS'
}

export type ProjectActivityTargetOperationFilterInput = {
  eq?: InputMaybe<ProjectActivityTarget>;
  in?: InputMaybe<Array<ProjectActivityTarget>>;
  neq?: InputMaybe<ProjectActivityTarget>;
  nin?: InputMaybe<Array<ProjectActivityTarget>>;
};

/** Represents an activity assigned to a project with installations costs. */
export type ProjectAssignedActivity = {
  __typename?: 'ProjectAssignedActivity';
  /** Gets the activity. */
  activity: ProjectActivity;
  /** Gets the collections of costs. */
  activityCosts: Array<ProjectActivityCost>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
};

/** Represents an activity assigned to a project with installations costs. */
export type ProjectAssignedActivityFilterInput = {
  /** Gets the activity. */
  activity?: InputMaybe<ProjectActivityFilterInput>;
  /** Gets the collections of costs. */
  activityCosts?: InputMaybe<ListFilterInputTypeOfProjectActivityCostFilterInput>;
  and?: InputMaybe<Array<ProjectAssignedActivityFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProjectAssignedActivityFilterInput>>;
  /** Gets the project. */
  project?: InputMaybe<ProjectFilterInput>;
  /** Gets the project. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
};

/** Represents an activity assigned to a project with installations costs. */
export type ProjectAssignedActivitySortInput = {
  /** Gets the activity. */
  activity?: InputMaybe<ProjectActivitySortInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the project. */
  project?: InputMaybe<ProjectSortInput>;
  /** Gets the project. */
  projectId?: InputMaybe<SortEnumType>;
};

/** Relational object that describes the relation between a project and a brand. */
export type ProjectBrand = {
  __typename?: 'ProjectBrand';
  /** Gets or sets the brand of the relation. */
  brand: Brand;
  /** Gets or sets the project of the relation. */
  project: Project;
};

/** Relational object that describes the relation between a project and a brand. */
export type ProjectBrandFilterInput = {
  and?: InputMaybe<Array<ProjectBrandFilterInput>>;
  /** Gets or sets the brand of the relation. */
  brand?: InputMaybe<BrandFilterInput>;
  /** Gets the brand id of the relation. */
  brandId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProjectBrandFilterInput>>;
  /** Gets or sets the project of the relation. */
  project?: InputMaybe<ProjectFilterInput>;
  /** Gets the project id of the relation. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
};

/** ProjectDefaultProductSet represents a default ProductSet for a ProductCategory in a Project. */
export type ProjectDefaultProductSet = {
  __typename?: 'ProjectDefaultProductSet';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets or sets the product category of the relation. */
  productCategory: ProductCategory;
  /** Gets the product category id of the relation. */
  productCategoryId: Scalars['UUID']['output'];
  /** Gets or sets the product set of the relation. */
  productSet: ProductSet;
  /** Gets the product set id of the relation. */
  productSetId: Scalars['UUID']['output'];
};

/** ProjectDefaultProductSet represents a default ProductSet for a ProductCategory in a Project. */
export type ProjectDefaultProductSetFilterInput = {
  and?: InputMaybe<Array<ProjectDefaultProductSetFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProjectDefaultProductSetFilterInput>>;
  /** Gets or sets the product category of the relation. */
  productCategory?: InputMaybe<ProductCategoryFilterInput>;
  /** Gets the product category id of the relation. */
  productCategoryId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the product set of the relation. */
  productSet?: InputMaybe<ProductSetFilterInput>;
  /** Gets the product set id of the relation. */
  productSetId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the project of the relation. */
  project?: InputMaybe<ProjectFilterInput>;
  /** Gets the project id of the relation. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
};

/** Represents a contact to send the project dossier. */
export type ProjectDossierContact = {
  __typename?: 'ProjectDossierContact';
  /** Gets the dossier contact email address. */
  email?: Maybe<Email>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
};

/** Represents a contact to send the project dossier. */
export type ProjectDossierContactDtoInput = {
  /** Gets the dossier contact email address. */
  email: Scalars['String']['input'];
  /** Gets the identifier for this entity. */
  id: Scalars['UUID']['input'];
};

/** Represents a contact to send the project dossier. */
export type ProjectDossierContactFilterInput = {
  and?: InputMaybe<Array<ProjectDossierContactFilterInput>>;
  /** Gets the dossier contact email address. */
  email?: InputMaybe<EmailFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProjectDossierContactFilterInput>>;
  /** Gets the project identifier of the contact relates to. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
};

/** Represents a contact to send the project dossier. */
export type ProjectDossierContactSortInput = {
  /** Gets the dossier contact email address. */
  email?: InputMaybe<EmailSortInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the project identifier of the contact relates to. */
  projectId?: InputMaybe<SortEnumType>;
};

/** Extended properties for Project used for listing. */
export type ProjectFilterInput = {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  /** Gets the brands assigned to this project. */
  assignedBrands?: InputMaybe<ListFilterInputTypeOfProjectBrandFilterInput>;
  /** Gets the default products assigned to this project. */
  assignedDefaultProducts?: InputMaybe<ListFilterInputTypeOfProjectDefaultProductSetFilterInput>;
  /** Gets the product packages assigned to this project. */
  assignedProductPackages?: InputMaybe<ListFilterInputTypeOfProjectProductPackageFilterInput>;
  /** Gets the costs per project activity. */
  assignedProjectActivities?: InputMaybe<ListFilterInputTypeOfProjectAssignedActivityFilterInput>;
  /** Gets the Dossier contacts assigned to this project. */
  assignedProjectDossierContacts?: InputMaybe<ListFilterInputTypeOfProjectDossierContactFilterInput>;
  /** Gets the ProjectProductReturnPrice assigned to this project. */
  assignedProjectProductReturnPrices?: InputMaybe<ListFilterInputTypeOfProjectProductReturnPriceFilterInput>;
  /** Gets the styles assigned to this project. */
  assignedStyles?: InputMaybe<ListFilterInputTypeOfProjectStyleFilterInput>;
  /** Gets the date and time the project was last closed on. */
  closedOn?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the company margin applied on each sanitary ProductSet in the ProductPackage for the project. */
  companyMarginSanitary?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the company margin applied on each tiles ProductSet in the ProductPackage for the project. */
  companyMarginTiles?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the correction factor for construction prices applied on each ProductSet in the ProductPackage for the project. */
  correctionConstructionFactor?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the correction factor for installation CV prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationCVFactor?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the correction factor for installation E prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationEFactor?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the correction factor for installation W prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationWFactor?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the correction factor for tiler prices applied on each ProductSet in the ProductPackage for the project. */
  correctionTilerFactor?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets a value indicating whether the custom offer feature is active. */
  isCustomOfferFeatureActive?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the date and time the project was last imported on. */
  lastImportedOn?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the distinct layouts (for the real estates) of this project. */
  layouts?: InputMaybe<ListFilterInputTypeOfLayoutFilterInput>;
  /** Gets the builder margin applied on each ProductSet in the ProductPackage for the project. */
  marginBuilder?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the installer margin applied on each ProductSet in the ProductPackage for the project. */
  marginInstaller?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the tiler margin applied on each tiles ProductSet in the ProductPackage for the project. */
  marginTiler?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the name of the project, according to Estimate. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Gets the number of the project in Estimate. */
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
  /** Gets the name of the project developer, according to Estimate. */
  projectDeveloperName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the projectType. */
  projectType?: InputMaybe<ProjectTypeOperationFilterInput>;
  /** Gets the date and time the project was last published on. */
  publishedOn?: InputMaybe<DateTimeOperationFilterInput>;
  purchasingSurchargeInstaller?: InputMaybe<DecimalOperationFilterInput>;
  /** Gets the real estates of this project. */
  realEstates?: InputMaybe<ListFilterInputTypeOfRealEstateFilterInput>;
  /** Gets the rooms of this project. */
  rooms?: InputMaybe<ListFilterInputTypeOfRoomFilterInput>;
  /** Gets a value indicating whether the project allows ShellOnly delivery for rooms, according to Estimate. */
  shellOnlyAllowed?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the current status of the project. */
  status?: InputMaybe<ProjectStatusOperationFilterInput>;
  /** Gets the number of RealEstate still not invited. */
  uninvitedCount?: InputMaybe<IntOperationFilterInput>;
  /** Gets a value indicating whether the project uses the Minus Return Price method for prices calculations. */
  useMinusReturnPriceCalculation?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the VAT for the project. */
  vat?: InputMaybe<DecimalOperationFilterInput>;
};

/** Represents a Project Landing Page. */
export type ProjectLandingPage = ContentItem & {
  __typename?: 'ProjectLandingPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** HtmlField */
  description?: Maybe<HtmlField>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Content stored as HTML. */
  htmlBody?: Maybe<HtmlBodyPart>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  projectType?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  startButtonText?: Maybe<Scalars['String']['output']>;
  /** Represents a StepBlock. */
  step1?: Maybe<Step1>;
  /** Represents a StepBlock. */
  step2?: Maybe<Step2>;
  /** Represents a StepBlock. */
  step3?: Maybe<Step3>;
};

export type ProjectLandingPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the ProjectLandingPage content item filters */
export type ProjectLandingPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<ProjectLandingPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<ProjectLandingPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<ProjectLandingPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Relational object that describes the relation between a project and a product package. */
export type ProjectProductPackage = {
  __typename?: 'ProjectProductPackage';
  /** Gets or sets the style of the relation. */
  productPackage: ProductPackage;
  /** Gets or sets the project of the relation. */
  project: Project;
};

/** Relational object that describes the relation between a project and a product package. */
export type ProjectProductPackageFilterInput = {
  and?: InputMaybe<Array<ProjectProductPackageFilterInput>>;
  or?: InputMaybe<Array<ProjectProductPackageFilterInput>>;
  /** Gets or sets the style of the relation. */
  productPackage?: InputMaybe<ProductPackageFilterInput>;
  /** Gets the project package id of the relation. */
  productPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the project of the relation. */
  project?: InputMaybe<ProjectFilterInput>;
  /** Gets the project id of the relation. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
};

/** ProjectProductReturnPrice. */
export type ProjectProductReturnPrice = {
  __typename?: 'ProjectProductReturnPrice';
  hashCode: Scalars['Int']['output'];
  /** Gets or sets the Product part of this relation. */
  product: Product;
  /** Gets or sets the ProductCombination part of this relation. */
  productCombination: ProductCombination;
  /** Gets or sets the project of the relation. */
  project: Project;
  /** Gets the return price of the product. */
  returnPrice?: Maybe<Money>;
};


/** ProjectProductReturnPrice. */
export type ProjectProductReturnPriceProductArgs = {
  order?: InputMaybe<Array<ProductSortInput>>;
};


/** ProjectProductReturnPrice. */
export type ProjectProductReturnPriceProductCombinationArgs = {
  order?: InputMaybe<Array<ProductCombinationSortInput>>;
};

/** ProjectProductReturnPrice. */
export type ProjectProductReturnPriceFilterInput = {
  and?: InputMaybe<Array<ProjectProductReturnPriceFilterInput>>;
  or?: InputMaybe<Array<ProjectProductReturnPriceFilterInput>>;
  /** Gets or sets the Product part of this relation. */
  product?: InputMaybe<ProductFilterInput>;
  /** Gets or sets the ProductCombination part of this relation. */
  productCombination?: InputMaybe<ProductCombinationFilterInput>;
  /** Gets the id of the ProductCombination part of this relation. */
  productCombinationId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the id of the Product part of this relation. */
  productId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the project of the relation. */
  project?: InputMaybe<ProjectFilterInput>;
  /** Gets the project id of the relation. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the return price of the product. */
  returnPrice?: InputMaybe<MoneyFilterInput>;
};

/** ProjectProductReturnPrice. */
export type ProjectProductReturnPriceSortInput = {
  /** Gets or sets the Product part of this relation. */
  product?: InputMaybe<ProductSortInput>;
  /** Gets or sets the ProductCombination part of this relation. */
  productCombination?: InputMaybe<ProductCombinationSortInput>;
  /** Gets the id of the ProductCombination part of this relation. */
  productCombinationId?: InputMaybe<SortEnumType>;
  /** Gets the id of the Product part of this relation. */
  productId?: InputMaybe<SortEnumType>;
  /** Gets or sets the project of the relation. */
  project?: InputMaybe<ProjectSortInput>;
  /** Gets the project id of the relation. */
  projectId?: InputMaybe<SortEnumType>;
  /** Gets the return price of the product. */
  returnPrice?: InputMaybe<MoneySortInput>;
};

/** A segment of a collection. */
export type ProjectProductReturnPricesCollectionSegment = {
  __typename?: 'ProjectProductReturnPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<ProjectProductReturnPrice>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** Extended properties for Project used for listing. */
export type ProjectSortInput = {
  /** Gets the date and time the project was last closed on. */
  closedOn?: InputMaybe<SortEnumType>;
  /** Gets the company margin applied on each sanitary ProductSet in the ProductPackage for the project. */
  companyMarginSanitary?: InputMaybe<SortEnumType>;
  /** Gets the company margin applied on each tiles ProductSet in the ProductPackage for the project. */
  companyMarginTiles?: InputMaybe<SortEnumType>;
  /** Gets the correction factor for construction prices applied on each ProductSet in the ProductPackage for the project. */
  correctionConstructionFactor?: InputMaybe<SortEnumType>;
  /** Gets the correction factor for installation CV prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationCVFactor?: InputMaybe<SortEnumType>;
  /** Gets the correction factor for installation E prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationEFactor?: InputMaybe<SortEnumType>;
  /** Gets the correction factor for installation W prices applied on each ProductSet in the ProductPackage for the project. */
  correctionInstallationWFactor?: InputMaybe<SortEnumType>;
  /** Gets the correction factor for tiler prices applied on each ProductSet in the ProductPackage for the project. */
  correctionTilerFactor?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the custom offer feature is active. */
  isCustomOfferFeatureActive?: InputMaybe<SortEnumType>;
  /** Gets the date and time the project was last imported on. */
  lastImportedOn?: InputMaybe<SortEnumType>;
  /** Gets the builder margin applied on each ProductSet in the ProductPackage for the project. */
  marginBuilder?: InputMaybe<SortEnumType>;
  /** Gets the installer margin applied on each ProductSet in the ProductPackage for the project. */
  marginInstaller?: InputMaybe<SortEnumType>;
  /** Gets the tiler margin applied on each tiles ProductSet in the ProductPackage for the project. */
  marginTiler?: InputMaybe<SortEnumType>;
  /** Gets the name of the project, according to Estimate. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the number of the project in Estimate. */
  number?: InputMaybe<SortEnumType>;
  /** Gets the name of the project developer, according to Estimate. */
  projectDeveloperName?: InputMaybe<SortEnumType>;
  /** Gets the projectType. */
  projectType?: InputMaybe<SortEnumType>;
  /** Gets the date and time the project was last published on. */
  publishedOn?: InputMaybe<SortEnumType>;
  purchasingSurchargeInstaller?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the project allows ShellOnly delivery for rooms, according to Estimate. */
  shellOnlyAllowed?: InputMaybe<SortEnumType>;
  /** Gets the current status of the project. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the number of RealEstate still not invited. */
  uninvitedCount?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the project uses the Minus Return Price method for prices calculations. */
  useMinusReturnPriceCalculation?: InputMaybe<SortEnumType>;
  /** Gets the VAT for the project. */
  vat?: InputMaybe<SortEnumType>;
};

/** The possible statusses of a project. */
export enum ProjectStatus {
  /** The project is closed */
  Closed = 'CLOSED',
  /** The project has ended */
  Ended = 'ENDED',
  /** The project is open */
  Open = 'OPEN',
  /** The project is in preview */
  Preview = 'PREVIEW'
}

export type ProjectStatusOperationFilterInput = {
  eq?: InputMaybe<ProjectStatus>;
  in?: InputMaybe<Array<ProjectStatus>>;
  neq?: InputMaybe<ProjectStatus>;
  nin?: InputMaybe<Array<ProjectStatus>>;
};

/** Relational object that describes the relation between a project and a style. */
export type ProjectStyle = {
  __typename?: 'ProjectStyle';
  /** Gets or sets the project of the relation. */
  project: Project;
  /** Gets or sets the style of the relation. */
  style: Style;
};

/** Relational object that describes the relation between a project and a style. */
export type ProjectStyleFilterInput = {
  and?: InputMaybe<Array<ProjectStyleFilterInput>>;
  or?: InputMaybe<Array<ProjectStyleFilterInput>>;
  /** Gets or sets the project of the relation. */
  project?: InputMaybe<ProjectFilterInput>;
  /** Gets the project id of the relation. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the style of the relation. */
  style?: InputMaybe<StyleFilterInput>;
  /** Gets the style id of the relation. */
  styleId?: InputMaybe<UuidOperationFilterInput>;
};

export type ProjectType = {
  __typename?: 'ProjectType';
  /** Text field */
  projectType?: Maybe<Scalars['String']['output']>;
};

export enum ProjectTypeEnum {
  DeBadkamerwerelden = 'DE_BADKAMERWERELDEN',
  Merkenpropositie = 'MERKENPROPOSITIE',
  Productenpropositie = 'PRODUCTENPROPOSITIE'
}

export type ProjectTypeOperationFilterInput = {
  eq?: InputMaybe<Badkamercore_ProjectType>;
  in?: InputMaybe<Array<Badkamercore_ProjectType>>;
  neq?: InputMaybe<Badkamercore_ProjectType>;
  nin?: InputMaybe<Array<Badkamercore_ProjectType>>;
};

/** A segment of a collection. */
export type ProjectsCollectionSegment = {
  __typename?: 'ProjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Project>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  accessToken: Scalars['String']['output'];
  activityTemplate?: Maybe<ActivityTemplate>;
  activityTemplates?: Maybe<ActivityTemplatesCollectionSegment>;
  /** Gets all the projects. */
  allProjects: Array<Project>;
  /** Represents a Become Partner Page. */
  becomePartnerPage?: Maybe<Array<Maybe<BecomePartnerPage>>>;
  /** Represents a Brand Detail. */
  brandDetail?: Maybe<Array<Maybe<BrandDetail>>>;
  /** Represents a Brand Listing Page. */
  brandListingPage?: Maybe<Array<Maybe<BrandListingPage>>>;
  /** Represents a Brand Page. */
  brandPage?: Maybe<Array<Maybe<BrandPage>>>;
  /** Represents a Brand Partner. */
  brandPartner?: Maybe<Array<Maybe<BrandPartner>>>;
  brands: Array<Brand>;
  /** Represents a Category. */
  category?: Maybe<Array<Maybe<Category>>>;
  /** Represents a Combination Product Sets Page. */
  combinationProductSetsPage?: Maybe<Array<Maybe<CombinationProductSetsPage>>>;
  contactRequestById?: Maybe<RequestForContact>;
  /** Represents a Contact Request Unauthenticated Popup. */
  contactRequestUnauthenticatedPopup?: Maybe<Array<Maybe<ContactRequestUnauthenticatedPopup>>>;
  contactRequests?: Maybe<ContactRequestsCollectionSegment>;
  /** Content items are instances of content types, just like objects are instances of classes. */
  contentItem?: Maybe<ContentItem>;
  /** Represents a Custom Offer Content. */
  customOfferContent?: Maybe<Array<Maybe<CustomOfferContent>>>;
  customOfferRequest?: Maybe<RequestForCustomOffer>;
  customOfferRequests?: Maybe<CustomOfferRequestsCollectionSegment>;
  cypressAccessToken: Scalars['String']['output'];
  designPackage?: Maybe<DesignPackage>;
  /** Represents a Design Package Page. */
  designPackagePage?: Maybe<Array<Maybe<DesignPackagePage>>>;
  designPackageProductSetRestrictionInfoKeys: Array<DesignPackageProductSetRestrictionInfoKey>;
  designPackages: Array<DesignPackage>;
  distinctProductCodes: Array<Scalars['String']['output']>;
  /** Represents a Error Definitions. */
  errorDefinitions?: Maybe<Array<Maybe<ErrorDefinitions>>>;
  /** Represents a Experience Centres Page. */
  experienceCentresPage?: Maybe<Array<Maybe<ExperienceCentresPage>>>;
  externalPreviewToken: Scalars['String']['output'];
  /** Represents a Frequently Asked Questions. */
  fAQPage?: Maybe<Array<Maybe<FaqPage>>>;
  /** Represents a Home Page. */
  homePage?: Maybe<Array<Maybe<HomePage>>>;
  /** Represents a How Does It Work - Content Item. */
  howDoesItWorkContentItem?: Maybe<Array<Maybe<HowDoesItWorkContentItem>>>;
  /** Represents a How Does It Work Page - About Us. */
  howDoesItWorkPageAboutUs?: Maybe<Array<Maybe<HowDoesItWorkPageAboutUs>>>;
  /** Represents a How Does It Work Page - Design Rooms. */
  howDoesItWorkPageDesignRooms?: Maybe<Array<Maybe<HowDoesItWorkPageDesignRooms>>>;
  /** Represents a How Does It Work Page - New Home. */
  howDoesItWorkPageNewHome?: Maybe<Array<Maybe<HowDoesItWorkPageNewHome>>>;
  /** Represents a How Does It Work - Topic Item. */
  howDoesItWorkTopicItem?: Maybe<Array<Maybe<HowDoesItWorkTopicItem>>>;
  importProductPackages: Array<ImportProductPackage>;
  /** Represents a Landing Page. */
  landingPage?: Maybe<Array<Maybe<LandingPage>>>;
  /** Represents a Layouts. */
  layouts?: Maybe<Array<Maybe<Layouts>>>;
  masterProductPackage?: Maybe<ProductPackage>;
  me?: Maybe<RealEstateContact>;
  /** Media assets are items that are part of your media library. */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>;
  /** Represents a Order Confirmation Page. */
  orderConfirmationPage?: Maybe<Array<Maybe<OrderConfirmationPage>>>;
  previewToken: Scalars['String']['output'];
  /** Represents a Privacy Policy Page. */
  privacyPolicyPage?: Maybe<Array<Maybe<PrivacyPolicyPage>>>;
  /** Represents a Product Brand Line Details. */
  productBrandLineDetails?: Maybe<Array<Maybe<ProductBrandLineDetails>>>;
  productCategories: Array<ProductCategory>;
  productCategoryProductSetInfoKeys: Array<ProductCategoryProductSetInfoKey>;
  /** Represents a Product Combination Page. */
  productCombinationPage?: Maybe<Array<Maybe<ProductCombinationPage>>>;
  /** Represents a Product Combination Position. */
  productCombinationPosition?: Maybe<Array<Maybe<ProductCombinationPosition>>>;
  productCombinations: Array<ProductCombination>;
  /** Represents a Product Configuration Name Popup. */
  productConfigurationNamePopup?: Maybe<Array<Maybe<ProductConfigurationNamePopup>>>;
  productInfo?: Maybe<Product>;
  productPackage?: Maybe<ProductPackage>;
  /** Represents a Product Package Page. */
  productPackagePage?: Maybe<Array<Maybe<ProductPackagePage>>>;
  productPackages: Array<ProductPackage>;
  /** Represents a Product Set Details. */
  productSetDetails?: Maybe<Array<Maybe<ProductSetDetails>>>;
  productSetInfoKeys: Array<ProductSetInfoKey>;
  /** Represents a Product Set Page. */
  productSetPage?: Maybe<Array<Maybe<ProductSetPage>>>;
  products: Array<Product>;
  project?: Maybe<Project>;
  projectActivities: Array<ProjectActivity>;
  /** Represents a Project Landing Page. */
  projectLandingPage?: Maybe<Array<Maybe<ProjectLandingPage>>>;
  /** Gets a subset of projects based on the page size. */
  projects?: Maybe<ProjectsCollectionSegment>;
  realEstate?: Maybe<RealEstate>;
  realEstateOrder?: Maybe<RealEstateOrder>;
  rensaUsers: Array<AdUserDto>;
  /** Represents a Request Drawing Popup. */
  requestDrawingPopup?: Maybe<Array<Maybe<RequestDrawingPopup>>>;
  requestFor3DDrawingDetails: RequestFor3DDrawingDetailDto;
  requestFor3DDrawingDetailsAsync: Array<CustomOffer>;
  requestsFor3DDrawings?: Maybe<RequestsFor3DDrawingsCollectionSegment>;
  requestsForTechnicalDrawings?: Maybe<RequestsForTechnicalDrawingsCollectionSegment>;
  rooms: Array<Room>;
  /** The active cultures configured for the site. */
  siteCultures?: Maybe<Array<Maybe<SiteCulture>>>;
  /** Represents a Style Detail. */
  styleDetail?: Maybe<Array<Maybe<StyleDetail>>>;
  /** Represents a Style Listing Page. */
  styleListingPage?: Maybe<Array<Maybe<StyleListingPage>>>;
  /** Represents a Style Page. */
  stylePage?: Maybe<Array<Maybe<StylePage>>>;
  styles: Array<Style>;
  /** Represents a Terms And Conditions Page. */
  termsAndConditionsPage?: Maybe<Array<Maybe<TermsAndConditionsPage>>>;
  /** Represents a Terms & Conditions. */
  termsConditions?: Maybe<Array<Maybe<TermsConditions>>>;
  /** Represents a TestCMSFields. */
  testCMSFields?: Maybe<Array<Maybe<TestCmsFields>>>;
  /** Represents a Translation. */
  translation?: Maybe<Array<Maybe<Translation>>>;
  userLogin: UserLoginDto;
  /** Represents a Usercentrics Consent Overlay. */
  usercentricsConsentOverlay?: Maybe<Array<Maybe<UsercentricsConsentOverlay>>>;
};


export type QueryAccessTokenArgs = {
  accessId: Scalars['UUID']['input'];
  realEstateId: Scalars['UUID']['input'];
};


export type QueryActivityTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryActivityTemplatesArgs = {
  order?: InputMaybe<Array<ActivityTemplateSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ActivityTemplateFilterInput>;
};


export type QueryAllProjectsArgs = {
  order?: InputMaybe<Array<ProjectSortInput>>;
  where?: InputMaybe<ProjectFilterInput>;
};


export type QueryBecomePartnerPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BecomePartnerPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<BecomePartnerPageWhereInput>;
};


export type QueryBrandDetailArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<BrandDetailWhereInput>;
};


export type QueryBrandListingPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandListingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<BrandListingPageWhereInput>;
};


export type QueryBrandPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<BrandPageWhereInput>;
};


export type QueryBrandPartnerArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BrandPartnerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<BrandPartnerWhereInput>;
};


export type QueryBrandsArgs = {
  where?: InputMaybe<BrandFilterInput>;
};


export type QueryCategoryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCombinationProductSetsPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CombinationProductSetsPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<CombinationProductSetsPageWhereInput>;
};


export type QueryContactRequestByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryContactRequestUnauthenticatedPopupArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContactRequestUnauthenticatedPopupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ContactRequestUnauthenticatedPopupWhereInput>;
};


export type QueryContactRequestsArgs = {
  order?: InputMaybe<Array<RequestForContactSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RequestForContactFilterInput>;
};


export type QueryContentItemArgs = {
  contentItemId: Scalars['String']['input'];
};


export type QueryCustomOfferContentArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CustomOfferContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<CustomOfferContentWhereInput>;
};


export type QueryCustomOfferRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCustomOfferRequestsArgs = {
  customOfferRequestStatus?: InputMaybe<CustomOfferRequestStatus>;
  order?: InputMaybe<Array<RequestForCustomOfferSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RequestForCustomOfferFilterInput>;
};


export type QueryCypressAccessTokenArgs = {
  secret: Scalars['UUID']['input'];
};


export type QueryDesignPackageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDesignPackagePageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DesignPackagePageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<DesignPackagePageWhereInput>;
};


export type QueryDesignPackageProductSetRestrictionInfoKeysArgs = {
  order?: InputMaybe<Array<DesignPackageProductSetRestrictionInfoKeySortInput>>;
  where?: InputMaybe<DesignPackageProductSetRestrictionInfoKeyFilterInput>;
};


export type QueryDesignPackagesArgs = {
  where?: InputMaybe<DesignPackageFilterInput>;
};


export type QueryErrorDefinitionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ErrorDefinitionsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ErrorDefinitionsWhereInput>;
};


export type QueryExperienceCentresPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExperienceCentresPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ExperienceCentresPageWhereInput>;
};


export type QueryExternalPreviewTokenArgs = {
  realEstateId: Scalars['UUID']['input'];
};


export type QueryFAqPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FaqPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<FaqPageWhereInput>;
};


export type QueryHomePageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HomePageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<HomePageWhereInput>;
};


export type QueryHowDoesItWorkContentItemArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HowDoesItWorkContentItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<HowDoesItWorkContentItemWhereInput>;
};


export type QueryHowDoesItWorkPageAboutUsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HowDoesItWorkPageAboutUsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<HowDoesItWorkPageAboutUsWhereInput>;
};


export type QueryHowDoesItWorkPageDesignRoomsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HowDoesItWorkPageDesignRoomsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<HowDoesItWorkPageDesignRoomsWhereInput>;
};


export type QueryHowDoesItWorkPageNewHomeArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HowDoesItWorkPageNewHomeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<HowDoesItWorkPageNewHomeWhereInput>;
};


export type QueryHowDoesItWorkTopicItemArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<HowDoesItWorkTopicItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<HowDoesItWorkTopicItemWhereInput>;
};


export type QueryImportProductPackagesArgs = {
  order?: InputMaybe<Array<ImportProductPackageSortInput>>;
  where?: InputMaybe<ImportProductPackageFilterInput>;
};


export type QueryLandingPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LandingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<LandingPageWhereInput>;
};


export type QueryLayoutsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LayoutsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<LayoutsWhereInput>;
};


export type QueryMediaAssetsArgs = {
  includeSubDirectories?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderConfirmationPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderConfirmationPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<OrderConfirmationPageWhereInput>;
};


export type QueryPreviewTokenArgs = {
  realEstateId: Scalars['UUID']['input'];
};


export type QueryPrivacyPolicyPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PrivacyPolicyPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<PrivacyPolicyPageWhereInput>;
};


export type QueryProductBrandLineDetailsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductBrandLineDetailsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ProductBrandLineDetailsWhereInput>;
};


export type QueryProductCategoriesArgs = {
  order?: InputMaybe<Array<ProductCategorySortInput>>;
  where?: InputMaybe<ProductCategoryFilterInput>;
};


export type QueryProductCategoryProductSetInfoKeysArgs = {
  order?: InputMaybe<Array<ProductCategoryProductSetInfoKeySortInput>>;
  where?: InputMaybe<ProductCategoryProductSetInfoKeyFilterInput>;
};


export type QueryProductCombinationPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCombinationPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ProductCombinationPageWhereInput>;
};


export type QueryProductCombinationPositionArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductCombinationPositionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ProductCombinationPositionWhereInput>;
};


export type QueryProductCombinationsArgs = {
  order?: InputMaybe<Array<ProductCombinationSortInput>>;
  where?: InputMaybe<ProductCombinationFilterInput>;
};


export type QueryProductConfigurationNamePopupArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductConfigurationNamePopupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ProductConfigurationNamePopupWhereInput>;
};


export type QueryProductInfoArgs = {
  code: Scalars['String']['input'];
};


export type QueryProductPackageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProductPackagePageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductPackagePageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ProductPackagePageWhereInput>;
};


export type QueryProductPackagesArgs = {
  where?: InputMaybe<ProductPackageFilterInput>;
};


export type QueryProductSetDetailsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductSetDetailsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ProductSetDetailsWhereInput>;
};


export type QueryProductSetInfoKeysArgs = {
  order?: InputMaybe<Array<ProductSetInfoKeySortInput>>;
  where?: InputMaybe<ProductSetInfoKeyFilterInput>;
};


export type QueryProductSetPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductSetPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ProductSetPageWhereInput>;
};


export type QueryProductsArgs = {
  where?: InputMaybe<ProductFilterInput>;
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  no?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectActivitiesArgs = {
  order?: InputMaybe<Array<ProjectActivitySortInput>>;
  where?: InputMaybe<ProjectActivityFilterInput>;
};


export type QueryProjectLandingPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectLandingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<ProjectLandingPageWhereInput>;
};


export type QueryProjectsArgs = {
  order?: InputMaybe<Array<ProjectSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProjectFilterInput>;
};


export type QueryRealEstateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRealEstateOrderArgs = {
  realEstateId: Scalars['UUID']['input'];
};


export type QueryRensaUsersArgs = {
  filterType: UsersGroupFilterType;
  searchTerm: Scalars['String']['input'];
};


export type QueryRequestDrawingPopupArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RequestDrawingPopupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<RequestDrawingPopupWhereInput>;
};


export type QueryRequestFor3DDrawingDetailsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRequestFor3DDrawingDetailsAsyncArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRequestsFor3DDrawingsArgs = {
  order?: InputMaybe<Array<RequestFor3DDrawingSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RequestFor3DDrawingFilterInput>;
};


export type QueryRequestsForTechnicalDrawingsArgs = {
  order?: InputMaybe<Array<RequestForTechnicalDrawingSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RequestForTechnicalDrawingFilterInput>;
};


export type QueryRoomsArgs = {
  order?: InputMaybe<Array<RoomSortInput>>;
  where?: InputMaybe<RoomFilterInput>;
};


export type QueryStyleDetailArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StyleDetailOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<StyleDetailWhereInput>;
};


export type QueryStyleListingPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StyleListingPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<StyleListingPageWhereInput>;
};


export type QueryStylePageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StylePageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<StylePageWhereInput>;
};


export type QueryStylesArgs = {
  where?: InputMaybe<StyleFilterInput>;
};


export type QueryTermsAndConditionsPageArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TermsAndConditionsPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<TermsAndConditionsPageWhereInput>;
};


export type QueryTermsConditionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TermsConditionsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<TermsConditionsWhereInput>;
};


export type QueryTestCmsFieldsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TestCmsFieldsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<TestCmsFieldsWhereInput>;
};


export type QueryTranslationArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TranslationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<TranslationWhereInput>;
};


export type QueryUserLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type QueryUsercentricsConsentOverlayArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UsercentricsConsentOverlayOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Status>;
  where?: InputMaybe<UsercentricsConsentOverlayWhereInput>;
};

/** Real estate represents a single building. */
export type RealEstate = {
  __typename?: 'RealEstate';
  /** Gets the current active external action of the real estate. */
  activeExternalAction?: Maybe<RealEstateExternalAction>;
  /**
   * Gets the current active status of the real estate.
   *
   *
   * **Returns:**
   * The active status.
   */
  activeStatus?: Maybe<RealEstateStatusUpdate>;
  /**
   * Gets whether there a quote request has already been done for this real estate.
   *
   *
   * **Returns:**
   * True if a quote has been requested
   */
  areQuotesRequested: Scalars['Boolean']['output'];
  /** Gets the build number (bouwnummer) of the real estate. */
  buildNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Gets the date and time the RealEstateContact is no longer allowed to select a DesignPackage for this RealEstate.
   * ///
   */
  closeDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the RealEstateContact for this real estate. */
  contact?: Maybe<RealEstateContact>;
  customOfferRequest?: Maybe<RequestForCustomOffer>;
  customOfferSelections: Array<Maybe<RealEstateCustomOfferSelection>>;
  /**
   * Gets the date and time the dossier was last sent.
   * ///
   */
  dossierSentDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the collection of RealEstateExternalAction of this real estate. */
  externalActions: Array<RealEstateExternalAction>;
  files: Array<RealEstateFileDto>;
  hasAdditionalWork?: Maybe<Scalars['Boolean']['output']>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /**
   * Gets whether the real estate is open for quote requests.
   * Business rule: Real Estates that have requests for quotes are not open for new ones.
   *
   *
   * **Returns:**
   * true if the real estate is open for quote requests, otherwise false
   */
  isOpenForQuoteRequests: Scalars['Boolean']['output'];
  /**
   * Gets whether the real estate was invited.
   *
   *
   * **Returns:**
   * true if the real estate was invited.
   */
  isRealEstateInvited: Scalars['Boolean']['output'];
  /** Gets the Layout of the real estate. */
  layout: Layout;
  /** Gets the collection of notes of this real estate. */
  notes?: Maybe<Array<Maybe<MessageDto>>>;
  /** Gets the number (no) of this real estate in Estimate. */
  number: Scalars['String']['output'];
  /** Gets the Project this real estate belongs to. */
  project: Project;
  realEstateOrder?: Maybe<RealEstateOrder>;
  requestFor3DDrawings: Array<RequestFor3DDrawing>;
  /** Gets the collection of RequestForContact requested by this real estate. */
  requestForContacts?: Maybe<Array<Maybe<RequestForContact>>>;
  /** Gets the collection of RequestForQuote requested by this real estate. */
  requestForQuotes: Array<RequestForQuote>;
  /** To be used by the projects listing. */
  requestForQuotesV2: Array<RequestForQuote>;
  /** Gets the revision number (revisienummer) of the real estate. */
  revisionNumber?: Maybe<Scalars['String']['output']>;
  roomSelections: Array<Maybe<RealEstateRoomSelection>>;
  roomSelectionsCosts: RealEstateSelectionCostsDto;
};


/** Real estate represents a single building. */
export type RealEstateRequestFor3DDrawingsArgs = {
  order?: InputMaybe<Array<RequestFor3DDrawingSortInput>>;
  where?: InputMaybe<RequestFor3DDrawingFilterInput>;
};


/** Real estate represents a single building. */
export type RealEstateRequestForContactsArgs = {
  order?: InputMaybe<Array<RequestForContactSortInput>>;
  where?: InputMaybe<RequestForContactFilterInput>;
};


/** Real estate represents a single building. */
export type RealEstateRequestForQuotesArgs = {
  where?: InputMaybe<RequestForQuoteFilterInput>;
};


/** Real estate represents a single building. */
export type RealEstateRequestForQuotesV2Args = {
  where?: InputMaybe<RequestForQuoteFilterInput>;
};

/** Represents a single person that is a future owner of the RealEstate in the scope of one RealEstate within one Project. */
export type RealEstateContact = {
  __typename?: 'RealEstateContact';
  /** Gets the access token for the contact. */
  accessToken: Scalars['UUID']['output'];
  /** Gets the email address of the contact. */
  email: Email;
  /** Gets the formal name for this contact according to Estimate. */
  formalName?: Maybe<Scalars['String']['output']>;
  /**
   * Checks if the contact has a user.
   *
   *
   * **Returns:**
   * True if the contact has a user.
   */
  hasUser: Scalars['Boolean']['output'];
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the date and time this contact was sent an invitation. */
  invitationSent?: Maybe<Scalars['DateTime']['output']>;
  /** Gets a value indicating whether the notifications are enabled. */
  isNotificationsEnabled: Scalars['Boolean']['output'];
  /** Gets the date and time this contact logged in. */
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastNoLoginNotification?: Maybe<RealEstateContactNotification>;
  lastNoQuoteNotification?: Maybe<RealEstateContactNotification>;
  /** Gets the legal name for this contact according to Estimate. */
  legalName?: Maybe<Scalars['String']['output']>;
  /** Gets the collection of RealEstateContactNotification sent to this real estate contact. */
  notifications: Array<RealEstateContactNotification>;
  /** Gets the phone number of the contact. */
  phone?: Maybe<PhoneNumber>;
  productSetSelection?: Maybe<Scalars['UUID']['output']>;
  /** Gets the RealEstate this is a contact for. */
  realEstate: RealEstate;
};


/** Represents a single person that is a future owner of the RealEstate in the scope of one RealEstate within one Project. */
export type RealEstateContactNotificationsArgs = {
  order?: InputMaybe<Array<RealEstateContactNotificationSortInput>>;
  where?: InputMaybe<RealEstateContactNotificationFilterInput>;
};


/** Represents a single person that is a future owner of the RealEstate in the scope of one RealEstate within one Project. */
export type RealEstateContactProductSetSelectionArgs = {
  designPackageId: Scalars['UUID']['input'];
  selectionName?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a single person that is a future owner of the RealEstate in the scope of one RealEstate within one Project. */
export type RealEstateContactFilterInput = {
  /** Gets the access token for the contact. */
  accessToken?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<RealEstateContactFilterInput>>;
  /** Gets the email address of the contact. */
  email?: InputMaybe<EmailFilterInput>;
  /** Gets the formal name for this contact according to Estimate. */
  formalName?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the date and time this contact was sent an invitation. */
  invitationSent?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets a value indicating whether the notifications are enabled. */
  isNotificationsEnabled?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the date and time this contact logged in. */
  lastLogin?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the legal name for this contact according to Estimate. */
  legalName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RealEstateContactFilterInput>>;
  /** Gets the phone number of the contact. */
  phone?: InputMaybe<PhoneNumberFilterInput>;
  /** Gets the RealEstate this is a contact for. */
  realEstate?: InputMaybe<RealEstateFilterInput>;
  /** Gets the collection of RealEstateContactNotification sent to this real estate contact. */
  realEstateContactNotifications?: InputMaybe<ListFilterInputTypeOfRealEstateContactNotificationFilterInput>;
  /** Gets the id of the real estate this contact will be the owner for. */
  realEstateId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the user this contact belongs to. */
  user?: InputMaybe<UserFilterInput>;
  /** Gets the user id this contact belongs to. */
  userId?: InputMaybe<UuidOperationFilterInput>;
};

/** Represents a single notification sent to a person that is a future owner of the RealEstate in the scope of one RealEstate within one Project. */
export type RealEstateContactNotification = {
  __typename?: 'RealEstateContactNotification';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the reminder notification type. */
  notificationType: ReminderNotificationType;
  /** Gets the RealEstateContact this notifications was sent. */
  realEstateContact: RealEstateContact;
  /** Gets the real estate contact identifier. */
  realEstateContactId: Scalars['UUID']['output'];
  /** Gets the date the notification was sent. */
  sentDate: Scalars['DateTime']['output'];
};

/** Represents a single notification sent to a person that is a future owner of the RealEstate in the scope of one RealEstate within one Project. */
export type RealEstateContactNotificationFilterInput = {
  and?: InputMaybe<Array<RealEstateContactNotificationFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the reminder notification type. */
  notificationType?: InputMaybe<ReminderNotificationTypeOperationFilterInput>;
  or?: InputMaybe<Array<RealEstateContactNotificationFilterInput>>;
  /** Gets the RealEstateContact this notifications was sent. */
  realEstateContact?: InputMaybe<RealEstateContactFilterInput>;
  /** Gets the real estate contact identifier. */
  realEstateContactId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the date the notification was sent. */
  sentDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a single notification sent to a person that is a future owner of the RealEstate in the scope of one RealEstate within one Project. */
export type RealEstateContactNotificationSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the reminder notification type. */
  notificationType?: InputMaybe<SortEnumType>;
  /** Gets the RealEstateContact this notifications was sent. */
  realEstateContact?: InputMaybe<RealEstateContactSortInput>;
  /** Gets the real estate contact identifier. */
  realEstateContactId?: InputMaybe<SortEnumType>;
  /** Gets the date the notification was sent. */
  sentDate?: InputMaybe<SortEnumType>;
};

/** Represents a single person that is a future owner of the RealEstate in the scope of one RealEstate within one Project. */
export type RealEstateContactSortInput = {
  /** Gets the access token for the contact. */
  accessToken?: InputMaybe<SortEnumType>;
  /** Gets the email address of the contact. */
  email?: InputMaybe<EmailSortInput>;
  /** Gets the formal name for this contact according to Estimate. */
  formalName?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the date and time this contact was sent an invitation. */
  invitationSent?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether the notifications are enabled. */
  isNotificationsEnabled?: InputMaybe<SortEnumType>;
  /** Gets the date and time this contact logged in. */
  lastLogin?: InputMaybe<SortEnumType>;
  /** Gets the legal name for this contact according to Estimate. */
  legalName?: InputMaybe<SortEnumType>;
  /** Gets the phone number of the contact. */
  phone?: InputMaybe<PhoneNumberSortInput>;
  /** Gets the RealEstate this is a contact for. */
  realEstate?: InputMaybe<RealEstateSortInput>;
  /** Gets the id of the real estate this contact will be the owner for. */
  realEstateId?: InputMaybe<SortEnumType>;
  /** Gets the user this contact belongs to. */
  user?: InputMaybe<UserSortInput>;
  /** Gets the user id this contact belongs to. */
  userId?: InputMaybe<SortEnumType>;
};

/** Contains information about a single selection for a room. */
export type RealEstateCustomOfferSelection = {
  __typename?: 'RealEstateCustomOfferSelection';
  customOffer: CustomOffer;
  /** Gets or sets the custom offer id. */
  customOfferId: Scalars['UUID']['output'];
  /** Gets unique identifier for a Room selection. */
  id: Scalars['UUID']['output'];
  /** Gets or sets a value indicating whether this selection is choosen. */
  isSelected: Scalars['Boolean']['output'];
  /** Gets or sets the name for this selection. */
  name: Scalars['String']['output'];
  /** Gets or sets the type of the selection. */
  selectionType: SelectionType;
  /** Gets or sets the aditional value to be paid for the selection. */
  surcharge?: Maybe<Money>;
};

/** Represents an action pending on an external entity. */
export type RealEstateExternalAction = {
  __typename?: 'RealEstateExternalAction';
  /** Gets the date the external action was closed. */
  closeDateUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the target of the external action. */
  externalActionTarget: RealEstateExternalActionTargetType;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  notes?: Maybe<Array<Maybe<MessageDto>>>;
  /** Gets the date the external action was opened. */
  requestDateUtc: Scalars['DateTime']['output'];
  /** Gets the external action status. */
  status: RealEstateExternalActionStatus;
};

/** Represents an action pending on an external entity. */
export type RealEstateExternalActionFilterInput = {
  and?: InputMaybe<Array<RealEstateExternalActionFilterInput>>;
  /** Gets the date the external action was closed. */
  closeDateUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the target of the external action. */
  externalActionTarget?: InputMaybe<RealEstateExternalActionTargetTypeOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RealEstateExternalActionFilterInput>>;
  /** Gets the real estate identifier. */
  realEstateId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the date the external action was opened. */
  requestDateUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the external action status. */
  status?: InputMaybe<RealEstateExternalActionStatusOperationFilterInput>;
};

/** Represents an action pending on an external entity. */
export type RealEstateExternalActionSortInput = {
  /** Gets the date the external action was closed. */
  closeDateUtc?: InputMaybe<SortEnumType>;
  /** Gets the target of the external action. */
  externalActionTarget?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the real estate identifier. */
  realEstateId?: InputMaybe<SortEnumType>;
  /** Gets the date the external action was opened. */
  requestDateUtc?: InputMaybe<SortEnumType>;
  /** Gets the external action status. */
  status?: InputMaybe<SortEnumType>;
};

/** The valid status for an external action. */
export enum RealEstateExternalActionStatus {
  /** Closed */
  Closed = 'CLOSED',
  /** New */
  New = 'NEW',
  /** Pending */
  Pending = 'PENDING'
}

export type RealEstateExternalActionStatusOperationFilterInput = {
  eq?: InputMaybe<RealEstateExternalActionStatus>;
  in?: InputMaybe<Array<RealEstateExternalActionStatus>>;
  neq?: InputMaybe<RealEstateExternalActionStatus>;
  nin?: InputMaybe<Array<RealEstateExternalActionStatus>>;
};

/** The type on entities that are the target of the external action. */
export enum RealEstateExternalActionTargetType {
  /** Contractor. */
  Contractor = 'CONTRACTOR',
  /** Installer. */
  Installer = 'INSTALLER',
  /** Other target entity. */
  Other = 'OTHER'
}

export type RealEstateExternalActionTargetTypeOperationFilterInput = {
  eq?: InputMaybe<RealEstateExternalActionTargetType>;
  in?: InputMaybe<Array<RealEstateExternalActionTargetType>>;
  neq?: InputMaybe<RealEstateExternalActionTargetType>;
  nin?: InputMaybe<Array<RealEstateExternalActionTargetType>>;
};

export type RealEstateFileDto = {
  __typename?: 'RealEstateFileDto';
  fileExtension: FileExtension;
  isDeletable: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  setIsDeletable: Scalars['Boolean']['output'];
  setName: Scalars['String']['output'];
  type: UploadFileType;
};


export type RealEstateFileDtoSetIsDeletableArgs = {
  isDeletable: Scalars['Boolean']['input'];
};


export type RealEstateFileDtoSetNameArgs = {
  name: Scalars['String']['input'];
};

/** Real estate represents a single building. */
export type RealEstateFilterInput = {
  /**
   * Gets the current active custom offer request.
   *
   *
   * **Returns:**
   * The custom offer request if any.
   */
  activeCustomOfferRequest?: InputMaybe<RequestForCustomOfferFilterInput>;
  /** Gets the current active external action of the real estate. */
  activeExternalAction?: InputMaybe<RealEstateExternalActionFilterInput>;
  /**
   * Gets the current active status of the real estate.
   *
   *
   * **Returns:**
   * The active status.
   */
  activeStatus?: InputMaybe<RealEstateStatusUpdateFilterInput>;
  and?: InputMaybe<Array<RealEstateFilterInput>>;
  /** Gets the build number (bouwnummer) of the real estate. */
  buildNumber?: InputMaybe<StringOperationFilterInput>;
  /**
   * Gets the date and time the RealEstateContact is no longer allowed to select a DesignPackage for this RealEstate.
   * ///
   */
  closeDateUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the RealEstateContact for this real estate. */
  contact?: InputMaybe<RealEstateContactFilterInput>;
  /**
   * Gets the date and time the dossier was last sent.
   * ///
   */
  dossierSentDateUtc?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the collection of RealEstateExternalAction of this real estate. */
  externalActions?: InputMaybe<ListFilterInputTypeOfRealEstateExternalActionFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the Layout of the real estate. */
  layout?: InputMaybe<LayoutFilterInput>;
  /** Gets the number (no) of this real estate in Estimate. */
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RealEstateFilterInput>>;
  /** Gets the Project this real estate belongs to. */
  project?: InputMaybe<ProjectFilterInput>;
  /** Gets the id of the project this real estate belongs to. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the collection of RequestFor3DDrawing requested by this real estate. */
  requestFor3DDrawings?: InputMaybe<ListFilterInputTypeOfRequestFor3DDrawingFilterInput>;
  /** Gets the collection of RequestForContact requested by this real estate. */
  requestForContacts?: InputMaybe<ListFilterInputTypeOfRequestForContactFilterInput>;
  /** Gets the collection of RequestForCustomOffer requested by this real estate. */
  requestForCustomOffers?: InputMaybe<ListFilterInputTypeOfRequestForCustomOfferFilterInput>;
  /** Gets the collection of RequestForQuote requested by this real estate. */
  requestForQuotes?: InputMaybe<ListFilterInputTypeOfRequestForQuoteFilterInput>;
  /** Gets the collection of RequestForTechnicalDrawing requested by this real estate. */
  requestForTechnicalDrawings?: InputMaybe<ListFilterInputTypeOfRequestForTechnicalDrawingFilterInput>;
  /** Gets the revision number (revisienummer) of the real estate. */
  revisionNumber?: InputMaybe<StringOperationFilterInput>;
};

/** Real estate order. */
export type RealEstateOrder = {
  __typename?: 'RealEstateOrder';
  /** Gets or sets the real estate build number. */
  buildNumber?: Maybe<Scalars['String']['output']>;
  /** Gets or sets confirmed status type. */
  confirmedStatusType: ConfirmedStatusType;
  /** Gets or sets the order costs. */
  costs: Array<Maybe<CostEntry>>;
  /** Gets or sets date when was created. */
  createdDate: Scalars['DateTime']['output'];
  /** Gets or sets the room selections. */
  globalCustomOffer?: Maybe<OrderCustomOffer>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets or sets the project identifier. */
  projectId: Scalars['UUID']['output'];
  /** Gets or sets the project name. */
  projectName: Scalars['String']['output'];
  /** Gets or sets the project number. */
  projectNumber: Scalars['String']['output'];
  /** Gets or sets the project type. */
  projectType: Badkamercore_ProjectType;
  /** Gets or sets the real estate identifier. */
  realEstateId: Scalars['UUID']['output'];
  /** Gets or sets the real estate number. */
  realEstateNumber: Scalars['String']['output'];
  /** Gets or sets the room selections. */
  rooms: Array<OrderRoom>;
};

/** Contains information about a single selection for a room. */
export type RealEstateRoomSelection = {
  __typename?: 'RealEstateRoomSelection';
  /** Gets or sets the custom offer id. */
  customOfferId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the design package identifier. */
  designPackageId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets a value indicating whether the selection contains one or more products that are no longer available. */
  hasUnavailableProductSets?: Maybe<Scalars['Boolean']['output']>;
  /** Gets unique identifier for a Room selection. */
  id: Scalars['UUID']['output'];
  /** Gets or sets a value indicating whether this selection is choosen. */
  isSelected: Scalars['Boolean']['output'];
  /** Gets or sets the name for this selection. */
  name?: Maybe<Scalars['String']['output']>;
  /** Gets or sets the status of the request for a 3D drawing. */
  request3DDrawingStatus?: Maybe<DrawingRequestStatus>;
  /** Gets or sets the room identifier. */
  roomId: Scalars['UUID']['output'];
  /** Gets or sets the type of the selection. */
  selectionType: SelectionType;
  /** Gets or sets the aditional value to be paid for the selection. */
  surcharge?: Maybe<Money>;
};

/** Contains information about the real estate selection costs. */
export type RealEstateSelectionCostsDto = {
  __typename?: 'RealEstateSelectionCostsDto';
  /** Gets or sets contains the cost overview specifications. */
  costOverview: Array<KeyValuePairOfCostTypeAndMoney>;
};

/** Real estate represents a single building. */
export type RealEstateSortInput = {
  /**
   * Gets the current active custom offer request.
   *
   *
   * **Returns:**
   * The custom offer request if any.
   */
  activeCustomOfferRequest?: InputMaybe<RequestForCustomOfferSortInput>;
  /** Gets the current active external action of the real estate. */
  activeExternalAction?: InputMaybe<RealEstateExternalActionSortInput>;
  /**
   * Gets the current active status of the real estate.
   *
   *
   * **Returns:**
   * The active status.
   */
  activeStatus?: InputMaybe<RealEstateStatusUpdateSortInput>;
  /** Gets the build number (bouwnummer) of the real estate. */
  buildNumber?: InputMaybe<SortEnumType>;
  /**
   * Gets the date and time the RealEstateContact is no longer allowed to select a DesignPackage for this RealEstate.
   * ///
   */
  closeDateUtc?: InputMaybe<SortEnumType>;
  /** Gets the RealEstateContact for this real estate. */
  contact?: InputMaybe<RealEstateContactSortInput>;
  /**
   * Gets the date and time the dossier was last sent.
   * ///
   */
  dossierSentDateUtc?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the Layout of the real estate. */
  layout?: InputMaybe<LayoutSortInput>;
  /** Gets the number (no) of this real estate in Estimate. */
  number?: InputMaybe<SortEnumType>;
  /** Gets the Project this real estate belongs to. */
  project?: InputMaybe<ProjectSortInput>;
  /** Gets the id of the project this real estate belongs to. */
  projectId?: InputMaybe<SortEnumType>;
  /** Gets the revision number (revisienummer) of the real estate. */
  revisionNumber?: InputMaybe<SortEnumType>;
};

/** The status of the RealEstate. */
export enum RealEstateStatus {
  /** Real estate choosing. */
  BuyerChoosing = 'BUYER_CHOOSING',
  /** Completed process. */
  Completed = 'COMPLETED',
  /** Waiting for draftsman. */
  ControlDraftsman = 'CONTROL_DRAFTSMAN',
  /** Real estate requested Custom Offer. */
  CustomOffer = 'CUSTOM_OFFER',
  /** Real estate invited to the platform. */
  Invited = 'INVITED',
  /** Real estate sold to new buyer. */
  NewBuyer = 'NEW_BUYER',
  /** Ready to send dossier. */
  SendDossier = 'SEND_DOSSIER',
  /** Ready to technical drawing. */
  TechnicalDrawing = 'TECHNICAL_DRAWING',
  /** Real estate not sold yet. */
  Unsold = 'UNSOLD'
}

export type RealEstateStatusOperationFilterInput = {
  eq?: InputMaybe<RealEstateStatus>;
  in?: InputMaybe<Array<RealEstateStatus>>;
  neq?: InputMaybe<RealEstateStatus>;
  nin?: InputMaybe<Array<RealEstateStatus>>;
};

/** Represent an update on the RealEstate status. */
export type RealEstateStatusUpdate = {
  __typename?: 'RealEstateStatusUpdate';
  /** Gets the RealEstate status. */
  status: RealEstateStatus;
  /** Gets the date when the status was updated. */
  updateDate: Scalars['DateTime']['output'];
};

/** Represent an update on the RealEstate status. */
export type RealEstateStatusUpdateFilterInput = {
  and?: InputMaybe<Array<RealEstateStatusUpdateFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RealEstateStatusUpdateFilterInput>>;
  /** Gets the RealEstate. */
  realEstate?: InputMaybe<RealEstateFilterInput>;
  /** Gets the RealEstate identifier. */
  realEstateId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the RealEstate status. */
  status?: InputMaybe<RealEstateStatusOperationFilterInput>;
  /** Gets the date when the status was updated. */
  updateDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represent an update on the RealEstate status. */
export type RealEstateStatusUpdateSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the RealEstate. */
  realEstate?: InputMaybe<RealEstateSortInput>;
  /** Gets the RealEstate identifier. */
  realEstateId?: InputMaybe<SortEnumType>;
  /** Gets the RealEstate status. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the date when the status was updated. */
  updateDate?: InputMaybe<SortEnumType>;
};

/** Available reminder notification types. */
export enum ReminderNotificationType {
  /** Notification sent when the real estate haven't logged in yet. */
  NoLogin = 'NO_LOGIN',
  /** Notification sent when the real estate haven't sent a quote yet. */
  NoQuote = 'NO_QUOTE'
}

export type ReminderNotificationTypeOperationFilterInput = {
  eq?: InputMaybe<ReminderNotificationType>;
  in?: InputMaybe<Array<ReminderNotificationType>>;
  neq?: InputMaybe<ReminderNotificationType>;
  nin?: InputMaybe<Array<ReminderNotificationType>>;
};

/** Represents a Request Drawing Popup. */
export type RequestDrawingPopup = ContentItem & {
  __typename?: 'RequestDrawingPopup';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Text field */
  cancelButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  cancelRequestCancelbutton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  cancelRequestConfirmbutton?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  cancelRequestContent?: Maybe<HtmlField>;
  /** Text field */
  cancelRequestTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  confirmButton?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  content?: Maybe<HtmlField>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  defaultTriggerTextCancelRequest?: Maybe<Scalars['String']['output']>;
  /** Text field */
  defaultTriggerTextDownloadDrawing?: Maybe<Scalars['String']['output']>;
  /** Text field */
  defaultTriggerTextDrawingPending?: Maybe<Scalars['String']['output']>;
  /** Text field */
  defaultTriggerTextRequestDrawing?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type RequestDrawingPopupOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the RequestDrawingPopup content item filters */
export type RequestDrawingPopupWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<RequestDrawingPopupWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<RequestDrawingPopupWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<RequestDrawingPopupWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a request for a 3D drawing on a selected DesignPackage (for a specific room) in a specific RealEstate with a specific list of selected ProductSets. */
export type RequestFor3DDrawing = {
  __typename?: 'RequestFor3DDrawing';
  assignedDrawer?: Maybe<AdUserDto>;
  /** Gets the identifier of the drawer assigned to 3d drawing request. */
  assignedDrawerId?: Maybe<Scalars['String']['output']>;
  /** Gets the name for this selection. */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the design package for this request. */
  designPackage: DesignPackage;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the identifier for this product selection. */
  productSelectionId: Scalars['UUID']['output'];
  /** Gets the real estate for this request. */
  realEstate: RealEstate;
  /** Gets the status of the request for a 3D drawing. */
  request3DDrawingStatus?: Maybe<DrawingRequestStatus>;
  /** Gets the name for this selection. */
  requested: Scalars['DateTime']['output'];
  /** Gets the identifier for this room selection. */
  roomSelectionId: Scalars['UUID']['output'];
  /** Gets the name for this selection. */
  selectionName: Scalars['String']['output'];
};

/** Contains detail information about a 3D drawing request. */
export type RequestFor3DDrawingDetailDto = {
  __typename?: 'RequestFor3DDrawingDetailDto';
  /** Gets or sets the product package sets. */
  productPackageSets: Array<KeyValuePairOfSelectedProductSetDictionaryKeyAndProductPackageSet>;
  /** Gets the 3D drawing request information. */
  requestFor3DDrawing: RequestFor3DDrawing;
};

/** Represents a request for a 3D drawing on a selected DesignPackage (for a specific room) in a specific RealEstate with a specific list of selected ProductSets. */
export type RequestFor3DDrawingFilterInput = {
  and?: InputMaybe<Array<RequestFor3DDrawingFilterInput>>;
  /** Gets the identifier of the drawer assigned to 3d drawing request. */
  assignedDrawerId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the name for this selection. */
  deadline?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the design package for this request. */
  designPackage?: InputMaybe<DesignPackageFilterInput>;
  /** Gets the id of the design package this request involves. */
  designPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RequestFor3DDrawingFilterInput>>;
  /** Gets the identifier for this product selection. */
  productSelectionId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateFilterInput>;
  /** Gets the id of the real estate this request for quote involves. */
  realEstateId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the status of the request for a 3D drawing. */
  request3DDrawingStatus?: InputMaybe<NullableOfDrawingRequestStatusOperationFilterInput>;
  /** Gets the name for this selection. */
  requested?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the identifier for this room selection. */
  roomSelectionId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the name for this selection. */
  selectionName?: InputMaybe<StringOperationFilterInput>;
};

/** Represents a request for a 3D drawing on a selected DesignPackage (for a specific room) in a specific RealEstate with a specific list of selected ProductSets. */
export type RequestFor3DDrawingSortInput = {
  /** Gets the identifier of the drawer assigned to 3d drawing request. */
  assignedDrawerId?: InputMaybe<SortEnumType>;
  /** Gets the name for this selection. */
  deadline?: InputMaybe<SortEnumType>;
  /** Gets the design package for this request. */
  designPackage?: InputMaybe<DesignPackageSortInput>;
  /** Gets the id of the design package this request involves. */
  designPackageId?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the identifier for this product selection. */
  productSelectionId?: InputMaybe<SortEnumType>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateSortInput>;
  /** Gets the id of the real estate this request for quote involves. */
  realEstateId?: InputMaybe<SortEnumType>;
  /** Gets the status of the request for a 3D drawing. */
  request3DDrawingStatus?: InputMaybe<SortEnumType>;
  /** Gets the name for this selection. */
  requested?: InputMaybe<SortEnumType>;
  /** Gets the identifier for this room selection. */
  roomSelectionId?: InputMaybe<SortEnumType>;
  /** Gets the name for this selection. */
  selectionName?: InputMaybe<SortEnumType>;
};

/** Extended properties for RequestForContact used for filtering. */
export type RequestForContact = {
  __typename?: 'RequestForContact';
  assignedAssignee?: Maybe<AdUserDto>;
  /** Gets the identifier of the specialist assigned to contact request. */
  assignedSpecialistId?: Maybe<Scalars['String']['output']>;
  /** Gets the type of contact of the request. */
  contactType?: Maybe<ContactType>;
  /** Gets the RequestForContact current status. */
  currentStatus?: Maybe<ContactRequestStatus>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  messages?: Maybe<Array<Maybe<MessageBaseDto>>>;
  /** Gets the phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Gets the real estate for this request. */
  realEstate?: Maybe<RealEstate>;
  /** Gets the id of the real estate this request for contact involves. */
  realEstateId?: Maybe<Scalars['UUID']['output']>;
  /** Gets the status of the request. */
  requestStatus?: Maybe<RequestForContactStatusUpdate>;
  /** Gets the date of the request. */
  requested: Scalars['DateTime']['output'];
};

/** Extended properties for RequestForContact used for filtering. */
export type RequestForContactFilterInput = {
  and?: InputMaybe<Array<RequestForContactFilterInput>>;
  /** Gets the identifier of the specialist assigned to contact request. */
  assignedSpecialistId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the type of contact of the request. */
  contactType?: InputMaybe<ContactTypeOperationFilterInput>;
  /** Gets the RequestForContact current status. */
  currentStatus?: InputMaybe<NullableOfContactRequestStatusOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RequestForContactFilterInput>>;
  /** Gets the phone number. */
  phone?: InputMaybe<StringOperationFilterInput>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateFilterInput>;
  /** Gets the id of the real estate this request for contact involves. */
  realEstateId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the status of the request. */
  requestStatus?: InputMaybe<RequestForContactStatusUpdateFilterInput>;
  /** Gets the date of the request. */
  requested?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the collection of RequestForContactStatusUpdate of this request for contact. */
  statusUpdates?: InputMaybe<ListFilterInputTypeOfRequestForContactStatusUpdateFilterInput>;
};

/** Extended properties for RequestForContact used for filtering. */
export type RequestForContactSortInput = {
  /** Gets the identifier of the specialist assigned to contact request. */
  assignedSpecialistId?: InputMaybe<SortEnumType>;
  /** Gets the type of contact of the request. */
  contactType?: InputMaybe<SortEnumType>;
  /** Gets the RequestForContact current status. */
  currentStatus?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the phone number. */
  phone?: InputMaybe<SortEnumType>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateSortInput>;
  /** Gets the id of the real estate this request for contact involves. */
  realEstateId?: InputMaybe<SortEnumType>;
  /** Gets the status of the request. */
  requestStatus?: InputMaybe<RequestForContactStatusUpdateSortInput>;
  /** Gets the date of the request. */
  requested?: InputMaybe<SortEnumType>;
};

/** Represent an update on the RequestForContact status. */
export type RequestForContactStatusUpdate = {
  __typename?: 'RequestForContactStatusUpdate';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the RequestForContact identifier. */
  requestForContactId: Scalars['UUID']['output'];
  /** Gets the RequestForContact status. */
  status: ContactRequestStatus;
  /** Gets the date when the status was updated. */
  updateDate: Scalars['DateTime']['output'];
};

/** Represent an update on the RequestForContact status. */
export type RequestForContactStatusUpdateFilterInput = {
  and?: InputMaybe<Array<RequestForContactStatusUpdateFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RequestForContactStatusUpdateFilterInput>>;
  /** Gets the RequestForContact identifier. */
  requestForContactId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the RequestForContact status. */
  status?: InputMaybe<ContactRequestStatusOperationFilterInput>;
  /** Gets the date when the status was updated. */
  updateDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represent an update on the RequestForContact status. */
export type RequestForContactStatusUpdateSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the RequestForContact identifier. */
  requestForContactId?: InputMaybe<SortEnumType>;
  /** Gets the RequestForContact status. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the date when the status was updated. */
  updateDate?: InputMaybe<SortEnumType>;
};

/** Extended properties for RequestForCustomOffer used for filtering. */
export type RequestForCustomOffer = {
  __typename?: 'RequestForCustomOffer';
  /** Gets the scheduled date. */
  appointmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the collection of CustomOfferRequestAppointment of this request for custom offer. */
  appointmentDates?: Maybe<Array<Maybe<CustomOfferRequestAppointment>>>;
  /** Gets the type of the appointment of the request. */
  appointmentType?: Maybe<CustomOfferAppointmentType>;
  /** Gets the offers assigned to this request. */
  assignedOffers?: Maybe<Array<Maybe<CustomOffer>>>;
  /** Gets the rooms assigned to this request. */
  assignedRooms?: Maybe<Array<Maybe<Room>>>;
  assignedSpecialist?: Maybe<AdUserDto>;
  /** Gets the identifier of the specialist assigned to custom offer request. */
  assignedSpecialistId?: Maybe<Scalars['String']['output']>;
  /** Gets the type of contact of the request. */
  contactType?: Maybe<ContactType>;
  /** Gets the RequestForCustomOffer current status. */
  currentStatus?: Maybe<CustomOfferRequestStatus>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the location where the appointment should happen. */
  location?: Maybe<ShowroomLocation>;
  /** Gets the phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Gets the real estate for this request. */
  realEstate: RealEstate;
  /** Gets the id of the real estate this request for quote involves. */
  realEstateId: Scalars['UUID']['output'];
  requestNotes?: Maybe<Array<Maybe<MessageDto>>>;
  /** Gets the status of the request. */
  requestStatus?: Maybe<RequestForCustomOfferStatusUpdate>;
  /** Gets the date of the request. */
  requested: Scalars['DateTime']['output'];
  /** Gets a value indicating whether it's passed the waiting period in the shared status. */
  sharedWaiting: Scalars['Boolean']['output'];
};


/** Extended properties for RequestForCustomOffer used for filtering. */
export type RequestForCustomOfferAppointmentDatesArgs = {
  order?: InputMaybe<Array<CustomOfferRequestAppointmentSortInput>>;
};

/** Extended properties for RequestForCustomOffer used for filtering. */
export type RequestForCustomOfferFilterInput = {
  and?: InputMaybe<Array<RequestForCustomOfferFilterInput>>;
  /** Gets the scheduled date. */
  appointmentDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets the collection of CustomOfferRequestAppointment of this request for custom offer. */
  appointmentDates?: InputMaybe<ListFilterInputTypeOfCustomOfferRequestAppointmentFilterInput>;
  /** Gets the type of the appointment of the request. */
  appointmentType?: InputMaybe<CustomOfferAppointmentTypeOperationFilterInput>;
  /** Gets the offers assigned to this request. */
  assignedOffers?: InputMaybe<ListFilterInputTypeOfCustomOfferFilterInput>;
  /** Gets the rooms assigned to this request. */
  assignedRooms?: InputMaybe<ListFilterInputTypeOfRoomFilterInput>;
  /** Gets the identifier of the specialist assigned to custom offer request. */
  assignedSpecialistId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the type of contact of the request. */
  contactType?: InputMaybe<NullableOfContactTypeOperationFilterInput>;
  /** Gets the RequestForCustomOffer current status. */
  currentStatus?: InputMaybe<NullableOfCustomOfferRequestStatusOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the location where the appointment should happen. */
  location?: InputMaybe<NullableOfShowroomLocationOperationFilterInput>;
  or?: InputMaybe<Array<RequestForCustomOfferFilterInput>>;
  /** Gets the phone number. */
  phone?: InputMaybe<StringOperationFilterInput>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateFilterInput>;
  /** Gets the id of the real estate this request for quote involves. */
  realEstateId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the status of the request. */
  requestStatus?: InputMaybe<RequestForCustomOfferStatusUpdateFilterInput>;
  /** Gets the date of the request. */
  requested?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets a value indicating whether it's passed the waiting period in the shared status. */
  sharedWaiting?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the collection of RequestForCustomOfferStatusUpdate of this request for custom offer. */
  statusUpdates?: InputMaybe<ListFilterInputTypeOfRequestForCustomOfferStatusUpdateFilterInput>;
};

/** Extended properties for RequestForCustomOffer used for filtering. */
export type RequestForCustomOfferSortInput = {
  /** Gets the scheduled date. */
  appointmentDate?: InputMaybe<SortEnumType>;
  /** Gets the type of the appointment of the request. */
  appointmentType?: InputMaybe<SortEnumType>;
  /** Gets the identifier of the specialist assigned to custom offer request. */
  assignedSpecialistId?: InputMaybe<SortEnumType>;
  /** Gets the type of contact of the request. */
  contactType?: InputMaybe<SortEnumType>;
  /** Gets the RequestForCustomOffer current status. */
  currentStatus?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the location where the appointment should happen. */
  location?: InputMaybe<SortEnumType>;
  /** Gets the phone number. */
  phone?: InputMaybe<SortEnumType>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateSortInput>;
  /** Gets the id of the real estate this request for quote involves. */
  realEstateId?: InputMaybe<SortEnumType>;
  /** Gets the status of the request. */
  requestStatus?: InputMaybe<RequestForCustomOfferStatusUpdateSortInput>;
  /** Gets the date of the request. */
  requested?: InputMaybe<SortEnumType>;
  /** Gets a value indicating whether it's passed the waiting period in the shared status. */
  sharedWaiting?: InputMaybe<SortEnumType>;
};

/** Represent an update on the RequestForCustomOffer status. */
export type RequestForCustomOfferStatusUpdate = {
  __typename?: 'RequestForCustomOfferStatusUpdate';
  /** Gets the RequestForCustomOffer status. */
  status: CustomOfferRequestStatus;
  /** Gets the date when the status was updated. */
  updateDate: Scalars['DateTime']['output'];
};

/** Represent an update on the RequestForCustomOffer status. */
export type RequestForCustomOfferStatusUpdateFilterInput = {
  and?: InputMaybe<Array<RequestForCustomOfferStatusUpdateFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RequestForCustomOfferStatusUpdateFilterInput>>;
  /** Gets the RequestForCustomOffer identifier. */
  requestForCustomOfferId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the RequestForCustomOffer status. */
  status?: InputMaybe<CustomOfferRequestStatusOperationFilterInput>;
  /** Gets the date when the status was updated. */
  updateDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represent an update on the RequestForCustomOffer status. */
export type RequestForCustomOfferStatusUpdateSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the RequestForCustomOffer identifier. */
  requestForCustomOfferId?: InputMaybe<SortEnumType>;
  /** Gets the RequestForCustomOffer status. */
  status?: InputMaybe<SortEnumType>;
  /** Gets the date when the status was updated. */
  updateDate?: InputMaybe<SortEnumType>;
};

/** Represents a request for a quotation on a selected DesignPackage (for a specific room) in a specific RealEstate. */
export type RequestForQuote = {
  __typename?: 'RequestForQuote';
  /** Gets a value indicating when this request for quote was created. */
  created: Scalars['DateTime']['output'];
  /** Gets a value indicating whether the design package selected has a bath for this request. */
  designPackageHasBath?: Maybe<Scalars['Boolean']['output']>;
  /** Gets a value indicating whether the design package selected is a fixed price for this request. */
  designPackageIsFixedPrice?: Maybe<Scalars['Boolean']['output']>;
  /** Gets a value indicating whether the design package selected is enlarged for this request. */
  designPackageIsXL?: Maybe<Scalars['Boolean']['output']>;
  /** Gets the design package name selected for this request. */
  designPackageName?: Maybe<Scalars['String']['output']>;
  /** Gets the price for the design package selected for this request. */
  designPackagePrice?: Maybe<Money>;
  /** Gets the style name for the style of the design package selected for this request. */
  designPackageStyleName?: Maybe<Scalars['String']['output']>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the real estate for this request. */
  realEstate: RealEstate;
  /** Gets the room name for this request. */
  roomName?: Maybe<Scalars['String']['output']>;
  /** Gets the quoterequested selected option like standard, shellOnly or custom */
  selectionType: SelectionType;
};

/** Contains information about a single selection for a room with additional price. */
export type RequestForQuoteAddToRoomSelectionDtoInput = {
  /** Gets or sets the custom offer identifier. */
  customOfferId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the design package identifier. */
  designPackageId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets a value indicating whether this selection is chosen. */
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gets or sets the name of the selection. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Gets or sets the room identifier. */
  roomId: Scalars['UUID']['input'];
  /** Gets or sets the type of the selection. */
  selectionType: SelectionType;
  /** Gets or sets the additional value to be paid for the selection. */
  surcharge?: InputMaybe<MoneyInput>;
};

/** Represents a request for a quotation on a selected DesignPackage (for a specific room) in a specific RealEstate. */
export type RequestForQuoteFilterInput = {
  and?: InputMaybe<Array<RequestForQuoteFilterInput>>;
  /** Gets a value indicating when this request for quote was created. */
  created?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets a value indicating whether the design package selected has a bath for this request. */
  designPackageHasBath?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the design package selected is a fixed price for this request. */
  designPackageIsFixedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets a value indicating whether the design package selected is enlarged for this request. */
  designPackageIsXL?: InputMaybe<BooleanOperationFilterInput>;
  /** Gets the design package name selected for this request. */
  designPackageName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the price for the design package selected for this request. */
  designPackagePrice?: InputMaybe<MoneyFilterInput>;
  /** Gets the style name for the style of the design package selected for this request. */
  designPackageStyleName?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RequestForQuoteFilterInput>>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateFilterInput>;
  /** Gets the id of the real estate this request for quote involves. */
  realEstateId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the room name for this request. */
  roomName?: InputMaybe<StringOperationFilterInput>;
  /** Gets the quoterequested selected option like standard, shellOnly or custom */
  selectionType?: InputMaybe<SelectionTypeOperationFilterInput>;
};

/** Contains information about a single global selection for a real estate. */
export type RequestForQuoteGlobalSelectionItemDtoInput = {
  /** Gets or sets the custom offer identifier. */
  customOfferId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the design package identifier. */
  designPackageId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the type of the selection. */
  selectionType: SelectionType;
};

/** Contains information about a single selection for a room including selected ProductSets. */
export type RequestForQuoteRoomSelectionItemDto = {
  __typename?: 'RequestForQuoteRoomSelectionItemDto';
  /** Gets or sets the design package identifier. */
  designPackageId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the room identifier. */
  roomId?: Maybe<Scalars['UUID']['output']>;
  /** Gets or sets the list of selected ProductSet Ids. */
  selectedProductSets?: Maybe<SelectedProductSets>;
};

/** Contains information about a single selection for a room including selected ProductSets. */
export type RequestForQuoteRoomSelectionItemDtoInput = {
  /** Gets or sets the custom offer identifier. */
  customOfferId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the design package identifier. */
  designPackageId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the room identifier. */
  roomId: Scalars['UUID']['input'];
  /** Gets or sets the list of selected ProductSet Ids. */
  selectedProductSets?: InputMaybe<SelectedProductSetsInput>;
  /** Gets or sets the type of the selection. */
  selectionType: SelectionType;
};

/** Contains information about a single selection for a room. */
export type RequestForQuoteUpdateFromRoomSelectionDtoInput = {
  /** Gets or sets the custom offer identifier. */
  customOfferId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the design package identifier. */
  designPackageId?: InputMaybe<Scalars['UUID']['input']>;
  /** Gets or sets the identifier for the selection to remove. */
  id: Scalars['UUID']['input'];
  /** Gets or sets the room identifier. */
  roomId: Scalars['UUID']['input'];
  /** Gets or sets the type of the selection. */
  selectionType: SelectionType;
};

/** Represents a request for a technical drawing on an order from a specific RealEstate. */
export type RequestForTechnicalDrawing = {
  __typename?: 'RequestForTechnicalDrawing';
  assignedDrawer?: Maybe<AdUserDto>;
  /** Gets the identifier of the drawer assigned to technical drawing request. */
  assignedDrawerId?: Maybe<Scalars['String']['output']>;
  /** Gets the date and time limit to finish the technical drawing. */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the real estate for this request. */
  realEstate: RealEstate;
  /** Gets the status of the request for a technical drawing request. */
  requestTechnicalDrawingStatus?: Maybe<DrawingRequestStatus>;
  /** Gets the date and time the request was issued. */
  requested: Scalars['DateTime']['output'];
};

/** Represents a request for a technical drawing on an order from a specific RealEstate. */
export type RequestForTechnicalDrawingFilterInput = {
  and?: InputMaybe<Array<RequestForTechnicalDrawingFilterInput>>;
  /** Gets the identifier of the drawer assigned to technical drawing request. */
  assignedDrawerId?: InputMaybe<StringOperationFilterInput>;
  /** Gets the date and time limit to finish the technical drawing. */
  deadline?: InputMaybe<DateTimeOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<RequestForTechnicalDrawingFilterInput>>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateFilterInput>;
  /** Gets the identifier of the real estate for this request. */
  realEstateId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the status of the request for a technical drawing request. */
  requestTechnicalDrawingStatus?: InputMaybe<DrawingRequestStatusOperationFilterInput>;
  /** Gets the date and time the request was issued. */
  requested?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Represents a request for a technical drawing on an order from a specific RealEstate. */
export type RequestForTechnicalDrawingSortInput = {
  /** Gets the identifier of the drawer assigned to technical drawing request. */
  assignedDrawerId?: InputMaybe<SortEnumType>;
  /** Gets the date and time limit to finish the technical drawing. */
  deadline?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the real estate for this request. */
  realEstate?: InputMaybe<RealEstateSortInput>;
  /** Gets the identifier of the real estate for this request. */
  realEstateId?: InputMaybe<SortEnumType>;
  /** Gets the status of the request for a technical drawing request. */
  requestTechnicalDrawingStatus?: InputMaybe<SortEnumType>;
  /** Gets the date and time the request was issued. */
  requested?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type RequestsFor3DDrawingsCollectionSegment = {
  __typename?: 'RequestsFor3DDrawingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RequestFor3DDrawing>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type RequestsForTechnicalDrawingsCollectionSegment = {
  __typename?: 'RequestsForTechnicalDrawingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RequestForTechnicalDrawing>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** Room present in one or more RealEstate in a Project. */
export type Room = {
  __typename?: 'Room';
  designPackages: Array<DesignPackage>;
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  layoutRooms: Array<LayoutRoom>;
  /** Gets the name of this Room. */
  name: Scalars['String']['output'];
  /** Gets the integer by which the Rooms should be ordered when displaying. */
  position: Scalars['Int']['output'];
};


/** Room present in one or more RealEstate in a Project. */
export type RoomDesignPackagesArgs = {
  order?: InputMaybe<Array<DesignPackageSortInput>>;
  where?: InputMaybe<DesignPackageFilterInput>;
};


/** Room present in one or more RealEstate in a Project. */
export type RoomLayoutRoomsArgs = {
  where?: InputMaybe<LayoutRoomFilterInput>;
};

/** Room present in one or more RealEstate in a Project. */
export type RoomFilterInput = {
  and?: InputMaybe<Array<RoomFilterInput>>;
  /** Gets the custom offer requests for the room. */
  customOfferRequests?: InputMaybe<ListFilterInputTypeOfRequestForCustomOfferFilterInput>;
  /** Gets the collection of DesignPackage for this Room. */
  designPackages?: InputMaybe<ListFilterInputTypeOfDesignPackageFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the collection of Layout to Room relations. */
  layoutRooms?: InputMaybe<ListFilterInputTypeOfLayoutRoomFilterInput>;
  /** Gets the name of this Room. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoomFilterInput>>;
  /** Gets the integer by which the Rooms should be ordered when displaying. */
  position?: InputMaybe<IntOperationFilterInput>;
  /** Gets the Project this Room belongs to. */
  project?: InputMaybe<ProjectFilterInput>;
  /** Gets the id of the Project this Room belongs to. */
  projectId?: InputMaybe<UuidOperationFilterInput>;
};

/** Room present in one or more RealEstate in a Project. */
export type RoomSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the name of this Room. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the integer by which the Rooms should be ordered when displaying. */
  position?: InputMaybe<SortEnumType>;
  /** Gets the Project this Room belongs to. */
  project?: InputMaybe<ProjectSortInput>;
  /** Gets the id of the Project this Room belongs to. */
  projectId?: InputMaybe<SortEnumType>;
};

/** Represents an Dictionary index on a association between ProductCategory and ProductSet for a specific DesignPackageWall if any. */
export type SelectedProductSetDictionaryKey = {
  __typename?: 'SelectedProductSetDictionaryKey';
  /** The ProductCategory identifier. */
  categoryId: Scalars['UUID']['output'];
  /** The DesignPackageWall identifier. */
  wallId?: Maybe<Scalars['UUID']['output']>;
};

export type SelectedProductSetDtoInput = {
  forCategoryId: Scalars['UUID']['input'];
  productSetId: Scalars['UUID']['input'];
  wallId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Contains information about the selected product sets. */
export type SelectedProductSets = {
  __typename?: 'SelectedProductSets';
  /** Gets or sets the list of selected ProductSet Ids. */
  productCombinationSets?: Maybe<Array<ProductCombinationSets>>;
};

/** Contains information about the selected product sets. */
export type SelectedProductSetsInput = {
  /** Gets or sets the list of selected ProductSet Ids. */
  productCombinationSets?: InputMaybe<Array<ProductCombinationSetsInput>>;
};

/** The request for quote selection options */
export enum SelectionType {
  /** Custom room option selection */
  Custom = 'CUSTOM',
  /** None room option selection */
  DesignPackage = 'DESIGN_PACKAGE',
  /** Custom quote for all rooms */
  GlobalCustom = 'GLOBAL_CUSTOM',
  /** ShellOnly room option selection */
  ShellOnly = 'SHELL_ONLY',
  /** Standard room option selection */
  Standard = 'STANDARD'
}

export type SelectionTypeOperationFilterInput = {
  eq?: InputMaybe<SelectionType>;
  in?: InputMaybe<Array<SelectionType>>;
  neq?: InputMaybe<SelectionType>;
  nin?: InputMaybe<Array<SelectionType>>;
};

/** Showroom locations. */
export enum ShowroomLocation {
  /** Bunnik. */
  Bunnik = 'BUNNIK',
  /** Drachten. */
  Drachten = 'DRACHTEN'
}

export type SiteCulture = {
  __typename?: 'SiteCulture';
  /** The culture code. */
  culture?: Maybe<Scalars['String']['output']>;
  /** Whether this is the default culture. */
  default?: Maybe<Scalars['Boolean']['output']>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** publication status */
export enum Status {
  /** all historical versions */
  All = 'ALL',
  /** draft content item version */
  Draft = 'DRAFT',
  /** the latest version, either published or draft */
  Latest = 'LATEST',
  /** published content item version */
  Published = 'PUBLISHED'
}

export type Step1 = {
  __typename?: 'Step1';
  /** Text field */
  description?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  image?: Maybe<MediaField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type Step2 = {
  __typename?: 'Step2';
  /** Text field */
  description?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  image?: Maybe<MediaField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type Step3 = {
  __typename?: 'Step3';
  /** Text field */
  description?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  image?: Maybe<MediaField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Style represents a single, unified set of design elements for decorating rooms. */
export type Style = {
  __typename?: 'Style';
  /** Gets or sets the primary key for this entity. */
  id: Scalars['UUID']['output'];
  /** Gets the name of the style. */
  name: Scalars['String']['output'];
  /** Gets the product package of the style. */
  productPackage?: Maybe<ProductPackage>;
  /** Gets the identifier of the product package of the style. */
  productPackageId?: Maybe<Scalars['UUID']['output']>;
  usedInDesignPackages: Array<DesignPackage>;
  usedInProjects: Array<ProjectStyle>;
};


/** Style represents a single, unified set of design elements for decorating rooms. */
export type StyleUsedInDesignPackagesArgs = {
  where?: InputMaybe<DesignPackageFilterInput>;
};


/** Style represents a single, unified set of design elements for decorating rooms. */
export type StyleUsedInProjectsArgs = {
  where?: InputMaybe<ProjectStyleFilterInput>;
};

/** Represents a Style Detail. */
export type StyleDetail = ContentItem & {
  __typename?: 'StyleDetail';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  teaserImage?: Maybe<MediaField>;
  /** Text field */
  teaserText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  teaserTitle?: Maybe<Scalars['String']['output']>;
};

export type StyleDetailOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the StyleDetail content item filters */
export type StyleDetailWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<StyleDetailWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<StyleDetailWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<StyleDetailWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Style represents a single, unified set of design elements for decorating rooms. */
export type StyleFilterInput = {
  and?: InputMaybe<Array<StyleFilterInput>>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the name of the style. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StyleFilterInput>>;
  /** Gets the product package of the style. */
  productPackage?: InputMaybe<ProductPackageFilterInput>;
  /** Gets the identifier of the product package of the style. */
  productPackageId?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the collection of DesignPackage objects that reference this style. */
  usedInDesignPackages?: InputMaybe<ListFilterInputTypeOfDesignPackageFilterInput>;
  /** Gets the collection of ProjectStyle objects that reference this style. */
  usedInProjects?: InputMaybe<ListFilterInputTypeOfProjectStyleFilterInput>;
};

/** Represents a Style Listing Page. */
export type StyleListingPage = ContentItem & {
  __typename?: 'StyleListingPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  goToStyle?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** HtmlField */
  pageDescription?: Maybe<HtmlField>;
  /** Text field */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
};

export type StyleListingPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the StyleListingPage content item filters */
export type StyleListingPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<StyleListingPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<StyleListingPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<StyleListingPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type StyleOverviewBlock1 = {
  __typename?: 'StyleOverviewBlock1';
  /** HtmlField */
  text?: Maybe<HtmlField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type StyleOverviewBlock2 = {
  __typename?: 'StyleOverviewBlock2';
  /** HtmlField */
  text?: Maybe<HtmlField>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a Style Page. */
export type StylePage = ContentItem & {
  __typename?: 'StylePage';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Text field */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Numeric field */
  position?: Maybe<Scalars['Decimal']['output']>;
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** ContentPickerField */
  styleDetails?: Maybe<ContentPickerField>;
  /** MediaField */
  styleOverViewBanner?: Maybe<MediaField>;
  /** MediaField */
  styleOverViewImages?: Maybe<MediaField>;
  /** Represents a StyleOverviewBlock. */
  styleOverviewBlock1?: Maybe<StyleOverviewBlock1>;
  /** Represents a StyleOverviewBlock. */
  styleOverviewBlock2?: Maybe<StyleOverviewBlock2>;
  /** Represents a StyleOverView. */
  styleoverview?: Maybe<Styleoverview>;
  /** MediaField */
  teaserImage?: Maybe<MediaField>;
  /** Text field */
  teaserSubtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  teaserTitle?: Maybe<Scalars['String']['output']>;
};

export type StylePageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the StylePage content item filters */
export type StylePageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<StylePageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<StylePageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<StylePageWhereInput>>>;
  /** the alias part of the content item */
  alias?: InputMaybe<AliasPartInput>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Style represents a single, unified set of design elements for decorating rooms. */
export type StyleSortInput = {
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the name of the style. */
  name?: InputMaybe<SortEnumType>;
  /** Gets the product package of the style. */
  productPackage?: InputMaybe<ProductPackageSortInput>;
  /** Gets the identifier of the product package of the style. */
  productPackageId?: InputMaybe<SortEnumType>;
};

export type Styleoverview = {
  __typename?: 'Styleoverview';
  /** HtmlField */
  introduction?: Maybe<HtmlField>;
};

/** Represents a Terms And Conditions Page. */
export type TermsAndConditionsPage = ContentItem & {
  __typename?: 'TermsAndConditionsPage';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** HtmlField */
  content?: Maybe<HtmlField>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type TermsAndConditionsPageOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the TermsAndConditionsPage content item filters */
export type TermsAndConditionsPageWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<TermsAndConditionsPageWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<TermsAndConditionsPageWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<TermsAndConditionsPageWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a Terms & Conditions. */
export type TermsConditions = ContentItem & {
  __typename?: 'TermsConditions';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Text field */
  checkboxLabelText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  checkboxLinkText?: Maybe<Scalars['String']['output']>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** MediaField */
  termsConditionsFile?: Maybe<MediaField>;
  /** Text field */
  warningText?: Maybe<Scalars['String']['output']>;
};

export type TermsConditionsOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the TermsConditions content item filters */
export type TermsConditionsWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<TermsConditionsWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<TermsConditionsWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<TermsConditionsWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a TestCMSFields. */
export type TestCmsFields = ContentItem & {
  __typename?: 'TestCMSFields';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Boolean field */
  booleanField?: Maybe<Scalars['Boolean']['output']>;
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** ContentPickerField */
  contentPickerField?: Maybe<ContentPickerField>;
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Date field */
  dateField?: Maybe<Scalars['Date']['output']>;
  /** Date & time field */
  dateTimeField?: Maybe<Scalars['DateTime']['output']>;
  /** DictionaryField */
  dictionaryField?: Maybe<DictionaryField>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** HtmlField */
  htmlField?: Maybe<HtmlField>;
  /** HtmlField */
  htmlFieldMonacoeditor?: Maybe<HtmlField>;
  /** HtmlField */
  htmlFieldMultiline?: Maybe<HtmlField>;
  /** HtmlField */
  htmlFieldTrumbowygeditor?: Maybe<HtmlField>;
  /** HtmlField */
  htmlFieldWysiwygeditor?: Maybe<HtmlField>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** LinkField */
  linkField?: Maybe<LinkField>;
  /** MediaField */
  mediaField?: Maybe<MediaField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Multi text field */
  multiTextField?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Numeric field */
  numericField?: Maybe<Scalars['Decimal']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textField?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldCodeMirror?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldColor?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldEmail?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldIconpicker?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldMonacoeditor?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldMultiline?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldPhone?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldPredefinedList?: Maybe<Scalars['String']['output']>;
  /** Text field */
  textFieldUrl?: Maybe<Scalars['String']['output']>;
  /** Time field */
  timeField?: Maybe<Scalars['TimeSpan']['output']>;
};

export type TestCmsFieldsOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the TestCMSFields content item filters */
export type TestCmsFieldsWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<TestCmsFieldsWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<TestCmsFieldsWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<TestCmsFieldsWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** Represents a Translation. */
export type Translation = ContentItem & {
  __typename?: 'Translation';
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Represents a TranslationAuthentication. */
  translationAuthentication?: Maybe<TranslationAuthentication>;
  /** Represents a TranslationBrand. */
  translationBrand?: Maybe<TranslationBrand>;
  /** Represents a TranslationDesignPackage. */
  translationDesignPackage?: Maybe<TranslationDesignPackage>;
  /** Represents a TranslationGlobal. */
  translationGlobal?: Maybe<TranslationGlobal>;
  /** Represents a TranslationProductProposition. */
  translationProductProposition?: Maybe<TranslationProductProposition>;
  /** Represents a TranslationStyle. */
  translationStyle?: Maybe<TranslationStyle>;
};

export type TranslationAuthentication = {
  __typename?: 'TranslationAuthentication';
  /** Text field */
  authenticationLoginButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationLoginForgotPasswordText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationLoginPasswordPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationLoginRealEstateListItemPrefix?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationLoginRealEstatesText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationLoginSubtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationLoginTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationLoginUsernamePlaceholder?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationResetPasswordConfirmMessage?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationResetPasswordEmailPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationResetPasswordInvalidEmail?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationResetPasswordSendLinkButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationResetPasswordText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationResetPasswordTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationSetPasswordConfirmPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationSetPasswordPasswordNotMatchError?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationSetPasswordPasswordRulesError?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationSetPasswordSave?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationSetPasswordText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  authenticationSetPasswordTitle?: Maybe<Scalars['String']['output']>;
};

export type TranslationBrand = {
  __typename?: 'TranslationBrand';
  /** Text field */
  backToBrands?: Maybe<Scalars['String']['output']>;
  /** Text field */
  readMore?: Maybe<Scalars['String']['output']>;
};

export type TranslationDesignPackage = {
  __typename?: 'TranslationDesignPackage';
  /** Text field */
  designPackageFrom?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackageLayoutsPageTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackagePopupChoosethisdesign?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackageSelectThisDesign?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackageStandardDesign?: Maybe<Scalars['String']['output']>;
  /** Text field */
  viewBrands?: Maybe<Scalars['String']['output']>;
  /** Text field */
  viewProductsConfig?: Maybe<Scalars['String']['output']>;
  /** Text field */
  viewStyles?: Maybe<Scalars['String']['output']>;
};

export type TranslationGlobal = {
  __typename?: 'TranslationGlobal';
  /** Text field */
  back?: Maybe<Scalars['String']['output']>;
  /** Text field */
  calculating?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalAboutUs?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCancel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalClosingDate?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalClosingDateTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalColors?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalConfirm?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContact?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactPreferenceEmail?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactPreferenceNoPreference?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactPreferencePhone?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactPreferenceTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactRequestButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactRequestPrivacyStatement?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactRequestPrivacyStatementTriggerText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactRequestSend?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactRequestSubtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalContactRequestTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCookies?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesCoordinationCommission?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesCoordinationCommissionTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesCustomOffer?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesCustomOfferTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesDrawings?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesDrawingsTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesInstallationConstruction?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesInstallationConstructionTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesLowerPriceStandardProducts?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesLowerPriceStandardProductsTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesProductsAndInstallationMaterials?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesProductsAndInstallationMaterialsTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesTilesAndFasteners?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesTilesAndFastenersPackagingUnitsDisclaimer?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesTilesAndFastenersTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesTotalSurcharge?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesVAT?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalCostTypesVATTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalDesigns?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalDetails?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalDownloadPDF?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalExperienceCentres?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalFAQ?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalFiltersAppliedFiltersText?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalFiltersOpenFiltersButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalFiltersResetFiltersButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalIncludingVAT?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalLandingUnauthenticatedTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalLogout?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalMoreInfo?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalMySelection?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalPhotoZoomLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalPrice?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalPrivacyPolicy?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalRequestSentPopupDescription?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalRequestSentPopupTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalRequiredFieldLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalRequiredFieldsLabel?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalStandard?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalTermsAndConditions?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalView?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalViewDesign?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalViewDesigns?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalWarning?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalWarningUnavailableProductsTooltip?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalWithBath?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalWithToilet?: Maybe<Scalars['String']['output']>;
  /** Text field */
  globalXL?: Maybe<Scalars['String']['output']>;
};

export type TranslationLayout = {
  __typename?: 'TranslationLayout';
  /** Text field */
  layoutWithBath?: Maybe<Scalars['String']['output']>;
  /** Text field */
  layoutWithBathXLVariant?: Maybe<Scalars['String']['output']>;
  /** Text field */
  layoutWithToilet?: Maybe<Scalars['String']['output']>;
  /** Text field */
  layoutWithToiletBath?: Maybe<Scalars['String']['output']>;
  /** Text field */
  layoutWithToiletBathXLVariant?: Maybe<Scalars['String']['output']>;
  /** Text field */
  layoutWithToiletXLVariant?: Maybe<Scalars['String']['output']>;
  /** Text field */
  layoutWithXLVariant?: Maybe<Scalars['String']['output']>;
};

export type TranslationOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

export type TranslationProductProposition = {
  __typename?: 'TranslationProductProposition';
  /** Text field */
  brandLineSelectedButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  brandLineUnselectedButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  changeSelection?: Maybe<Scalars['String']['output']>;
  /** Text field */
  defaultProductSetBadge?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackageConfigOverviewButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackageConfigOverviewPageSelectedProductSetsOverviewTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackageConfigPrice?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackageConfigPriceDescription?: Maybe<Scalars['String']['output']>;
  /** Text field */
  designPackageConfigSubtitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  favouriteProductSetBadge?: Maybe<Scalars['String']['output']>;
  /** Text field */
  nextButtonCombination?: Maybe<Scalars['String']['output']>;
  /** Text field */
  nextButtonOverview?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderDepthHighToLow?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderDepthLowToHigh?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderHeightHighToLow?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderHeightLowToHigh?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderLengthHighToLow?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderLengthLowToHigh?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderPriceHighToLow?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderPriceLowToHigh?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderRelevance?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderWidthHighToLow?: Maybe<Scalars['String']['output']>;
  /** Text field */
  orderWidthLowToHigh?: Maybe<Scalars['String']['output']>;
  /** Text field */
  overviewAddToSelection?: Maybe<Scalars['String']['output']>;
  /** Text field */
  overviewAllConfigurationsLink?: Maybe<Scalars['String']['output']>;
  /** Text field */
  overviewCostsTitle?: Maybe<Scalars['String']['output']>;
  /** Text field */
  overviewStandardSelection?: Maybe<Scalars['String']['output']>;
  /** Text field */
  overviewUnsavedSelection?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productPropositionOverviewChooseYour?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productPropositionOverviewIncompleteCombination?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productPropositionOverviewNoSelectionYet?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productPropositionOverviewUnavailableProductSet?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productSetNextButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productSetPreviousButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productSetSelectedButton?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productSetSelectedButtonHover?: Maybe<Scalars['String']['output']>;
  /** Text field */
  productSetUnselectedButton?: Maybe<Scalars['String']['output']>;
};

export type TranslationStyle = {
  __typename?: 'TranslationStyle';
  /** Text field */
  backToStyles?: Maybe<Scalars['String']['output']>;
};

/** the Translation content item filters */
export type TranslationWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<TranslationWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<TranslationWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<TranslationWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type TupleOfCostTypeAndStringInput = {
  item1: CostType;
  item2: Scalars['String']['input'];
};

export type TupleOfGuidAndNullableOfBooleanInput = {
  item1: Scalars['UUID']['input'];
  item2?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TupleOfGuidAndPriceVariantInput = {
  item1: Scalars['UUID']['input'];
  item2: PriceVariant;
};

export type TupleOfGuidAndStringInput = {
  item1: Scalars['UUID']['input'];
  item2: Scalars['String']['input'];
};

export type TupleOfStringAndBooleanInput = {
  item1: Scalars['String']['input'];
  item2: Scalars['Boolean']['input'];
};

export type TupleOfStringAndUploadFileTypeInput = {
  item1: Scalars['String']['input'];
  item2: UploadFileType;
};

export enum UploadFileType {
  CustomOffer = 'CUSTOM_OFFER',
  Drawing3D = 'DRAWING3_D',
  Manual = 'MANUAL',
  TechnicalDrawing = 'TECHNICAL_DRAWING'
}

/** Represents a single User that is a future owner of the RealEstate. */
export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  /** Gets the email address of the user. */
  email?: InputMaybe<StringOperationFilterInput>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Gets the date and time this user logged in. */
  lastLogin?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  /** Gets the RealEstateContact this is a user for. */
  realEstateContacts?: InputMaybe<ListFilterInputTypeOfRealEstateContactFilterInput>;
};

/** User Login information. */
export type UserLoginDto = {
  __typename?: 'UserLoginDto';
  /** Gets or sets the user access token. */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Gets or sets the user available real estates. */
  availableRealEstates?: Maybe<Array<UserLoginRealEstateDto>>;
};

/** Real estate information. */
export type UserLoginRealEstateDto = {
  __typename?: 'UserLoginRealEstateDto';
  /** Gets or sets real estate contact access token. */
  accessId: Scalars['UUID']['output'];
  /** Gets or sets real estate building number. */
  buildingNumber?: Maybe<Scalars['String']['output']>;
  /** Gets or sets real estate identifier. */
  realEstateId: Scalars['UUID']['output'];
  /** Gets or sets the real estate number. */
  realEstateNumber: Scalars['String']['output'];
};

/** Represents a single User that is a future owner of the RealEstate. */
export type UserSortInput = {
  /** Gets the email address of the user. */
  email?: InputMaybe<SortEnumType>;
  /** Gets or sets the primary key for this entity. */
  id?: InputMaybe<SortEnumType>;
  /** Gets the date and time this user logged in. */
  lastLogin?: InputMaybe<SortEnumType>;
};

/** Represents a Usercentrics Consent Overlay. */
export type UsercentricsConsentOverlay = ContentItem & {
  __typename?: 'UsercentricsConsentOverlay';
  /** Text field */
  accept?: Maybe<Scalars['String']['output']>;
  /** The author of the content item */
  author: Scalars['String']['output'];
  /** Content item id */
  contentItemId: Scalars['String']['output'];
  /** The content item version id */
  contentItemVersionId: Scalars['String']['output'];
  /** Type of content */
  contentType: Scalars['String']['output'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  description?: Maybe<Scalars['String']['output']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']['output']>;
  /** Is the latest version */
  latest: Scalars['Boolean']['output'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Text field */
  moreInformation?: Maybe<Scalars['String']['output']>;
  /** The owner of the content item */
  owner: Scalars['String']['output'];
  /** Is the published version */
  published: Scalars['Boolean']['output'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']['output']>;
  render?: Maybe<Scalars['String']['output']>;
  /** Text field */
  title?: Maybe<Scalars['String']['output']>;
};

export type UsercentricsConsentOverlayOrderByInput = {
  author?: InputMaybe<OrderByDirection>;
  contentItemId?: InputMaybe<OrderByDirection>;
  contentItemVersionId?: InputMaybe<OrderByDirection>;
  contentType?: InputMaybe<OrderByDirection>;
  createdUtc?: InputMaybe<OrderByDirection>;
  displayText?: InputMaybe<OrderByDirection>;
  latest?: InputMaybe<OrderByDirection>;
  modifiedUtc?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  published?: InputMaybe<OrderByDirection>;
  publishedUtc?: InputMaybe<OrderByDirection>;
};

/** the UsercentricsConsentOverlay content item filters */
export type UsercentricsConsentOverlayWhereInput = {
  /** AND logical operation */
  AND?: InputMaybe<Array<InputMaybe<UsercentricsConsentOverlayWhereInput>>>;
  /** NOT logical operation */
  NOT?: InputMaybe<Array<InputMaybe<UsercentricsConsentOverlayWhereInput>>>;
  /** OR logical operation */
  OR?: InputMaybe<Array<InputMaybe<UsercentricsConsentOverlayWhereInput>>>;
  /** the author of the content item is equal to */
  author?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item contains the string */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item ends with the string */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is in collection */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item is not equal to */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item is not in collection */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the author of the content item starts with the string */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** content item id is equal to */
  contentItemId?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is in collection */
  contentItemId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** content item id is not equal to */
  contentItemId_not?: InputMaybe<Scalars['ID']['input']>;
  /** content item id is not in collection */
  contentItemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: InputMaybe<Scalars['ID']['input']>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** the date and time of creation is equal to */
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of creation is less than */
  createdUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the display text of the content item is equal to */
  displayText?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item contains the string */
  displayText_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is in collection */
  displayText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item is not equal to */
  displayText_not?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the localization part of the content item */
  localization?: InputMaybe<LocalizationInputObjectType>;
  /** the date and time of modification is equal to */
  modifiedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the owner of the content item is equal to */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item contains the string */
  owner_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is in collection */
  owner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item is not equal to */
  owner_not?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item is not in collection */
  owner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** the date and time of publication is equal to */
  publishedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The group of users that should be included. */
export enum UsersGroupFilterType {
  /** All users. No Restrictions. */
  AllRensa = 'ALL_RENSA',
  /** User that do designs and drawings. */
  Draftsman = 'DRAFTSMAN',
  /** All users from the Showroom department. */
  Showroom = 'SHOWROOM',
  /** Users that are DeBadkamer specialists. */
  Specialists = 'SPECIALISTS'
}

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

/** The valid types for a project */
export enum Badkamercore_ProjectType {
  /** Style based project */
  DeBadkamerwerelden = 'DE_BADKAMERWERELDEN',
  /**
   * Master product package with defaults only.
   * @deprecated Remove after Master product package creation
   */
  MasterWithDefault = 'MASTER_WITH_DEFAULT',
  /** Brand based project */
  Merkenpropositie = 'MERKENPROPOSITIE',
  /** Product packaged based project */
  Productenpropositie = 'PRODUCTENPROPOSITIE'
}
